var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHrmsLogin2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-49",
    d: "M347.78,370c-28.58,16.77-28.38,43.64.43,60s75.34,16,103.92-.74,28.39-43.64-.43-60S376.36,353.23,347.78,370Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-49",
    d: "M198.86,298.6l-48.11-27.29a1.06,1.06,0,0,1,0-2l46.72-27.4a3.85,3.85,0,0,1,3.48,0L249,269.17a1.06,1.06,0,0,1,0,2l-46.72,27.39A3.88,3.88,0,0,1,198.86,298.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.23,299.5l-90.66,52.41a1.33,1.33,0,0,1-1.2,0l-91.28-52.72a.36.36,0,0,1,0-.69l90.66-52.41a1.33,1.33,0,0,1,1.2,0l91.28,52.72A.36.36,0,0,1,348.23,299.5Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-49",
    d: "M116.9,428.94l-49-27.79a1.08,1.08,0,0,1,0-2l67.42-39.5a3.93,3.93,0,0,1,3.55,0l49,27.79a1.08,1.08,0,0,1,0,2.05l-67.42,39.49A3.9,3.9,0,0,1,116.9,428.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-49",
    d: "M134.07,397.21c-14.82,8.69-14.72,22.62.22,31.11s39.07,8.31,53.89-.39,14.72-22.62-.23-31.11S148.89,388.51,134.07,397.21Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-49",
    d: "M48.22,409.75c-13.52,7.8-13.52,20.45,0,28.26s35.43,7.8,49,0,13.51-20.46,0-28.26S61.74,401.94,48.22,409.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-49",
    d: "M440.89,311.39l32.81-18.91a.84.84,0,0,0,0-1.59l-81.07-47a3.07,3.07,0,0,0-2.77,0l-32.8,18.9a.85.85,0,0,0,0,1.6l81.07,47A3.05,3.05,0,0,0,440.89,311.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-49",
    d: "M103.13,241c-6.89,4-6.89,10.42,0,14.4s18,4,24.93,0,6.88-10.42,0-14.4S110,237,103.13,241Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-49",
    d: "M26.27,287.71c-6.16,3.56-6.16,9.32,0,12.87s16.14,3.56,22.29,0,6.16-9.31,0-12.87S32.42,284.16,26.27,287.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-49",
    d: "M306.85,281.71,355,254.42a1.06,1.06,0,0,0,0-2L308.26,225a3.87,3.87,0,0,0-3.49,0l-48.11,27.29a1.06,1.06,0,0,0,0,2l46.72,27.39A3.81,3.81,0,0,0,306.85,281.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-49",
    d: "M246.48,162.36c-5.82,3.66-5.82,9.59,0,13.26s15.28,3.66,21.11,0,5.83-9.6,0-13.26S252.31,158.7,246.48,162.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-49",
    d: "M225.11,422.17c-19.11,11-19.11,28.93,0,40s50.1,11,69.21,0,19.11-28.92,0-40S244.22,411.14,225.11,422.17Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Walls--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--walls--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.37,290.7a.5.5,0,0,1-.25-.93L255.84,149.06a.5.5,0,0,1,.5,0L487.88,282.73a.51.51,0,0,1,.18.69.49.49,0,0,1-.68.18L256.09,150.07,12.62,290.64A.54.54,0,0,1,12.37,290.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.09,150a.5.5,0,0,1-.5-.5V11.79a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v137.7A.5.5,0,0,1,256.09,150Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shelves--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shelves--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shelf--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "186.44 98.22 168.6 87.92 121.61 115.02 121.61 116.98 139.45 127.28 186.44 100.18 186.44 98.22",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.45 125.32 186.44 98.22 168.6 87.92 121.61 115.02 139.45 125.32",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.45 125.32 139.45 127.28 121.61 116.98 121.61 115.02 139.45 125.32",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.97 70.94 184.43 76.98 184.43 96.9 173.97 90.85 173.97 70.94",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.1,77.32,174,71.5a4.25,4.25,0,0,1-2.31,1.27l10,5.79A10.12,10.12,0,0,0,184.1,77.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.72,78.52a2.16,2.16,0,0,0,1.95,0l1.7-1c.54-.31.54-.81,0-1.11l-10-5.73-.43.24,9.83,5.67c.32.18.32.48,0,.67l-1.58.9a1.33,1.33,0,0,1-1.17,0l-9.82-5.66-.47.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.74,72.79V92.71l10,5.73a2.23,2.23,0,0,0,1.95,0l1.7-1a.7.7,0,0,0,.41-.56V77a.67.67,0,0,1-.41.56l-1.7,1a2.16,2.16,0,0,1-1.95,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.69,78.75a2,2,0,0,0,1-.23l1.7-1a.67.67,0,0,0,.41-.56V96.9a.7.7,0,0,1-.41.56l-1.7,1a2.06,2.06,0,0,1-1,.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.57 73.95 180.04 80 176.79 100.52 166.32 94.47 169.57 73.95",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.63,80.29l-10.14-5.82a5.57,5.57,0,0,1-2.69,1l10,5.79A13.59,13.59,0,0,0,179.63,80.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.79,81.23a2.7,2.7,0,0,0,2.11.09l2-.81c.62-.26.7-.72.16-1l-10-5.74-.49.2,9.82,5.67c.32.19.27.46-.1.62l-1.85.74a1.64,1.64,0,0,1-1.27,0l-9.82-5.66-.56.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.8,75.49,162.55,96l10,5.73a2.7,2.7,0,0,0,2.11.1l2-.81c.31-.13.48-.31.51-.5L180.41,80c0,.18-.2.36-.51.49l-2,.81a2.7,2.7,0,0,1-2.11-.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.82,81.49a2.53,2.53,0,0,0,1.08-.17l2-.81c.31-.13.49-.31.51-.49l-3.25,20.51c0,.19-.2.37-.51.5l-2,.81a2.55,2.55,0,0,1-1.09.16Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-49",
    d: "M165.76,100.18c2.46,1.42,2.46,3.73,0,5.15a9.87,9.87,0,0,1-8.92,0c-2.47-1.42-2.47-3.73,0-5.15A9.87,9.87,0,0,1,165.76,100.18Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.29,103.77c-2.15-2.19-3.41-7.65-1.32-9.39h10.65c2.09,1.73.83,7.2-1.31,9.39l-.06.06-.08.07a1.54,1.54,0,0,1-.19.17l0,0-.16.12a2.2,2.2,0,0,1-.28.18,7.05,7.05,0,0,1-6.39,0h0a2.2,2.2,0,0,1-.28-.18l-.15-.11-.06-.05a1.54,1.54,0,0,1-.19-.17l-.09-.08Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.69,93.55c2.43,1.4,2.43,3.67,0,5.07a9.66,9.66,0,0,1-8.79,0c-2.43-1.4-2.43-3.67,0-5.07A9.66,9.66,0,0,1,165.69,93.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,94.54c1.48.85,1.48,2.24,0,3.09a5.93,5.93,0,0,1-5.35,0c-1.48-.85-1.48-2.24,0-3.09A5.93,5.93,0,0,1,164,94.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.62,96A5.87,5.87,0,0,1,164,96a2.44,2.44,0,0,1,.89.81,2.63,2.63,0,0,1-.89.81,5.93,5.93,0,0,1-5.35,0,2.63,2.63,0,0,1-.89-.81A2.44,2.44,0,0,1,158.62,96Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.65,96.82a12,12,0,0,0,1.93-2.57c.89-1.58,1.06-3.7.6-4s-2.35,1.85-2.35,1.85a11.33,11.33,0,0,0,.2-2.7c-.08-1.41-.42-2.69-.82-3S161.9,88,161.52,89.3s-.62,2.34-.62,2.34a20.18,20.18,0,0,0-.7-3c-.47-1.33-.89-1.64-1.22-1.5s-.55.75-.64,2.53a18,18,0,0,0,.07,2.55s-.66-.73-1.39-1.44-1.16-.88-1.39-.73-.3,1.35,1,3.62A12.49,12.49,0,0,0,159,96.82S160.68,97.94,163.65,96.82Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "144.69 86.05 155.16 92.09 155.16 112.01 144.69 105.96 144.69 86.05",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.82,92.42l-10.13-5.81a4.38,4.38,0,0,1-2.32,1.27l10,5.78A10.24,10.24,0,0,0,154.82,92.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.44,93.63a2.16,2.16,0,0,0,1.95,0l1.7-1a.59.59,0,0,0,0-1.12l-10-5.73-.42.24,9.82,5.68c.32.18.32.48,0,.67l-1.59.9a1.33,1.33,0,0,1-1.17,0l-9.81-5.67-.48.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,87.9v19.91l10,5.73a2.16,2.16,0,0,0,1.95,0l1.7-1a.7.7,0,0,0,.41-.56V92.09a.69.69,0,0,1-.41.56l-1.7,1a2.16,2.16,0,0,1-1.95,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.42,93.86a1.93,1.93,0,0,0,1-.23l1.7-1a.69.69,0,0,0,.41-.56V112a.7.7,0,0,1-.41.56l-1.7,1a1.94,1.94,0,0,1-1,.24Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.41 88.5 150.87 94.55 150.87 114.47 140.41 108.42 140.41 88.5",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.54,94.88l-10.13-5.81a4.3,4.3,0,0,1-2.32,1.26l10,5.79A10.12,10.12,0,0,0,150.54,94.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,96.09a2.16,2.16,0,0,0,2,0l1.7-1a.59.59,0,0,0,0-1.12l-10-5.73-.42.24,9.82,5.67c.32.19.32.49,0,.67l-1.59.9a1.27,1.27,0,0,1-1.17,0l-9.82-5.66-.47.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.18,90.36v19.91l10,5.73a2.16,2.16,0,0,0,2,0l1.7-1a.67.67,0,0,0,.41-.56V94.55a.7.7,0,0,1-.41.56l-1.7,1a2.16,2.16,0,0,1-2,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.13,96.32a2.06,2.06,0,0,0,1-.23l1.7-1a.7.7,0,0,0,.41-.56v19.91a.67.67,0,0,1-.41.56l-1.7,1a2,2,0,0,1-1,.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.18 92.73 146.65 98.77 143.39 119.29 132.93 113.25 136.18 92.73",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.23,99.06,136.1,93.24a5.55,5.55,0,0,1-2.7,1.05l10,5.79A13.7,13.7,0,0,0,146.23,99.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.4,100a2.74,2.74,0,0,0,2.11.1l2-.82c.63-.25.7-.71.16-1l-10-5.73-.49.2L146,98.4c.32.18.28.46-.1.61l-1.85.75a1.64,1.64,0,0,1-1.27-.06L133,94l-.56.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.41,94.27l-3.25,20.52,10,5.73a2.72,2.72,0,0,0,2.12.09l2-.81c.31-.13.49-.31.52-.49L147,98.79c0,.19-.21.36-.52.49l-2,.82a2.74,2.74,0,0,1-2.11-.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.42,100.26a2.6,2.6,0,0,0,1.09-.16l2-.82c.31-.13.49-.3.52-.49l-3.25,20.52c0,.18-.21.36-.52.49l-2,.81a2.77,2.77,0,0,1-1.09.17Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shelf--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "186.44 59.57 168.6 49.27 121.61 76.37 121.61 78.33 139.45 88.63 186.44 61.53 186.44 59.57",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.45 86.67 186.44 59.57 168.6 49.27 121.61 76.37 139.45 86.67",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.45 86.67 139.45 88.63 121.61 78.33 121.61 76.37 139.45 86.67",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.34 30.39 182.91 37.08 182.91 59.09 171.34 52.41 171.34 30.39",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.54,37.44,171.34,31a4.71,4.71,0,0,1-2.56,1.4l11.1,6.4A11.24,11.24,0,0,0,182.54,37.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.81,38.78a2.39,2.39,0,0,0,2.15,0l1.88-1.08a.65.65,0,0,0,0-1.24l-11-6.33-.47.27,10.85,6.26c.36.21.36.54,0,.74l-1.75,1a1.46,1.46,0,0,1-1.29,0L168.3,32.14l-.53.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.77,32.44v22l11,6.33a2.39,2.39,0,0,0,2.15,0l1.88-1.08a.76.76,0,0,0,.45-.62v-22a.76.76,0,0,1-.45.62L181,38.78a2.39,2.39,0,0,1-2.15,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.88,39a2.24,2.24,0,0,0,1.08-.26l1.88-1.08a.76.76,0,0,0,.45-.62v22a.76.76,0,0,1-.45.62L181,60.79a2.24,2.24,0,0,1-1.08.26Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.85 34.22 178.41 40.9 174.82 63.58 163.25 56.9 166.85 34.22",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,41.22l-11.21-6.43a6.12,6.12,0,0,1-3,1.16l11.11,6.4A15,15,0,0,0,178,41.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.72,42.26a3,3,0,0,0,2.33.1l2.2-.9c.7-.28.78-.79.18-1.13l-11-6.33-.54.22,10.85,6.27c.36.2.31.51-.11.68l-2,.82a1.82,1.82,0,0,1-1.4-.06l-10.86-6.26-.61.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.68,35.92l-3.6,22.68,11,6.34a3,3,0,0,0,2.34.1l2.2-.9c.35-.14.54-.34.57-.54l3.6-22.68c0,.21-.23.4-.58.54l-2.2.9a3,3,0,0,1-2.33-.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.85,42.55a2.78,2.78,0,0,0,1.2-.19l2.2-.9c.35-.14.54-.33.58-.54l-3.6,22.68c0,.2-.22.4-.57.54l-2.2.9a3,3,0,0,1-1.21.18Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "147.62 75.41 148.44 75.81 163.62 67.04 162.8 66.65 147.62 75.41",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.8 66.65 148.36 74.98 146.26 53.38 160.7 45.05 162.8 66.65",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.69,42.29l-18,10.37,2.48,25.48,18-10.38ZM163.62,67l-15.18,8.77-2.18-22.43,15.18-8.76Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.62 67.04 162.8 66.65 160.7 45.05 161.44 44.62 163.62 67.04",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.69 42.29 161.86 41.9 143.88 52.28 144.71 52.66 162.69 42.29",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.88 52.28 144.71 52.66 147.19 78.14 146.36 77.75 143.88 52.28",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Land--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "162.16 66.24 148.85 73.92 148.5 70.28 150.97 59.59 153.33 63.24 152.84 66.32 156.78 54.97 161.81 62.6 162.16 66.24",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.77,55.09a1.89,1.89,0,0,0-.88,1.65.66.66,0,0,0,1.09.51,1.89,1.89,0,0,0,.88-1.65A.66.66,0,0,0,150.77,55.09Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-49",
    d: "M140.14,73.91c2.46,1.43,2.46,3.73,0,5.15a9.87,9.87,0,0,1-8.92,0c-2.46-1.42-2.46-3.72,0-5.15A9.87,9.87,0,0,1,140.14,73.91Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.67,77.5c-2.14-2.19-3.4-7.65-1.31-9.39H141c2.1,1.74.84,7.2-1.31,9.39l-.06.06a.46.46,0,0,1-.07.07,1.54,1.54,0,0,1-.19.17l-.05,0-.17.13-.27.17a7.05,7.05,0,0,1-6.39,0h0a1.67,1.67,0,0,1-.28-.18.83.83,0,0,1-.15-.11l-.07,0a1.45,1.45,0,0,1-.18-.17l-.09-.08Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.08,67.28c2.43,1.4,2.43,3.67,0,5.08a9.74,9.74,0,0,1-8.8,0c-2.43-1.41-2.43-3.68,0-5.08A9.74,9.74,0,0,1,140.08,67.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.36,68.27c1.47.86,1.47,2.24,0,3.09a5.93,5.93,0,0,1-5.35,0c-1.48-.85-1.48-2.23,0-3.09A5.93,5.93,0,0,1,138.36,68.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,69.74a5.93,5.93,0,0,1,5.35,0,2.41,2.41,0,0,1,.88.81,2.41,2.41,0,0,1-.88.81,5.93,5.93,0,0,1-5.35,0,2.45,2.45,0,0,1-.89-.81A2.45,2.45,0,0,1,133,69.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,70.55A12.25,12.25,0,0,0,140,68c.89-1.58,1.06-3.7.59-4s-2.34,1.85-2.34,1.85a11.33,11.33,0,0,0,.2-2.7c-.08-1.41-.42-2.69-.83-2.94s-1.3,1.51-1.69,2.8-.62,2.34-.62,2.34a19.84,19.84,0,0,0-.69-3c-.47-1.33-.89-1.63-1.22-1.5s-.55.75-.65,2.53A17.23,17.23,0,0,0,132.8,66s-.66-.73-1.4-1.44-1.15-.88-1.38-.73-.3,1.35.95,3.62a12.65,12.65,0,0,0,2.37,3.11S135.07,71.67,138,70.55Z",
    style: {
      fill: "#ebebeb"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shelves--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shelf--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "281.12 91.64 300.51 80.44 350.19 109.14 350.19 111.27 330.8 122.47 281.12 93.77 281.12 91.64",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.8 120.34 281.12 91.64 300.51 80.44 350.19 109.14 330.8 120.34",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.8 120.34 330.8 122.47 350.19 111.27 350.19 109.14 330.8 120.34",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.82 63.08 286.44 69.66 286.44 91.3 297.82 84.73 297.82 63.08",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.81,70l11-6.31a4.65,4.65,0,0,0,2.52,1.37l-10.92,6.29A10.85,10.85,0,0,1,286.81,70Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.48,71.33a2.39,2.39,0,0,1-2.12,0l-1.85-1.07a.63.63,0,0,1,0-1.21l10.85-6.23.46.26-10.67,6.17c-.35.2-.35.52,0,.73l1.72,1a1.42,1.42,0,0,0,1.27,0l10.67-6.15.52.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.33,65.1V86.74L290.48,93a2.33,2.33,0,0,1-2.12,0l-1.85-1.06a.75.75,0,0,1-.44-.61V69.65a.74.74,0,0,0,.44.61l1.85,1.07a2.39,2.39,0,0,0,2.12,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.42,71.58a2.18,2.18,0,0,1-1.06-.25l-1.85-1.07a.74.74,0,0,1-.44-.61V91.3a.75.75,0,0,0,.44.61L288.36,93a2.18,2.18,0,0,0,1.06.25Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.47 65.75 291.1 72.33 291.1 93.97 302.47 87.4 302.47 65.75",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.46,72.69l11-6.32A4.65,4.65,0,0,0,305,67.74L294.07,74A11.43,11.43,0,0,1,291.46,72.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.13,74A2.37,2.37,0,0,1,293,74l-1.86-1.07a.64.64,0,0,1,0-1.21L302,65.49l.46.26L291.8,71.92a.39.39,0,0,0,0,.73l1.72,1a1.42,1.42,0,0,0,1.27,0l10.67-6.15.52.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,67.77V89.41l-10.85,6.23a2.31,2.31,0,0,1-2.11,0l-1.86-1.06a.75.75,0,0,1-.44-.61V72.33a.73.73,0,0,0,.44.6L293,74a2.37,2.37,0,0,0,2.11,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.07,74.25A2.12,2.12,0,0,1,293,74l-1.86-1.07a.73.73,0,0,1-.44-.6V94a.75.75,0,0,0,.44.61L293,95.64a2.12,2.12,0,0,0,1.05.25Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.24 71.51 298.87 78.08 302.4 100.38 313.78 93.81 310.24 71.51",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.32,78.39l11-6.32a6.09,6.09,0,0,0,2.93,1.14L302.34,79.5A14.69,14.69,0,0,1,299.32,78.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.49,79.41a3,3,0,0,1-2.3.11L299,78.63c-.69-.28-.77-.78-.18-1.11l10.86-6.23.53.22-10.67,6.16c-.35.2-.3.5.11.67l2,.81a1.75,1.75,0,0,0,1.37-.06l10.67-6.16.61.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.34,73.18l3.54,22.3L307,101.71a3,3,0,0,1-2.3.1l-2.16-.88c-.34-.14-.53-.33-.56-.53l-3.54-22.3c0,.2.23.39.56.53l2.17.89a3,3,0,0,0,2.3-.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.37,79.7a3,3,0,0,1-1.18-.18L299,78.63c-.33-.14-.53-.33-.56-.53L302,100.4c0,.2.22.39.56.53l2.16.88a2.89,2.89,0,0,0,1.19.18Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.56 77.39 310.19 83.96 310.19 105.61 321.56 99.03 321.56 77.39",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.55,84.32l11-6.32a4.66,4.66,0,0,0,2.52,1.38l-10.92,6.29A10.85,10.85,0,0,1,310.55,84.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.22,85.63a2.31,2.31,0,0,1-2.11,0l-1.86-1.06a.65.65,0,0,1,0-1.22l10.85-6.22.46.26-10.67,6.16a.39.39,0,0,0,0,.73l1.72,1a1.42,1.42,0,0,0,1.27,0l10.67-6.15.52.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.07,79.4v21.65l-10.85,6.23a2.37,2.37,0,0,1-2.11,0l-1.86-1.07a.73.73,0,0,1-.44-.6V84a.75.75,0,0,0,.44.61l1.86,1.06a2.31,2.31,0,0,0,2.11,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.16,85.89a2.12,2.12,0,0,1-1.05-.26l-1.86-1.06a.75.75,0,0,1-.44-.61v21.65a.73.73,0,0,0,.44.6l1.86,1.07a2.23,2.23,0,0,0,1.05.25Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.22 80.06 314.84 86.63 314.84 108.28 326.22 101.71 326.22 80.06",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.2,87l11-6.32a4.53,4.53,0,0,0,2.51,1.38l-10.91,6.29A10.74,10.74,0,0,1,315.2,87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.87,88.3a2.31,2.31,0,0,1-2.11,0l-1.86-1.06c-.58-.34-.58-.88,0-1.21l10.86-6.23.46.26-10.68,6.16c-.35.21-.35.53,0,.73l1.73,1a1.42,1.42,0,0,0,1.27,0l10.67-6.15.52.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.73,82.08v21.64L318.87,110a2.37,2.37,0,0,1-2.11,0l-1.86-1.07a.71.71,0,0,1-.43-.6V86.63a.74.74,0,0,0,.43.61l1.86,1.06a2.31,2.31,0,0,0,2.11,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.82,88.56a2.13,2.13,0,0,1-1.06-.26l-1.86-1.06a.74.74,0,0,1-.43-.61v21.65a.71.71,0,0,0,.43.6l1.86,1.07a2.13,2.13,0,0,0,1.06.25Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.99 85.81 322.61 92.39 326.14 114.68 337.52 108.11 333.99 85.81",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.06,92.7l11-6.33A6,6,0,0,0,337,87.51L326.09,93.8A14.17,14.17,0,0,1,323.06,92.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.23,93.72a3,3,0,0,1-2.3.1l-2.16-.88c-.68-.28-.76-.78-.18-1.11l10.86-6.24.54.22L323.31,92c-.35.2-.3.5.11.66l2,.81a1.78,1.78,0,0,0,1.38-.06l10.67-6.15.6.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.08,87.49l3.54,22.3L330.76,116a3,3,0,0,1-2.29.1l-2.17-.88c-.34-.14-.53-.34-.56-.54L322.2,92.4a.85.85,0,0,0,.57.54l2.16.88a3,3,0,0,0,2.3-.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.12,94a2.87,2.87,0,0,1-1.19-.18l-2.16-.88a.85.85,0,0,1-.57-.54l3.54,22.3c0,.2.22.4.56.54l2.17.88a2.82,2.82,0,0,0,1.18.18Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shelf--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "273.76 49.17 292 38.63 350.19 72.22 350.19 74.22 331.95 84.75 273.76 51.17 273.76 49.17",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.95 82.75 273.76 49.17 292 38.63 350.19 72.22 331.95 82.75",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.95 82.75 331.95 84.75 350.19 74.22 350.19 72.22 331.95 82.75",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.03 20.36 279.2 27.2 279.2 49.7 291.03 42.87 291.03 20.36",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.58,27.57,291,21a4.78,4.78,0,0,0,2.62,1.43L282.3,29A11.77,11.77,0,0,1,279.58,27.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.4,28.94a2.5,2.5,0,0,1-2.2,0l-1.93-1.11a.66.66,0,0,1,0-1.26l11.28-6.48.48.27-11.1,6.41a.4.4,0,0,0,0,.76l1.79,1a1.48,1.48,0,0,0,1.33,0l11.09-6.4.54.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.68,22.46V45L283.4,51.44a2.44,2.44,0,0,1-2.2,0l-1.93-1.11a.77.77,0,0,1-.46-.63V27.2a.79.79,0,0,0,.46.63l1.93,1.11a2.44,2.44,0,0,0,2.2,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.3,29.2a2.29,2.29,0,0,1-1.1-.26l-1.93-1.11a.79.79,0,0,1-.46-.63V49.7a.77.77,0,0,0,.46.63l1.93,1.11a2.29,2.29,0,0,0,1.1.26Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.87 23.14 284.04 29.98 284.04 52.48 295.87 45.65 295.87 23.14",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.42,30.35l11.45-6.57a4.78,4.78,0,0,0,2.62,1.43l-11.36,6.54A11.42,11.42,0,0,1,284.42,30.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.23,31.71a2.44,2.44,0,0,1-2.2,0l-1.92-1.1a.67.67,0,0,1,0-1.27l11.28-6.47.48.27-11.1,6.41a.4.4,0,0,0,0,.76l1.79,1a1.46,1.46,0,0,0,1.32,0L299,24.93l.54.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.52,25.24v22.5l-11.29,6.48a2.5,2.5,0,0,1-2.2,0l-1.92-1.11a.75.75,0,0,1-.46-.63V30a.78.78,0,0,0,.46.64l1.92,1.1a2.44,2.44,0,0,0,2.2,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.13,32a2.24,2.24,0,0,1-1.1-.27l-1.92-1.1a.78.78,0,0,1-.46-.64V52.48a.75.75,0,0,0,.46.63L286,54.22a2.35,2.35,0,0,0,1.1.26Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.94 29.12 292.12 35.96 295.79 59.14 307.62 52.31 303.94 29.12",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.58,36.28,304,29.71a6.26,6.26,0,0,0,3,1.18l-11.35,6.54A15.12,15.12,0,0,1,292.58,36.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.92,37.34a3.08,3.08,0,0,1-2.39.11l-2.25-.92c-.71-.29-.79-.81-.18-1.16l11.29-6.47.55.22-11.09,6.41c-.37.21-.32.52.11.69l2.09.85a1.85,1.85,0,0,0,1.43-.07l11.1-6.39.63.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.21,30.86l3.67,23.19-11.29,6.48a3.06,3.06,0,0,1-2.38.1L296,59.71c-.36-.14-.56-.34-.59-.55L291.7,36c0,.21.23.42.58.56l2.25.92a3.08,3.08,0,0,0,2.39-.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.76,37.64a2.92,2.92,0,0,1-1.23-.19l-2.25-.92c-.35-.14-.55-.35-.58-.56l3.67,23.19c0,.21.23.41.59.55l2.25.92a2.9,2.9,0,0,0,1.23.19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "323.6 71.24 322.76 71.64 307.24 62.68 308.08 62.28 323.6 71.24",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.08 62.28 322.85 70.8 324.99 48.72 310.23 40.2 308.08 62.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.66,63.42,324,74,326.57,48,308.2,37.37Zm3.81-23.66,15.52,9-2.23,22.92-15.52-9Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.24 62.68 308.08 62.28 310.23 40.2 309.47 39.76 307.24 62.68",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.2 37.37 309.05 36.98 327.42 47.59 326.57 47.98 308.2 37.37",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.42 47.59 326.57 47.98 324.04 74.03 324.89 73.63 327.42 47.59",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "308.73 61.86 322.34 69.72 322.7 66 320.17 55.07 317.76 58.8 318.26 61.94 314.23 50.34 309.09 58.14 308.73 61.86",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.38,50.47a1.9,1.9,0,0,1,.9,1.68c-.06.61-.56.84-1.11.52a1.92,1.92,0,0,1-.9-1.69C319.33,50.38,319.82,50.14,320.38,50.47Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-49",
    d: "M331.25,69.71c-2.52,1.45-2.52,3.81,0,5.26a10.1,10.1,0,0,0,9.12,0c2.51-1.45,2.51-3.81,0-5.26A10,10,0,0,0,331.25,69.71Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.91,73.37c2.19-2.23,3.48-7.82,1.34-9.6H330.36c-2.13,1.78-.85,7.36,1.34,9.6,0,0,.05,0,.06.06a.6.6,0,0,1,.08.08l.2.17,0,0a1.09,1.09,0,0,0,.17.13,2.68,2.68,0,0,0,.28.18,7.22,7.22,0,0,0,6.53,0h0c.1,0,.19-.12.29-.18l.15-.12.07,0,.19-.17.09-.09Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.31,62.92c-2.48,1.44-2.48,3.76,0,5.19a9.89,9.89,0,0,0,9,0c2.49-1.43,2.49-3.75,0-5.19A10,10,0,0,0,331.31,62.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.07,63.94c-1.51.87-1.51,2.28,0,3.16a6.06,6.06,0,0,0,5.47,0c1.51-.88,1.51-2.29,0-3.16A6.06,6.06,0,0,0,333.07,63.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.54,65.44a6,6,0,0,0-5.47,0,2.36,2.36,0,0,0-.9.83,2.52,2.52,0,0,0,.9.83,6.06,6.06,0,0,0,5.47,0,2.65,2.65,0,0,0,.91-.83A2.47,2.47,0,0,0,338.54,65.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.4,66.27a12.59,12.59,0,0,1-2-2.63c-.92-1.62-1.09-3.78-.62-4s2.4,1.89,2.4,1.89a11.84,11.84,0,0,1-.2-2.76c.08-1.44.43-2.74.84-3s1.34,1.55,1.73,2.87.63,2.4.63,2.4a20.3,20.3,0,0,1,.71-3c.48-1.37.92-1.68,1.25-1.54s.56.77.66,2.59a18,18,0,0,1-.08,2.6s.68-.74,1.43-1.46,1.18-.91,1.42-.76.3,1.39-1,3.71a13,13,0,0,1-2.42,3.18S336.43,67.41,333.4,66.27Z",
    style: {
      fill: "#ebebeb"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pictures--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "194.31 109.85 195.26 110.41 214.66 99.21 213.71 98.65 194.31 109.85",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.71 98.65 195.26 109.3 195.26 62.31 213.71 51.67 213.71 98.65",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.44,48l-23,13.26V113.5l23-13.26Zm-1.78,51.19-19.4,11.2V62.31l19.4-11.2Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.66 99.21 213.71 98.65 213.71 51.67 214.66 51.11 214.66 99.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.44 48.02 215.48 47.47 192.51 60.73 193.47 61.28 216.44 48.02",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.51 60.73 193.47 61.28 193.47 113.5 192.51 112.95 192.51 60.73",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "212.33 97.54 196.64 106.6 196.64 63.98 212.33 54.92 212.33 97.54",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "212.33 97.54 196.64 106.6 196.64 63.98 212.33 54.92 212.33 97.54",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.64,91.39a16.9,16.9,0,0,0,2.25,0,28.68,28.68,0,0,0,7.64-1.66c1.89-.71,3.79-1.61,5.8-1.67v9.5l-2.12,1.23a7.26,7.26,0,0,0-2.92-1.62c-3-.79-6.12.73-9.22,1.08a11.41,11.41,0,0,1-1.43.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.64,83c3.51-1,7.11-1.9,9.62-4.48,2-2.07,3-5,3.63-7.77s1.12-5.73,2.4-8.33l0-.07v18c-.2.29-.39.58-.6.87-2.31,3.12-5.7,5.73-9.58,5.93-1.82.1-3.7-.33-5.51-.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.64,72.59a10.69,10.69,0,0,0,3.48-9.73q-.08-.39-.18-.78l6-3.49c0,.4,0,.8-.06,1.19a35.18,35.18,0,0,1-.49,6.89,13.5,13.5,0,0,1-6.88,8.88,12.83,12.83,0,0,1-1.91.8Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "194.3 137.9 195.23 138.45 214.44 127.36 213.51 126.8 194.3 137.9",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.51 126.8 195.23 137.35 195.23 118.21 213.51 107.67 213.51 126.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.21,104.06l-22.74,13.13v24.32l22.74-13.13Zm-1.77,23.3-19.21,11.09V118.21l19.22-11.09Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.44 127.36 213.51 126.8 213.51 107.67 214.44 107.12 214.44 127.36",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.21 104.06 215.26 103.52 192.51 116.65 193.47 117.19 216.21 104.06",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.51 116.65 193.47 117.19 193.47 141.51 192.51 140.97 192.51 116.65",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "212.8 126.23 195.95 135.96 195.95 131.09 200.16 121.37 202.78 123.8 201.84 127.88 207.66 115.43 212.8 121.37 212.8 126.23",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.62,116.67a2.77,2.77,0,0,0-1.24,2.16c0,.79.56,1.11,1.24.72a2.77,2.77,0,0,0,1.25-2.16C203.87,116.59,203.31,116.27,202.62,116.67Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "222.36 106.79 223.31 107.36 242.71 96.16 241.76 95.59 222.36 106.79",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.76 95.59 223.31 106.25 223.31 59.26 241.76 48.61 241.76 95.59",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.49,45l-23,13.26v52.22l23-13.26Zm-1.78,51.19-19.4,11.2V59.26l19.4-11.2Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.71 96.16 241.76 95.59 241.76 48.61 242.71 48.06 242.71 96.16",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.49 44.97 243.53 44.42 220.56 57.68 221.52 58.23 244.49 44.97",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.56 57.68 221.52 58.23 221.52 110.45 220.56 109.9 220.56 57.68",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "240.38 94.49 224.69 103.54 224.69 60.93 240.38 51.87 240.38 94.49",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "240.38 94.49 224.69 103.54 224.69 60.93 240.38 51.87 240.38 94.49",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.69,88.33a14,14,0,0,0,2.24,0,27.76,27.76,0,0,0,7.64-1.66c1.9-.7,3.8-1.61,5.81-1.66v9.5l-2.12,1.22a7.24,7.24,0,0,0-2.92-1.61c-3-.8-6.12.72-9.23,1.08a13.37,13.37,0,0,1-1.42.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.69,80c3.51-1,7.11-1.9,9.62-4.47,2-2.08,3-5,3.63-7.77s1.12-5.73,2.4-8.33c0,0,0,0,0-.08v18c-.2.3-.39.59-.6.87-2.31,3.13-5.7,5.73-9.58,5.94-1.82.09-3.7-.34-5.51-.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.69,69.54a10.74,10.74,0,0,0,3.48-9.74q-.07-.39-.18-.78l6-3.48c0,.39-.05.79-.06,1.19a35.14,35.14,0,0,1-.49,6.88,13.54,13.54,0,0,1-6.88,8.89,11.82,11.82,0,0,1-1.91.79Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "222.34 50.35 223.28 50.9 242.49 39.81 241.56 39.25 222.34 50.35",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.56 39.25 223.28 49.8 223.28 30.66 241.56 20.12 241.56 39.25",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.26,16.51,221.52,29.64V54l22.74-13.13Zm-1.77,23.3L223.28,50.9V30.66l19.21-11.09Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.49 39.81 241.56 39.25 241.56 20.12 242.5 19.57 242.49 39.81",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.26 16.51 243.31 15.97 220.56 29.1 221.51 29.64 244.26 16.51",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.56 29.1 221.51 29.64 221.51 53.96 220.56 53.42 220.56 29.1",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "240.84 38.68 224 48.41 224 43.55 228.21 33.82 230.83 36.25 229.89 40.33 235.71 27.88 240.84 33.82 240.84 38.68",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.67,29.12a2.77,2.77,0,0,0-1.24,2.16c0,.79.56,1.11,1.24.72a2.77,2.77,0,0,0,1.25-2.16C231.92,29,231.36,28.72,230.67,29.12Z",
    style: {
      fill: "#f0f0f0"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Windows--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.94 197.42 422.1 198.52 357.66 161.32 359.5 160.23 423.94 197.42",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.5 160.23 422.1 196.35 422.1 72.77 359.5 36.66 359.5 160.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.19,163.33l71.38,41.2V70.76l-71.38-41.2Zm3.47-127.75L422.1,72.77V198.52l-64.44-37.2Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.66 161.32 359.5 160.23 359.5 36.66 357.66 35.58 357.66 161.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.1 155.84 422.1 157.99 357.66 120.8 359.5 119.7 422.1 155.84",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.1 107.13 422.1 109.29 357.66 72.1 359.5 71 422.1 107.13",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.19 29.56 356.06 28.49 427.44 69.69 425.57 70.76 354.19 29.56",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.44 69.69 425.57 70.76 425.57 204.53 427.44 203.46 427.44 69.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.46 56.25 391.6 55.17 391.6 180.93 393.46 179.86 393.46 56.25",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "388.13 53.17 391.6 55.17 391.6 180.93 388.13 178.91 388.13 53.17",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.19 70.1 354.19 74.1 425.57 115.3 425.57 111.3 354.19 70.1",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.19 118.79 354.19 122.79 425.57 163.99 425.57 159.99 354.19 118.79",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.6 91.7 393.46 90.61 422.1 107.13 422.1 109.29 391.6 91.7",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.6 140.37 393.46 139.29 422.1 155.81 422.1 157.97 391.6 140.37",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "46.31 212.17 48.16 213.27 112.59 176.08 110.75 174.98 46.31 212.17",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.75 174.98 48.16 211.1 48.16 87.52 110.75 51.41 110.75 174.98",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.07,44.31,44.68,85.51V219.28l71.38-41.2Zm-3.48,131.77L48.15,213.27V87.52l64.43-37.19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.59 176.08 110.75 174.98 110.75 51.41 112.59 50.33 112.59 176.08",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.16 170.59 48.16 172.75 112.59 135.55 110.75 134.46 48.16 170.59",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.16 121.89 48.16 124.04 112.59 86.85 110.75 85.76 48.16 121.89",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.06 44.31 114.2 43.24 42.82 84.44 44.68 85.51 116.06 44.31",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.82 84.44 44.68 85.51 44.68 219.28 42.82 218.21 42.82 84.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.79 71 78.66 69.92 78.66 195.68 76.79 194.61 76.79 71",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "82.13 67.93 78.66 69.92 78.66 195.68 82.13 193.67 82.13 67.93",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.06 84.85 116.06 88.85 44.68 130.05 44.68 126.05 116.06 84.85",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.06 133.54 116.06 137.54 44.68 178.74 44.68 174.74 116.06 133.54",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.66 106.45 76.79 105.37 48.16 121.89 48.16 124.04 78.66 106.45",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.66 155.13 76.79 154.04 48.16 170.56 48.16 172.72 78.66 155.13",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Furniture--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Drawer--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "433.95 293.11 436.77 307.08 439.51 308.66 442.22 307.1 445.06 293.11 439.51 289.9 433.95 293.11",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.95 293.11 436.77 307.08 439.51 308.66 442.22 307.1 445.06 293.11 439.51 289.9 433.95 293.11",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.51 308.66 439.51 296.31 433.95 293.11 436.77 307.08 439.51 308.66",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.95 293.11 435.77 302.13 439.51 304.29 443.23 302.14 445.06 293.11 439.51 289.9 433.95 293.11",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.38 279 461.2 292.98 463.94 294.56 466.65 292.99 469.49 279 463.94 275.79 458.38 279",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.38 279 461.2 292.98 463.94 294.56 466.65 292.99 469.49 279 463.94 275.79 458.38 279",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.94 294.56 463.94 282.21 458.38 279 461.2 292.98 463.94 294.56",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.38 279 460.2 288.03 463.94 290.18 467.66 288.04 469.49 279 463.94 275.79 458.38 279",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.69 251.38 364.5 265.36 367.24 266.94 369.96 265.37 372.8 251.38 367.24 248.17 361.69 251.38",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.24 266.94 367.24 254.59 361.69 251.38 364.5 265.36 367.24 266.94",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.69 251.38 363.51 260.41 367.24 262.56 370.96 260.42 372.8 251.38 367.24 248.17 361.69 251.38",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cabinet--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--cabinet--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "439.51 302.03 469.78 284.55 469.78 219.03 439.51 236.51 439.51 302.03",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.51 236.51 360.11 190.66 360.11 256.19 439.51 302.03 439.51 236.51",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.11 190.66 439.51 236.51 469.78 219.03 390.39 173.19 360.11 190.66",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.18 268.97 364.44 228.12 364.44 252.17 363.64 252.63 434.39 293.47 435.19 293.01 435.18 268.97",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.39 269.43 363.64 228.58 363.64 252.63 434.39 293.47 434.39 269.43",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.38,254.33l-5.89-3.39c-.76-.44-1.38-.24-1.38.45a2.76,2.76,0,0,0,1.38,2l5.89,3.4c.76.44,1.38.24,1.38-.45A2.78,2.78,0,0,0,400.38,254.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.19 239.93 364.44 199.08 364.44 223.13 363.64 223.59 434.39 264.44 435.19 263.98 435.19 239.93",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.39 240.39 363.64 199.54 363.64 223.59 434.39 264.44 434.39 240.39",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.38,225.3l-5.89-3.4c-.76-.44-1.38-.24-1.38.45a2.78,2.78,0,0,0,1.38,2.05l5.89,3.39c.76.44,1.38.24,1.38-.45A2.76,2.76,0,0,0,400.38,225.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.66,192.63c-3.67,2.12-3.67,5.56,0,7.68a14.74,14.74,0,0,0,13.29,0c3.67-2.12,3.67-5.56,0-7.68A14.68,14.68,0,0,0,392.66,192.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.15,196.94c3.2-3.26,5.07-11.4,2-14H391.24c-3.11,2.59-1.24,10.73,2,14l.08.09a.57.57,0,0,1,.11.11l.29.25.08.06c.08.06.15.13.24.19l.41.26a10.51,10.51,0,0,0,9.52,0h0a3.74,3.74,0,0,0,.42-.27l.23-.17.09-.07.28-.25.13-.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.62,181.91c-3.62,2.09-3.62,5.48,0,7.57a14.52,14.52,0,0,0,13.11,0c3.62-2.09,3.62-5.48,0-7.57A14.49,14.49,0,0,0,392.62,181.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.19,183.39c-2.21,1.27-2.21,3.33,0,4.6a8.75,8.75,0,0,0,8,0c2.2-1.27,2.2-3.33,0-4.6A8.81,8.81,0,0,0,395.19,183.39Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.16,185.57a8.81,8.81,0,0,0-8,0,3.73,3.73,0,0,0-1.32,1.21,3.56,3.56,0,0,0,1.32,1.21,8.75,8.75,0,0,0,8,0,3.56,3.56,0,0,0,1.32-1.21A3.73,3.73,0,0,0,403.16,185.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.67,186.78a17.83,17.83,0,0,1-2.88-3.83c-1.33-2.35-1.58-5.51-.89-5.9s3.49,2.76,3.49,2.76a17.05,17.05,0,0,1-.29-4c.11-2.1.62-4,1.22-4.39s1.95,2.26,2.53,4.18.92,3.49.92,3.49a29.42,29.42,0,0,1,1-4.41c.7-2,1.33-2.44,1.83-2.24s.81,1.12.95,3.77a25.51,25.51,0,0,1-.11,3.8s1-1.09,2.08-2.14,1.72-1.32,2.07-1.1.44,2-1.43,5.4a18.8,18.8,0,0,1-3.52,4.63S400.09,188.45,395.67,186.78Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "441.66 223.26 440.48 223.83 418.65 211.22 419.83 210.66 441.66 223.26",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.83 210.66 440.6 222.65 443.62 191.58 422.85 179.59 419.83 210.66",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.43,212.26l25.85,14.93,3.56-36.65L420,175.62ZM421.78,179l21.84,12.61-3.14,32.25-21.83-12.61Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.65 211.22 419.83 210.66 422.85 179.59 421.79 178.97 418.65 211.22",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.99 175.62 421.19 175.06 447.04 189.99 445.84 190.54 419.99 175.62",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.04 189.99 445.84 190.54 442.28 227.19 443.47 226.63 447.04 189.99",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "420.74 210.07 439.89 221.12 440.4 215.89 436.84 200.51 433.44 205.76 434.15 210.18 428.48 193.87 421.25 204.83 420.74 210.07",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.13,194a2.71,2.71,0,0,1,1.27,2.36c-.09.86-.79,1.19-1.57.73a2.71,2.71,0,0,1-1.27-2.36C435.65,193.91,436.35,193.59,437.13,194Z",
    style: {
      fill: "#f0f0f0"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lamp--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--lamp--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.8,290.07h0c0-2-1.29-4-3.91-5.47-5.24-3-13.73-3-19,0-2.62,1.51-3.92,3.49-3.91,5.47h0v1.86h0c0,1.95,1.35,3.9,3.93,5.39,5.24,3,13.73,3,19,0,2.58-1.49,3.89-3.44,3.93-5.39h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9,284.6c-5.23,3-5.23,7.92,0,10.95s13.73,3,19,0,5.24-7.93,0-10.95S33.14,281.57,27.9,284.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,170.94h2.82V288.62h0a.65.65,0,0,1-.4.65,2.25,2.25,0,0,1-2,0,.65.65,0,0,1-.4-.65h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.17,164.57h0l8.59-21.92H47.08l8.59,21.92h0c1.23,3.43-.46,7.13-5.06,9.79-7.28,4.21-19.09,4.21-26.37,0C19.62,171.7,17.94,168,19.17,164.57Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.17,164.57h0l8.59-21.92H47.08l8.59,21.92h0c1.23,3.43-.46,7.13-5.06,9.79-7.28,4.21-19.09,4.21-26.37,0C19.62,171.7,17.94,168,19.17,164.57Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.67,168.73c-3.5-5.68,1-16.44,4.27-25.43v-.65h-5.2l-8.59,21.92h0c-1.23,3.43.45,7.13,5.06,9.79,7.28,4.21,19.09,4.21,26.37,0C44,177,32.18,174.42,28.67,168.73Z",
    style: {
      fill: "#0B1D51",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.41,147.9a15.46,15.46,0,0,1-14,0c-3.86-2.23-3.86-5.84,0-8.07a15.46,15.46,0,0,1,14,0C48.27,142.06,48.27,145.67,44.41,147.9Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.41,147.9a15.46,15.46,0,0,1-14,0c-3.86-2.23-3.86-5.84,0-8.07a15.46,15.46,0,0,1,14,0C48.27,142.06,48.27,145.67,44.41,147.9Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.41,148.43a13,13,0,0,0,6.42-1.52c1.5-.87,2.32-1.95,2.32-3s-.82-2.18-2.32-3.05a13,13,0,0,0-6.42-1.52A13,13,0,0,0,31,140.82c-1.5.87-2.33,2-2.33,3.05s.83,2.17,2.33,3A13,13,0,0,0,37.41,148.43Z",
    style: {
      fill: "#0B1D51"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-3--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--hanging-flowerpot--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445,151.09h-.09a.43.43,0,0,1-.33-.51l15.46-73.19a.43.43,0,0,1,.51-.34.44.44,0,0,1,.34.52l-15.47,73.19A.43.43,0,0,1,445,151.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.93,151.47a.45.45,0,0,1-.43-.34L460.05,77.56a.43.43,0,1,1,.85-.18L476.35,151a.43.43,0,0,1-.33.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.36,155.7h-28l2.9,12.06h0a5.88,5.88,0,0,0,3.22,4,17.37,17.37,0,0,0,15.76,0c2.08-1.19,3.15-2.75,3.25-4.32Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.36,155.7h-28l2.9,12.06h0a5.88,5.88,0,0,0,3.22,4,17.37,17.37,0,0,0,15.76,0c2.08-1.19,3.15-2.75,3.25-4.32Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.36,155.7h-28l2.9,12.06h0a5.88,5.88,0,0,0,3.22,4,17.37,17.37,0,0,0,15.76,0c2.08-1.19,3.15-2.75,3.25-4.32Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471,164a12.39,12.39,0,0,0,1.68-1.17l1.57-6.44a11.09,11.09,0,0,1-2.83,2.25c-5.9,3.4-15.37,3.49-21.47.27l.71-2.87-.22-.3h-4l2.9,12.05h0a5.88,5.88,0,0,0,3.22,4A17.41,17.41,0,0,0,464,173.27c-7,.52-11.76-2.53-12.48-5.34-.28-1.12-.78-3.6-.78-3.6C456.51,167.29,465.39,167.17,471,164Z",
    style: {
      fill: "#0B1D51",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.82,152.13a6,6,0,0,1-.94,2.18,10.23,10.23,0,0,1-3.51,3.11c-6.07,3.51-15.93,3.51-22,0a10.23,10.23,0,0,1-3.51-3.11,5.82,5.82,0,0,1-.93-2.18h0c-.54-2.64.94-5.39,4.45-7.41,6.07-3.51,15.93-3.51,22,0C474.88,146.74,476.36,149.49,475.82,152.13Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.82,152.13a6,6,0,0,1-.94,2.18,10.23,10.23,0,0,1-3.51,3.11c-6.07,3.51-15.93,3.51-22,0a10.23,10.23,0,0,1-3.51-3.11,5.82,5.82,0,0,1-.93-2.18h0c-.54-2.64.94-5.39,4.45-7.41,6.07-3.51,15.93-3.51,22,0C474.88,146.74,476.36,149.49,475.82,152.13Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.88,154.31a10.23,10.23,0,0,1-3.51,3.11c-6.07,3.51-15.93,3.51-22,0a10.23,10.23,0,0,1-3.51-3.11,5.82,5.82,0,0,1-.93-2.18h0l.69,4.74c.32,1.91,1.74,3.77,4.28,5.24,5.79,3.34,15.17,3.34,21,0,2.5-1.45,3.93-3.29,4.26-5.17l0-.24.67-4.57A6,6,0,0,1,474.88,154.31Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.88,154.31a10.23,10.23,0,0,1-3.51,3.11c-6.07,3.51-15.93,3.51-22,0a10.23,10.23,0,0,1-3.51-3.11,5.82,5.82,0,0,1-.93-2.18h0l.69,4.74c.32,1.91,1.74,3.77,4.28,5.24,5.79,3.34,15.17,3.34,21,0,2.5-1.45,3.93-3.29,4.26-5.17l0-.24.67-4.57A6,6,0,0,1,474.88,154.31Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.54,145.78c-5.06-2.93-13.28-2.93-18.34,0-2.86,1.66-4.1,3.89-3.73,6.05.29,1.65,1.54,3.27,3.73,4.53,5.06,2.93,13.28,2.93,18.34,0,2.19-1.26,3.44-2.88,3.73-4.53C473.65,149.67,472.41,147.44,469.54,145.78Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.54,145.78c-5.06-2.93-13.28-2.93-18.34,0-2.86,1.66-4.1,3.89-3.73,6.05.29,1.65,1.54,3.27,3.73,4.53,5.06,2.93,13.28,2.93,18.34,0,2.19-1.26,3.44-2.88,3.73-4.53C473.65,149.67,472.41,147.44,469.54,145.78Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.33,153.83a8.6,8.6,0,0,0,2.87,2.53c5.06,2.93,13.28,2.93,18.34,0a8.6,8.6,0,0,0,2.87-2.53c0-1.75-1.21-3.49-3.52-4.83-4.71-2.72-12.33-2.72-17,0C449.54,150.34,448.37,152.08,448.33,153.83Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M456.46,135c-.25-7.15-2.94-18.27-5.53-22.76a36.51,36.51,0,0,1,8.15,21.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.22,150.4c.24-5,3.9-6.59,8-5,2.92,1.15,7.15,5.5,8.49,12.43C479.42,154.28,469.92,142.23,464.22,150.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.44,152.79a4.08,4.08,0,0,1,4.81-3.68c2.91.6,9.75,5.95,12.66,14.71-.53-5.88-2.44-11-6.37-14.25s-6.79-3.79-9.67-2.09C463.4,149,464.44,152.79,464.44,152.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.22,155.2c-2.36-7.91-2.72-22.61-.44-30.56,3.22-11.23,9.9-16.15,14.89-17.35-4.72,2-9.71,9.17-11.11,16.22s-.6,31.69-.6,31.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.17,147.48c.3-4.42,2.88-14.23,8-18.18a9.4,9.4,0,0,1,12.54.77,7.67,7.67,0,0,0-9.5.15c-2.69,2.22-5.43,8.88-6.8,15.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.12,130.22c3.22-3.15,5.73-5.28,9.72-5.08s9.31,5.78,12.4,17.59c-3.19-7.5-7.32-14.1-13.94-14.8A10.66,10.66,0,0,0,468.12,130.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.18,123.2a25.71,25.71,0,0,1,26.44,21.72l-3.55-.58s-2.94-9.3-8-14.12C442.49,125.93,439.13,124.22,432.18,123.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.49,142.69c.27-4-1.61-12.38-7.7-18.06s-8.3-6.93-14.58-8.53A39.69,39.69,0,0,1,450.27,127c4,5.28,4.22,11.53,4.22,13.88C455.18,142.69,457.66,146.54,459.49,142.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.22,144.65c-.79-5.08,1.94-14.18,5.13-18.63,3.87-5.39,9.57-9.42,15.9-10.51-6.78,2.59-13.59,10.15-15.59,17.28a38.58,38.58,0,0,0-.84,14.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.38,155.2c-.86-4.76.65-14.65,8.48-20.1s13.22-4,15.27-3.39c-6.05-.41-12.13,3-15.84,7.13-2.58,2.89-5,7.64-5.16,15.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.49,155.59s2.05-.05,2.87-1c0-3.07.82-9.22,5.14-12.85s7.66-2.93,8.34-1.51c0-2.09-2.63-3.94-5.54-3.32C467.43,137.93,460.57,144.22,461.49,155.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.76,137.83c2.65-1.44,4.93-2.68,7.88-1.31.14-.08,1.82-.5,2.46.25,2.47,2.92,1.67,10.18-2.86,17.14,2.09-5.22,2.19-14.85-1.66-16.35A7.71,7.71,0,0,0,469.76,137.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.64,136.52c1.2.55,3.64,4.73,2.06,10.55,1.47-4.4.94-8.63-1.53-10.68A2.74,2.74,0,0,0,477.64,136.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.28,154.17a4.08,4.08,0,0,0-4.81-3.68c-2.91.6-9.75,5.94-12.66,14.71a23.71,23.71,0,0,1,6.2-14.54c3.16-3.34,7.31-4.94,10.61-3.18S456.28,154.17,456.28,154.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.07,143.09c-2.55-2.56-4.34-5-9-4s-7.91,6.08-9.19,13c.8-2.66,3.22-8.75,8-9.79S452,141.56,455.07,143.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.28,154.17c-.67-4.5-2.38-10.93-7.18-11.19s-10.06,2.76-12.25,9c1.12-5.72,6-11.17,11.08-11.18s10.08,1.1,11.29,14.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.24,135.05a13.1,13.1,0,0,0-6.62-3.28c-1.63-.27-4.81-1.53-8.21,1.64s-7,10.57-5.72,15.74C432.24,143.66,439.61,128.25,452.24,135.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.9,155.64c0-4.18-3-17.42-7.87-20.8-6-4.22-10.07-.63-10.07-.63a8.07,8.07,0,0,1,7.19,1.15c3.11,2.27,6,8.94,7.13,18.81A4.34,4.34,0,0,0,459.9,155.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.16,143.2c-.29,1.22,1,10.34,2,12.39a8.61,8.61,0,0,0,2.91,0c.92-1.6,0-11.91,1.79-12.11C462.45,142.81,457.8,141.09,457.16,143.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.16,143.2c1.42-1.47,7.2,1.42,8.29,10,1.44-4.09.8-9.14-.64-10.42a2.6,2.6,0,0,0-3-.39S457.36,140.45,457.16,143.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.84,142.42c1.77.74,3.79,3.2,3.77,7.38.14-2.14-.28-5.9-3.31-7.57A2.91,2.91,0,0,0,461.84,142.42Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.47,165.28a.44.44,0,0,1-.43-.44V77.47a.44.44,0,0,1,.43-.44.44.44,0,0,1,.44.44v87.37A.44.44,0,0,1,460.47,165.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.47,77.9A3.86,3.86,0,1,1,464.33,74,3.86,3.86,0,0,1,460.47,77.9Zm0-6.86a3,3,0,1,0,3,3A3,3,0,0,0,460.47,71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.47,71a.43.43,0,0,1-.43-.43V35.05a.43.43,0,0,1,.43-.43.44.44,0,0,1,.44.43V70.61A.44.44,0,0,1,460.47,71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.37,165.27a22.67,22.67,0,0,1-10.9-2.55c-2.59-1.47-4.22-3.44-4.57-5.54a.44.44,0,0,1,.86-.15c.31,1.84,1.78,3.59,4.14,4.93,5.77,3.27,15.17,3.27,20.94,0,2.33-1.32,3.8-3.05,4.13-4.86a.43.43,0,0,1,.51-.35.44.44,0,0,1,.35.5c-.38,2.08-2,4-4.56,5.47A22.64,22.64,0,0,1,460.37,165.27Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-2--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.49,170.4c-5.1-5.67-8.1-19.49-3.12-24H269.7c5,4.49,2,18.3-3.12,24l-.14.16-.17.18c-.15.16-.3.3-.47.45l-.12.1-.38.32a6.58,6.58,0,0,1-.66.46,15.6,15.6,0,0,1-15.21,0h0c-.22-.14-.44-.29-.66-.46l-.36-.3-.15-.13a6.14,6.14,0,0,1-.45-.43l-.2-.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.5,144.61c5.78,3.63,5.78,9.52,0,13.15s-15.15,3.63-20.93,0-5.78-9.52,0-13.15S261.72,141,267.5,144.61Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.72,146.35c4.25,2.67,4.25,7,0,9.66a15.75,15.75,0,0,1-15.37,0c-4.25-2.67-4.25-7,0-9.66A15.8,15.8,0,0,1,264.72,146.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.35,150.94a15.75,15.75,0,0,1,15.37,0,7.3,7.3,0,0,1,2.54,2.53,7.24,7.24,0,0,1-2.54,2.54,15.75,15.75,0,0,1-15.37,0,7.24,7.24,0,0,1-2.54-2.54A7.3,7.3,0,0,1,249.35,150.94Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.4,103.88l-9.62,8.21,9.3-4.62a29.56,29.56,0,0,1-1.61,9.48,57.26,57.26,0,0,0-7.24,5.52l7.13-3a41.46,41.46,0,0,1-1.47,12.77c-.51,2-2.62,5.87-3.95,8.75a34.19,34.19,0,0,1-2.08,3.85c0,.08-.09.16-.14.24q-2.45-1.52-5.08-2.92c-1.15-2.6-2.64-9-3.18-14.25-2.05-20.07,12.06-31.58,23.4-35.44A37.44,37.44,0,0,0,268.4,103.88Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.36,104.72a20,20,0,0,0-4,7.72,43.29,43.29,0,0,0-1.7,8.68,40.17,40.17,0,0,0,2,17.44h0a.29.29,0,0,1-.15.38.26.26,0,0,1-.35-.17h0a40.75,40.75,0,0,1-1.8-17.68,43.47,43.47,0,0,1,1.85-8.7A19.94,19.94,0,0,1,260.36,104.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.77,114.41a0,0,0,0,0,0,0,153.61,153.61,0,0,1,10.05,15.19l9.76,1.69-7.2,1.35,3.87,6.59,9.6,2.13-7.5,1.31s2.09,7.88,7.45,11.16c3,1.81,4.42,2.09,5.31,1.18.62-.64.76-4.41,1.28-7.78a27.46,27.46,0,0,0-2.4-15.47,20.56,20.56,0,0,0-3.07-4.86C246.83,118.41,233.41,114.31,226.77,114.41Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,117.85a39.89,39.89,0,0,1,13.57,10.08,27.85,27.85,0,0,1,6.77,16,.05.05,0,0,1,0,0,0,0,0,0,1,0,0,37.41,37.41,0,0,0-2.56-8.39,32.85,32.85,0,0,0-4.48-7.36A40.92,40.92,0,0,0,237,117.9s0,0,0,0S237,117.84,237,117.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.91,118.75h0a18.09,18.09,0,0,0-2.46.12,36.79,36.79,0,0,0-9.39,2.46c-1.12.45-2.25,1-3.35,1.52q-.84.44-1.65.9a27.5,27.5,0,0,0-7.19,5.86,18.54,18.54,0,0,0-2.48,3.74c-.09.18-.18.35-.26.53h0c-.21.46-.4.91-.58,1.36a27.05,27.05,0,0,0-2.12,12.44c.1,3,1.05,6.45,1.6,7a1.06,1.06,0,0,0,.24.19c.8.55,2.07.23,4.44-1.2,4.76-2.86,6.63-10.11,6.63-10.11l-6.61-1.2,8.49-1.83,3.44-5.78-6.34-1.24,8.62-1.43a134.59,134.59,0,0,1,9-13.34Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.45,118.87a36.79,36.79,0,0,0-9.39,2.46c-1.12.45-2.25,1-3.35,1.52q-.84.44-1.65.9a27.5,27.5,0,0,0-7.19,5.86,18.54,18.54,0,0,0-2.48,3.74c-.09.18-.18.35-.26.53h0c-.21.46-.4.91-.58,1.36a27.05,27.05,0,0,0-2.12,12.44c.1,3,1.05,6.45,1.6,7a1.06,1.06,0,0,0,.24.19,1.37,1.37,0,0,0,.53.21c-.59-4.67,1.55-16.51,4.78-21.39a38.4,38.4,0,0,1,22.32-15h0A17.74,17.74,0,0,0,282.45,118.87Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.77,155.1a43.61,43.61,0,0,1,.62-10.33,35.29,35.29,0,0,1,3.19-9.8,28.28,28.28,0,0,1,6.45-7.74,35.52,35.52,0,0,1,8.27-5.34l0,0s0,0,0,0a46.89,46.89,0,0,0-7.95,5.73,34,34,0,0,0-3.5,3.5,22.89,22.89,0,0,0-2.92,4,34.64,34.64,0,0,0-3.29,9.62,42.56,42.56,0,0,0-.84,10.27s0,0,0,0A0,0,0,0,1,257.77,155.1Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-1--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.52,249.69C100,244,96.75,230.55,102.14,226h27.42c5.38,4.52,2.14,17.95-3.38,23.65l-.15.16-.19.19c-.16.15-.32.3-.5.45l-.13.1c-.14.11-.27.22-.42.32a6.12,6.12,0,0,1-.71.46c-4.55,2.65-11.92,2.65-16.46,0h0c-.24-.14-.48-.29-.72-.46l-.39-.3-.16-.13c-.17-.14-.33-.29-.48-.43s-.15-.15-.22-.22Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.52,249.69C100,244,96.75,230.55,102.14,226h27.42c5.38,4.52,2.14,17.95-3.38,23.65l-.15.16-.19.19c-.16.15-.32.3-.5.45l-.13.1c-.14.11-.27.22-.42.32a6.12,6.12,0,0,1-.71.46c-4.55,2.65-11.92,2.65-16.46,0h0c-.24-.14-.48-.29-.72-.46l-.39-.3-.16-.13c-.17-.14-.33-.29-.48-.43s-.15-.15-.22-.22Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.18,224.21c6.25,3.65,6.25,9.57,0,13.23s-16.4,3.65-22.66,0-6.25-9.58,0-13.23S120.92,220.56,127.18,224.21Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.18,224.21c6.25,3.65,6.25,9.57,0,13.23s-16.4,3.65-22.66,0-6.25-9.58,0-13.23S120.92,220.56,127.18,224.21Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M124.17,226c4.59,2.68,4.59,7,0,9.71s-12,2.68-16.64,0-4.59-7,0-9.71S119.57,223.28,124.17,226Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.17,226c4.59,2.68,4.59,7,0,9.71s-12,2.68-16.64,0-4.59-7,0-9.71S119.57,223.28,124.17,226Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.53,230.58c4.59-2.69,12-2.69,16.64,0a7.69,7.69,0,0,1,2.75,2.55,7.78,7.78,0,0,1-2.75,2.55c-4.6,2.68-12,2.68-16.64,0a7.69,7.69,0,0,1-2.75-2.55A7.61,7.61,0,0,1,107.53,230.58Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108,182s0-.37,0-.41,0-.28,0-.42-.07-.55-.12-.83c-.11-.55-.25-1.1-.41-1.64a1,1,0,0,0-.1-.32l-.1-.31c-.07-.22-.14-.43-.22-.65s-.21-.61-.31-.92a7.16,7.16,0,0,1-.3-.89,1.4,1.4,0,0,0-.08-.34.44.44,0,0,1-.06-.16l-.09-.45c-.07-.3-.14-.59-.22-.89a17.75,17.75,0,0,0-.55-1.75c-.17-.45-.36-.9-.56-1.34a4.64,4.64,0,0,0-1.52-2,.61.61,0,0,0-.6-.11c-.21.1-.25.38-.26.61l-.27,3.93a11.52,11.52,0,0,0,0,2.42,5.82,5.82,0,0,0,1.34,3,12.09,12.09,0,0,0,1.59,1.44c.43.34.87.67,1.28,1A5.62,5.62,0,0,0,108,182Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.74,173.75a5.05,5.05,0,0,0-.12-.56,3.83,3.83,0,0,0-.48-1.14c-.11-.17-.17-.37-.27-.55a1.87,1.87,0,0,0-.4-.49.77.77,0,0,0-.33-.18.36.36,0,0,0-.36.1.56.56,0,0,0-.09.31,11.1,11.1,0,0,1-.41,2.08,7,7,0,0,1-.36,1,1.65,1.65,0,0,1-.19.27,1.18,1.18,0,0,0-.11.19,6.2,6.2,0,0,1-.54.94,5.25,5.25,0,0,1-.53.62,11.67,11.67,0,0,0-1.83,1.82c-.7,1.09-.58,2.49-.61,3.73,0,.21,0,.42,0,.64a17.83,17.83,0,0,0,.16,4.84c0,.12.16.4.34.29l.19-.12a6.24,6.24,0,0,0,1.9-2.82c.12-.27.22-.56.33-.83a2.36,2.36,0,0,1,.4-.54c.41-.53.77-1.13,1.13-1.7a17.28,17.28,0,0,0,1.8-3.66,9.68,9.68,0,0,0,.5-2.92A7.28,7.28,0,0,0,115.74,173.75Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,187.13c.32,0,.64,0,1,0,.66,0,1.32,0,2,0h1c.12,0,.22,0,.34,0a2.57,2.57,0,0,0,.48,0l.09,0s0-.09.05-.14a2.88,2.88,0,0,0-.32-1.31,2.63,2.63,0,0,0-.38-.56,5.16,5.16,0,0,0-1.7-1.34,8.68,8.68,0,0,0-2-.59L99.08,182a.75.75,0,0,0-.72.09.71.71,0,0,0-.13.4,4,4,0,0,0,1.83,3.47A7.66,7.66,0,0,0,104,187.13Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.89,193.76a3.26,3.26,0,0,0-.64-.79,4.31,4.31,0,0,0-1.26-.85,14.53,14.53,0,0,0-2.44-.71,28.62,28.62,0,0,1-5.52-2,.82.82,0,0,0-.37-.1c-.32,0-.44.42-.46.74a4.59,4.59,0,0,0,2.41,4.22c1.49.77,3.26.65,4.94.59h.07a13.67,13.67,0,0,1,1.81,0,6.85,6.85,0,0,1,.89.14c.24.06.69.32.85,0a.69.69,0,0,0,0-.38,2.7,2.7,0,0,0-.3-.88Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.71,194.23a1.5,1.5,0,0,1-.25.19.56.56,0,0,1-.21.06.32.32,0,0,1-.28-.14,1.29,1.29,0,0,1-.09-.16,2.52,2.52,0,0,1-.15-.34,3.71,3.71,0,0,1-.18-.73l0-.18c0-.28-.06-.56-.08-.84l-.06-.42a1.56,1.56,0,0,1,0-.31,2.18,2.18,0,0,0,0-.51,4.42,4.42,0,0,1,0-.63c.16-1.85,1.51-3.35,2.62-4.84a22.89,22.89,0,0,0,2.56-4.35c.15-.34.4-.75.77-.69s.45.36.54.64a9.86,9.86,0,0,1-.15,6.19,13.6,13.6,0,0,1-1.7,3.33,18.3,18.3,0,0,1-1.15,1.48c-.12.14-.23.29-.35.42-.39.42-.78.83-1.18,1.23l-.49.49Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.3,199.36a15.4,15.4,0,0,0-3.82-.75,9,9,0,0,1-3.72-1.11.68.68,0,0,0-.38-.16c-.27,0-.41.33-.44.6a3.62,3.62,0,0,0,.62,2.28,6.87,6.87,0,0,0,6.83,3.12h0c.85-.14,1.66-.44,2.51-.53a4.42,4.42,0,0,1,.63,0c.14,0,.35.09.46,0s0-.58-.1-.82a2.76,2.76,0,0,0-.37-.82,4.41,4.41,0,0,0-1.3-1.28A5.55,5.55,0,0,0,108.3,199.36Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.38,207c-1.29-.33-2.63-.39-3.88-.84-.56-.2-1.09-.47-1.64-.69-.16-.07-.36-.12-.47,0a.45.45,0,0,0-.09.28,4.38,4.38,0,0,0,2,3.57,7.27,7.27,0,0,0,4,1.14c.84,0,1.69-.07,2.54,0a1.92,1.92,0,0,1,.59.1c.1,0,.16.15.26.18.38.13.43-.41.39-.64a3,3,0,0,0-.51-1.23,2.38,2.38,0,0,0-.43-.52,1.39,1.39,0,0,0-.21-.11c-.37-.18-.67-.48-1-.68A6.76,6.76,0,0,0,108.38,207Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.44,202.27a5,5,0,0,1,1,.49,10.69,10.69,0,0,1,.89.75c.15,2.13.25,4.25.34,6.38a2.74,2.74,0,0,0-.46-.4,3.94,3.94,0,0,0-1.39-.65c-1.24-.32-2.55-.14-3.77-.55-.06,0-.08.11,0,.14a23.86,23.86,0,0,0,3.45.76,4.6,4.6,0,0,1,1.33.52,2.23,2.23,0,0,1,.55.42,3.1,3.1,0,0,1,.35.46c.14,3.44.29,6.89.67,10.32a57.68,57.68,0,0,0,.93,5.84c.2,1,.45,1.91.73,2.85q.24.83.54,1.65a9.1,9.1,0,0,0,.53,1.14h.62c0-.26-.1-.53-.17-.78l-.42-1.4q-.37-1.28-.66-2.58-.6-2.65-1-5.35c-.46-3.62-.62-7.26-.77-10.9s-.32-7.31-.7-10.95c-.23-2.2-.55-4.39-.94-6.57a11.17,11.17,0,0,1,1.4-3.11,27.09,27.09,0,0,0,2.14-3.92c0-.05,0-.15-.07-.07a39.49,39.49,0,0,1-2.65,3.69,9.2,9.2,0,0,0-1.06,2.1c-.21-1.08-.43-2.15-.68-3.23-.15-.67-.32-1.34-.5-2,.06-.38.12-.75.15-1.12a13.11,13.11,0,0,1,.2-1.38,14.16,14.16,0,0,1,.85-2.63c.7-1.67,1.9-3.11,2.45-4.84,0-.08-.08-.21-.12-.09a10.61,10.61,0,0,1-1.57,2.55,12,12,0,0,0-1.51,2.46,11.37,11.37,0,0,0-.78,2.69c0,.24-.08.49-.11.74A64.21,64.21,0,0,0,106,177c0-.09-.12,0-.1.11.95,3.12,1.84,6.27,2.62,9.45l-.17-.12a6.44,6.44,0,0,0-1.38-.65c-1.23-.43-2.5-.71-3.74-1.09-.07,0-.1.16,0,.18,1.16.4,2.3.83,3.45,1.25a9.23,9.23,0,0,1,1.33.58,3.62,3.62,0,0,1,.61.41.52.52,0,0,1,.1.11c.6,2.46,1.12,4.95,1.54,7.45a5.58,5.58,0,0,0-3.12-1.7c-.84-.17-1.71-.21-2.57-.32a8,8,0,0,1-2.39-.75s-.06.08,0,.11c1.17,1.07,3.08,1.11,4.57,1.36a6.28,6.28,0,0,1,2.3.78,4.89,4.89,0,0,1,1.4,1.43c.21,1.26.39,2.51.54,3.78s.24,2.34.32,3.51a3.85,3.85,0,0,0-1.31-.92,8.18,8.18,0,0,0-2.28-.66c-1.58-.26-3.26-.31-4.62-1.28,0,0,0,0,0,.05a8,8,0,0,0,4.21,1.67A12.8,12.8,0,0,1,109.44,202.27Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.44,202.27a5,5,0,0,1,1,.49,10.69,10.69,0,0,1,.89.75c.15,2.13.25,4.25.34,6.38a2.74,2.74,0,0,0-.46-.4,3.94,3.94,0,0,0-1.39-.65c-1.24-.32-2.55-.14-3.77-.55-.06,0-.08.11,0,.14a23.86,23.86,0,0,0,3.45.76,4.6,4.6,0,0,1,1.33.52,2.23,2.23,0,0,1,.55.42,3.1,3.1,0,0,1,.35.46c.14,3.44.29,6.89.67,10.32a57.68,57.68,0,0,0,.93,5.84c.2,1,.45,1.91.73,2.85q.24.83.54,1.65a9.1,9.1,0,0,0,.53,1.14h.62c0-.26-.1-.53-.17-.78l-.42-1.4q-.37-1.28-.66-2.58-.6-2.65-1-5.35c-.46-3.62-.62-7.26-.77-10.9s-.32-7.31-.7-10.95c-.23-2.2-.55-4.39-.94-6.57a11.17,11.17,0,0,1,1.4-3.11,27.09,27.09,0,0,0,2.14-3.92c0-.05,0-.15-.07-.07a39.49,39.49,0,0,1-2.65,3.69,9.2,9.2,0,0,0-1.06,2.1c-.21-1.08-.43-2.15-.68-3.23-.15-.67-.32-1.34-.5-2,.06-.38.12-.75.15-1.12a13.11,13.11,0,0,1,.2-1.38,14.16,14.16,0,0,1,.85-2.63c.7-1.67,1.9-3.11,2.45-4.84,0-.08-.08-.21-.12-.09a10.61,10.61,0,0,1-1.57,2.55,12,12,0,0,0-1.51,2.46,11.37,11.37,0,0,0-.78,2.69c0,.24-.08.49-.11.74A64.21,64.21,0,0,0,106,177c0-.09-.12,0-.1.11.95,3.12,1.84,6.27,2.62,9.45l-.17-.12a6.44,6.44,0,0,0-1.38-.65c-1.23-.43-2.5-.71-3.74-1.09-.07,0-.1.16,0,.18,1.16.4,2.3.83,3.45,1.25a9.23,9.23,0,0,1,1.33.58,3.62,3.62,0,0,1,.61.41.52.52,0,0,1,.1.11c.6,2.46,1.12,4.95,1.54,7.45a5.58,5.58,0,0,0-3.12-1.7c-.84-.17-1.71-.21-2.57-.32a8,8,0,0,1-2.39-.75s-.06.08,0,.11c1.17,1.07,3.08,1.11,4.57,1.36a6.28,6.28,0,0,1,2.3.78,4.89,4.89,0,0,1,1.4,1.43c.21,1.26.39,2.51.54,3.78s.24,2.34.32,3.51a3.85,3.85,0,0,0-1.31-.92,8.18,8.18,0,0,0-2.28-.66c-1.58-.26-3.26-.31-4.62-1.28,0,0,0,0,0,.05a8,8,0,0,0,4.21,1.67A12.8,12.8,0,0,1,109.44,202.27Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.21,212.83a13.79,13.79,0,0,0-1.9-.91L97,210.13a.67.67,0,0,0-.63,0,.59.59,0,0,0-.2.45,4.66,4.66,0,0,0,.25,1.85,7.35,7.35,0,0,0,5.6,5c1.09.17,2.22,0,3.3.3.43.1,1.13.24,1.14-.41a1,1,0,0,0-.18-.46c-.1-.21-.15-.46-.24-.68a7,7,0,0,0-1.53-2.36A6.32,6.32,0,0,0,103.21,212.83Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.42,220.18a10.05,10.05,0,0,0-2.72-.68l-2.5-.4-1-.15-.14,0a.73.73,0,0,0-.41-.09c-.18,0-.21.15-.23.32a2.94,2.94,0,0,0,.09,1,3.6,3.6,0,0,0,1.06,1.71,6.21,6.21,0,0,0,3,1.38,11.15,11.15,0,0,0,2.7.21,2,2,0,0,0,1.89-.92c.32-.64-.25-1.24-.7-1.64A3.87,3.87,0,0,0,105.42,220.18Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.27,214.91a1.17,1.17,0,0,1,0-.53.64.64,0,0,1,.63-.31,1.3,1.3,0,0,1,.65.33,4.22,4.22,0,0,1,1.06,2.83,9.79,9.79,0,0,1-.11,3.15c-.19.76-.54,1.73-1.4,1.91a1.49,1.49,0,0,1-1.55-.74c-.49-.88-.06-2,.16-2.93a13.76,13.76,0,0,0,.52-3.31C108.28,215.17,108.28,215,108.27,214.91Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.45,226a12,12,0,0,0-3.3-.73l-1.25-.15a.82.82,0,0,0-.27,0c-.27.09-.29.47-.21.74a3.53,3.53,0,0,0,2.89,2,17.61,17.61,0,0,1,3.64.69c.26.11.68.29.86-.05s-.11-.48-.23-.7a3.82,3.82,0,0,0-1.22-1.34A5.43,5.43,0,0,0,106.45,226Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.93,224.53c.39-1,1.23-1.75,1.4-2.78a.55.55,0,0,1,.55.24,1.68,1.68,0,0,1,.22.59,11.53,11.53,0,0,1,.38,2.41,3.9,3.9,0,0,1-.63,2.31,1.39,1.39,0,0,1-1,.65,1.17,1.17,0,0,1-.94-.37c-.38-.42-.26-1-.24-1.53A4.67,4.67,0,0,1,108.93,224.53Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.23,222.45c.34.08.66.18,1,.28.3,1.58.61,3.16.92,4.74,0,.17.07.35.11.52l-.27-.2a3.25,3.25,0,0,0-.77-.38,1.58,1.58,0,0,0-.43-.1l-.4,0c-.1,0-.11.19,0,.21a4.33,4.33,0,0,1,.79.27,3.32,3.32,0,0,1,.68.34,4.21,4.21,0,0,1,.52.4c.22,1.18.44,2.37.74,3.53a11.65,11.65,0,0,0,.72,2.16c.1.22.22.43.34.64h.77a14.35,14.35,0,0,1-1-2.71c-.3-1.19-.53-2.41-.75-3.62a3.47,3.47,0,0,1,.19-.77,8.41,8.41,0,0,1,.35-.82c.06-.13.14-.26.2-.39a1.91,1.91,0,0,0,.17-.62s0-.06,0,0c-.34.11-.51.45-.69.74a5.74,5.74,0,0,0-.4.78c-.27-1.37-.54-2.75-.82-4.13h0c0-.23.09-.45.16-.67.14-.44.36-.84.54-1.27a6.19,6.19,0,0,0,.42-1.39,3.9,3.9,0,0,0,.1-1.36c0-.12-.13,0-.12.08.08.5-.33,1-.55,1.38s-.4.77-.6,1.16c-.09.18-.18.36-.26.54a13.22,13.22,0,0,0-1.09-3.79,6.16,6.16,0,0,0-1.43-1.81,6.63,6.63,0,0,0-1.13-.77,9.81,9.81,0,0,0-1.36-.53s-.08.09,0,.11c.34.23.66.49,1,.71a10.19,10.19,0,0,1,1.08.78,4.12,4.12,0,0,1,1.21,1.67,21.47,21.47,0,0,1,1,4,10.87,10.87,0,0,0-2-.34,6,6,0,0,1-2.05-.58c-.08-.05-.12.15-.06.19a4.85,4.85,0,0,0,2.07.82Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.23,222.45c.34.08.66.18,1,.28.3,1.58.61,3.16.92,4.74,0,.17.07.35.11.52l-.27-.2a3.25,3.25,0,0,0-.77-.38,1.58,1.58,0,0,0-.43-.1l-.4,0c-.1,0-.11.19,0,.21a4.33,4.33,0,0,1,.79.27,3.32,3.32,0,0,1,.68.34,4.21,4.21,0,0,1,.52.4c.22,1.18.44,2.37.74,3.53a11.65,11.65,0,0,0,.72,2.16c.1.22.22.43.34.64h.77a14.35,14.35,0,0,1-1-2.71c-.3-1.19-.53-2.41-.75-3.62a3.47,3.47,0,0,1,.19-.77,8.41,8.41,0,0,1,.35-.82c.06-.13.14-.26.2-.39a1.91,1.91,0,0,0,.17-.62s0-.06,0,0c-.34.11-.51.45-.69.74a5.74,5.74,0,0,0-.4.78c-.27-1.37-.54-2.75-.82-4.13h0c0-.23.09-.45.16-.67.14-.44.36-.84.54-1.27a6.19,6.19,0,0,0,.42-1.39,3.9,3.9,0,0,0,.1-1.36c0-.12-.13,0-.12.08.08.5-.33,1-.55,1.38s-.4.77-.6,1.16c-.09.18-.18.36-.26.54a13.22,13.22,0,0,0-1.09-3.79,6.16,6.16,0,0,0-1.43-1.81,6.63,6.63,0,0,0-1.13-.77,9.81,9.81,0,0,0-1.36-.53s-.08.09,0,.11c.34.23.66.49,1,.71a10.19,10.19,0,0,1,1.08.78,4.12,4.12,0,0,1,1.21,1.67,21.47,21.47,0,0,1,1,4,10.87,10.87,0,0,0-2-.34,6,6,0,0,1-2.05-.58c-.08-.05-.12.15-.06.19a4.85,4.85,0,0,0,2.07.82Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.58,176.49c1-2.13,2.85-3.84,3.6-6.07a.55.55,0,0,1,.16-.31.43.43,0,0,1,.57.06,1.22,1.22,0,0,1,.27.56,9.36,9.36,0,0,1,.21,5.11,18.63,18.63,0,0,1-.91,2.23,41.87,41.87,0,0,1-1.73,3.87,7.61,7.61,0,0,1-1.44,1.85c-.43.39-1.18,1.07-1.64.34a2,2,0,0,1-.18-1.07c0-.43,0-.86,0-1.29a16.81,16.81,0,0,1,.24-2.56,11.14,11.14,0,0,1,.71-2.43C130.49,176.68,130.54,176.59,130.58,176.49Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.15,184.54a11,11,0,0,0-1.4-3.23q-1.16-2-2.29-4c-.06-.1-.14-.22-.26-.22s-.22.11-.29.22a6.93,6.93,0,0,0-.31,6,16.06,16.06,0,0,0,3.44,5.1.63.63,0,0,0,.69.26.89.89,0,0,0,.45-.71.8.8,0,0,0,0-.27,3.94,3.94,0,0,1,0-.77q0-.48.06-1A6.43,6.43,0,0,0,127.15,184.54Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.15,183.13l2.21-1.1a.31.31,0,0,1,.19,0c.11,0,.16.14.18.25a3.34,3.34,0,0,1-.39,2.31,7.4,7.4,0,0,1-1.49,1.86A18.6,18.6,0,0,1,135,188a17.49,17.49,0,0,1-2.09,1.32,15.06,15.06,0,0,1-2.25,1,13.84,13.84,0,0,1-2.36.6c-.43.06-1,.14-1.08-.43a2.42,2.42,0,0,1,.43-1.46,6.54,6.54,0,0,1,1.38-1.54,19,19,0,0,1,2-1.55c.72-.47,1.46-.9,2.21-1.31s1.53-.8,2.3-1.19Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,191.49a15.57,15.57,0,0,0-.75-1.85,33.91,33.91,0,0,1-1.61-4.46c-.24,0-.45.18-.6.38a7.59,7.59,0,0,0-1.61,4.19,5.6,5.6,0,0,0,1.51,4.17c.78.79,1.84,1.33,2.4,2.29.1.18.21.39.41.45a.28.28,0,0,0,.31-.15c.06-.11,0-.22,0-.35,0-.38.09-.76.13-1.15a11.49,11.49,0,0,0,0-2.27A7.63,7.63,0,0,0,123,191.49Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.49,194.54a7.89,7.89,0,0,1,4.15-1.39,10.87,10.87,0,0,0,4.27-1.09.88.88,0,0,1,.46-.18c.43,0,.61.56.53,1a4,4,0,0,1-.83,1.63,7.74,7.74,0,0,1-1.22,1.34c-1.63,1.33-3.9,1.45-6,1.5l-1.52,0-.76,0a6,6,0,0,1-.73,0c-.39,0-.08-.49,0-.67.21-.38.41-.75.65-1.1A5.35,5.35,0,0,1,125.49,194.54Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.8,200.05a9,9,0,0,0-.91-1.8l-1.83-3c-.19-.32-.44-.67-.81-.68-.87,2.33-1.35,5-.23,7.25a11.26,11.26,0,0,0,1.41,2L119,205.7c.21.26.61.53,1,.34.16-.08.18-.28.22-.45a4.91,4.91,0,0,0,.09-.77,2.25,2.25,0,0,0,0-.58,8.43,8.43,0,0,1-.13-1.67A7.93,7.93,0,0,0,119.8,200.05Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.27,201.12a6.69,6.69,0,0,1,1.63-.62c.67-.14,1.36-.14,2-.23,1.11-.13,2.19-.48,3.29-.65a.64.64,0,0,1,.34,0,.56.56,0,0,1,.22.45,3.87,3.87,0,0,1-.57,2.14,7.72,7.72,0,0,1-5.15,3.77,18.63,18.63,0,0,1-3,.25,14.72,14.72,0,0,0-1.49.13c-.25,0-.5.08-.74.14a.67.67,0,0,1-.46,0c-.24-.11-.25-.45-.23-.67a2.61,2.61,0,0,1,.36-1,9.17,9.17,0,0,1,3.47-3.59Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.71,206.81a18.8,18.8,0,0,0-.31,3.08,10.08,10.08,0,0,0,.55,3.86,13.64,13.64,0,0,0,2.33,3.57.4.4,0,0,0,.2.16c.18,0,.31-.16.38-.33a9.06,9.06,0,0,0,.5-4.86,9,9,0,0,0-.74-2.41c-.16-.34-.4-.66-.54-1,0-.08,0-.17-.08-.26a6.2,6.2,0,0,0-.42-.75,9.64,9.64,0,0,1-.74-1.68.93.93,0,0,0-.32-.53.33.33,0,0,0-.36,0c-.13.07-.11.19-.16.31a3,3,0,0,0-.19.41A2.42,2.42,0,0,0,114.71,206.81Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.37,210.68a5.47,5.47,0,0,1,1.6-1.81,6.64,6.64,0,0,1,1.73-.74l4.52-1.46a5.57,5.57,0,0,1-1.64,4.58,16.09,16.09,0,0,1-3.87,2.84c-1,.58-2,1-2.58,1.39-.24.17-.49.34-.73.53s-.53.44-.73.22,0-.28,0-.4.07-.35.11-.52l.18-.65c.07-.22.12-.43.17-.65l.06-.31a10.33,10.33,0,0,1,.45-1.56A11.11,11.11,0,0,1,120.37,210.68Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.19,187.71a37.18,37.18,0,0,0-4,1.94l-.79.44.06-.11a40.17,40.17,0,0,0,3.13-6.17,34.89,34.89,0,0,0,1.07-3.33c.31-1.16.47-2.33.67-3.52,0-.14-.13-.24-.17-.06-.25,1.07-.64,2.11-1,3.15s-.71,2-1.13,3a46.56,46.56,0,0,1-2.84,5.59l-.43.71v-.47a9.93,9.93,0,0,0-.18-2,12.61,12.61,0,0,0-.49-1.8,4,4,0,0,0-.84-1.66c-.06-.06-.12,0-.11.11a14,14,0,0,0,.6,1.64,9.55,9.55,0,0,1,.4,1.76,12.2,12.2,0,0,1,.09,1.81,12,12,0,0,0-.08,1.58c-.77,1.28-1.54,2.56-2.23,3.89-.32.6-.61,1.21-.9,1.82l0-.08a11.52,11.52,0,0,0-.75-2,18,18,0,0,1-1.72-4.64c0-.08-.1,0-.09,0a12.66,12.66,0,0,0,1,4.14c.26.72.5,1.45.7,2.19a10,10,0,0,1,.21,1.09c0,.19,0,.37.06.55l-.09.22a1.94,1.94,0,0,0-.28.66c-.2.47-.39.94-.58,1.41q-1,2.59-1.75,5.25a11.21,11.21,0,0,0-.53-1.93,10.6,10.6,0,0,0-.87-1.87,6.32,6.32,0,0,0-1.25-1.76c-.07-.05-.09.11-.08.14.27.61.68,1.14.94,1.76a16.23,16.23,0,0,1,.68,1.8,25.71,25.71,0,0,1,.73,3.24,69.17,69.17,0,0,0-1.48,7.26c-.38-.94-.87-1.82-1.33-2.73-.07-.12-.16.06-.13.14a18.16,18.16,0,0,1,1.11,3.44c0,.24.1.47.13.71-.33,2.61-.54,5.24-.62,7.87,0,.39.05,2.78.09,4.27a26.08,26.08,0,0,0,.34,3.68,12.22,12.22,0,0,0,.5,1.77h.7a7.72,7.72,0,0,0-.12-.82,32.7,32.7,0,0,1-.58-6.14c0-.67,0-1.33,0-2,0-2.05.17-4.09.37-6.13a7,7,0,0,1,.82-1.61c.94-1.35,2.38-2.24,3.35-3.55.06-.08,0-.37-.11-.28a16.06,16.06,0,0,0-2.2,1.66,8.59,8.59,0,0,0-1.63,1.67c.15-1.19.32-2.38.53-3.57s.51-2.62.82-3.92a5.47,5.47,0,0,0,.49-.59c.22-.28.42-.57.65-.84a6.87,6.87,0,0,1,1.55-1.29,6.34,6.34,0,0,1,1.66-.74,8.08,8.08,0,0,1,.85-.2,3,3,0,0,0,.89-.2s.05-.12,0-.15a3.41,3.41,0,0,0-2.14,0,6.78,6.78,0,0,0-2,.79,6.69,6.69,0,0,0-1.49,1.27q.75-2.76,1.74-5.43.6-1.59,1.29-3.12a5,5,0,0,1,1.18-.68,18.67,18.67,0,0,1,1.79-.58,10.14,10.14,0,0,0,1.68-.67c.07,0,.08-.22,0-.2-.69.19-1.44.25-2.15.38a9,9,0,0,0-1.92.54c.69-1.45,1.43-2.86,2.22-4.26a6.94,6.94,0,0,1,.86-1,10.07,10.07,0,0,1,1.64-1,40,40,0,0,0,3.44-2.1C132.32,187.89,132.3,187.67,132.19,187.71Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.19,187.71a37.18,37.18,0,0,0-4,1.94l-.79.44.06-.11a40.17,40.17,0,0,0,3.13-6.17,34.89,34.89,0,0,0,1.07-3.33c.31-1.16.47-2.33.67-3.52,0-.14-.13-.24-.17-.06-.25,1.07-.64,2.11-1,3.15s-.71,2-1.13,3a46.56,46.56,0,0,1-2.84,5.59l-.43.71v-.47a9.93,9.93,0,0,0-.18-2,12.61,12.61,0,0,0-.49-1.8,4,4,0,0,0-.84-1.66c-.06-.06-.12,0-.11.11a14,14,0,0,0,.6,1.64,9.55,9.55,0,0,1,.4,1.76,12.2,12.2,0,0,1,.09,1.81,12,12,0,0,0-.08,1.58c-.77,1.28-1.54,2.56-2.23,3.89-.32.6-.61,1.21-.9,1.82l0-.08a11.52,11.52,0,0,0-.75-2,18,18,0,0,1-1.72-4.64c0-.08-.1,0-.09,0a12.66,12.66,0,0,0,1,4.14c.26.72.5,1.45.7,2.19a10,10,0,0,1,.21,1.09c0,.19,0,.37.06.55l-.09.22a1.94,1.94,0,0,0-.28.66c-.2.47-.39.94-.58,1.41q-1,2.59-1.75,5.25a11.21,11.21,0,0,0-.53-1.93,10.6,10.6,0,0,0-.87-1.87,6.32,6.32,0,0,0-1.25-1.76c-.07-.05-.09.11-.08.14.27.61.68,1.14.94,1.76a16.23,16.23,0,0,1,.68,1.8,25.71,25.71,0,0,1,.73,3.24,69.17,69.17,0,0,0-1.48,7.26c-.38-.94-.87-1.82-1.33-2.73-.07-.12-.16.06-.13.14a18.16,18.16,0,0,1,1.11,3.44c0,.24.1.47.13.71-.33,2.61-.54,5.24-.62,7.87,0,.39.05,2.78.09,4.27a26.08,26.08,0,0,0,.34,3.68,12.22,12.22,0,0,0,.5,1.77h.7a7.72,7.72,0,0,0-.12-.82,32.7,32.7,0,0,1-.58-6.14c0-.67,0-1.33,0-2,0-2.05.17-4.09.37-6.13a7,7,0,0,1,.82-1.61c.94-1.35,2.38-2.24,3.35-3.55.06-.08,0-.37-.11-.28a16.06,16.06,0,0,0-2.2,1.66,8.59,8.59,0,0,0-1.63,1.67c.15-1.19.32-2.38.53-3.57s.51-2.62.82-3.92a5.47,5.47,0,0,0,.49-.59c.22-.28.42-.57.65-.84a6.87,6.87,0,0,1,1.55-1.29,6.34,6.34,0,0,1,1.66-.74,8.08,8.08,0,0,1,.85-.2,3,3,0,0,0,.89-.2s.05-.12,0-.15a3.41,3.41,0,0,0-2.14,0,6.78,6.78,0,0,0-2,.79,6.69,6.69,0,0,0-1.49,1.27q.75-2.76,1.74-5.43.6-1.59,1.29-3.12a5,5,0,0,1,1.18-.68,18.67,18.67,0,0,1,1.79-.58,10.14,10.14,0,0,0,1.68-.67c.07,0,.08-.22,0-.2-.69.19-1.44.25-2.15.38a9,9,0,0,0-1.92.54c.69-1.45,1.43-2.86,2.22-4.26a6.94,6.94,0,0,1,.86-1,10.07,10.07,0,0,1,1.64-1,40,40,0,0,0,3.44-2.1C132.32,187.89,132.3,187.67,132.19,187.71Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.23,228a8.57,8.57,0,0,0-.31-2.07,4.57,4.57,0,0,0-1.39-2.48,1.8,1.8,0,0,0-1.39-.39c.15,1,.29,2,.43,3,0,.1,0,.21.05.31a5.37,5.37,0,0,0,.68,2.15,2.87,2.87,0,0,0,.39.39,4.46,4.46,0,0,0,.86.7l.15.09a.62.62,0,0,0,.23.07c.28,0,.24-.44.26-.62a8.21,8.21,0,0,0,0-1S122.23,228.08,122.23,228Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.93,224.33a7.88,7.88,0,0,0,1.57-.9c.11-.08.25-.16.37-.09a.31.31,0,0,1,.12.19,2.48,2.48,0,0,1-.64,2.06,8.26,8.26,0,0,1-1.9,1.83,5.67,5.67,0,0,1-2.4.94c-.5.07-1.62.16-1.41-.66a3,3,0,0,1,.49-.9,9.13,9.13,0,0,1,.8-1,7.55,7.55,0,0,1,2.67-1.38Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.07,218.94a8.48,8.48,0,0,1,5.49.19,2.35,2.35,0,0,1,1.18.73,1,1,0,0,1-.07,1.27,1.27,1.27,0,0,1-.54.21l-8.53,2.1a2.28,2.28,0,0,1-.69.07c-.11,0-.21-.08-.31-.09s-.18,0-.24-.07a.38.38,0,0,1,0-.21,2.44,2.44,0,0,1,.05-.53.9.9,0,0,1,.08-.23c.1-.19.17-.38.26-.57a5.66,5.66,0,0,1,1.89-2.14A5.93,5.93,0,0,1,127.07,218.94Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.59,213.83a11,11,0,0,1,4.83-.89.32.32,0,0,1,.27.06.32.32,0,0,1,.07.19,2.49,2.49,0,0,1-.79,2,6.34,6.34,0,0,1-2.1,1.56,13.22,13.22,0,0,1-2.41.75l-2.21.53c-.14,0-.48.21-.61.11s0-.56,0-.7a4.35,4.35,0,0,1,.41-.84,6.25,6.25,0,0,1,.94-1.49A5.49,5.49,0,0,1,128.59,213.83Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.59,218.55a.15.15,0,0,0-.14,0,.13.13,0,0,0-.06.1,1.53,1.53,0,0,0-.07.36v.1a1.67,1.67,0,0,1-.06.29,3.71,3.71,0,0,0-.06.67,3.37,3.37,0,0,0,.09.71,5,5,0,0,0,.69,1.57,2,2,0,0,0,.24.33c.1.12.22.22.32.32a4.41,4.41,0,0,1,.61.81c0,.08.12.17.21.15a.22.22,0,0,0,.13-.1,1.12,1.12,0,0,0,.21-.34c0-.14.06-.27.08-.41V223a5,5,0,0,0-.69-3A5.28,5.28,0,0,0,120.59,218.55Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3,220.74a4.09,4.09,0,0,0-2.14,0,9.85,9.85,0,0,0-2.25.66,5.77,5.77,0,0,0-1.25.77,13.79,13.79,0,0,1,2-3.12,15.61,15.61,0,0,1,3.15-3c.05,0,.05-.2,0-.16a11.39,11.39,0,0,0-3.21,2.07,11.8,11.8,0,0,0-2.37,3.15,13.06,13.06,0,0,0-.74,1.67l-.1-.34a5.59,5.59,0,0,0-.47-1,2.85,2.85,0,0,0-.31-.46c-.07-.09-.17-.26-.3-.24s0,0,0,.07a1.3,1.3,0,0,0,.2.49l.21.41a9,9,0,0,1,.34.86c.1.31.15.62.23.93a10.7,10.7,0,0,0-.31,1.24,16.56,16.56,0,0,0-.26,2.43c-.07-.17-.14-.35-.22-.52a6.75,6.75,0,0,0-.83-1.29c-.07-.08-.12.1-.08.16a6.79,6.79,0,0,1,1,2.72l.09.5c0,.28,0,.55,0,.83,0,1,0,2,0,3,0,.71-.08,1.41-.13,2.11h.66a14,14,0,0,0,.34-3.59c0-.93,0-1.86,0-2.79l0,0a2.84,2.84,0,0,1,.5-.23,6.55,6.55,0,0,0,1-.46,6.92,6.92,0,0,0,1.8-1.37s0-.17,0-.11a4.23,4.23,0,0,1-2,1.08c-.39.1-.78.22-1.16.33l-.18.06c0-.43,0-.86.08-1.29a12.88,12.88,0,0,1,.41-2.23c.3-.32.53-.73.84-1a5.85,5.85,0,0,1,1.45-1,10.12,10.12,0,0,1,1.86-.69l1-.27a3.09,3.09,0,0,1,1.15-.22C129.34,220.9,129.36,220.77,129.3,220.74Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3,220.74a4.09,4.09,0,0,0-2.14,0,9.85,9.85,0,0,0-2.25.66,5.77,5.77,0,0,0-1.25.77,13.79,13.79,0,0,1,2-3.12,15.61,15.61,0,0,1,3.15-3c.05,0,.05-.2,0-.16a11.39,11.39,0,0,0-3.21,2.07,11.8,11.8,0,0,0-2.37,3.15,13.06,13.06,0,0,0-.74,1.67l-.1-.34a5.59,5.59,0,0,0-.47-1,2.85,2.85,0,0,0-.31-.46c-.07-.09-.17-.26-.3-.24s0,0,0,.07a1.3,1.3,0,0,0,.2.49l.21.41a9,9,0,0,1,.34.86c.1.31.15.62.23.93a10.7,10.7,0,0,0-.31,1.24,16.56,16.56,0,0,0-.26,2.43c-.07-.17-.14-.35-.22-.52a6.75,6.75,0,0,0-.83-1.29c-.07-.08-.12.1-.08.16a6.79,6.79,0,0,1,1,2.72l.09.5c0,.28,0,.55,0,.83,0,1,0,2,0,3,0,.71-.08,1.41-.13,2.11h.66a14,14,0,0,0,.34-3.59c0-.93,0-1.86,0-2.79l0,0a2.84,2.84,0,0,1,.5-.23,6.55,6.55,0,0,0,1-.46,6.92,6.92,0,0,0,1.8-1.37s0-.17,0-.11a4.23,4.23,0,0,1-2,1.08c-.39.1-.78.22-1.16.33l-.18.06c0-.43,0-.86.08-1.29a12.88,12.88,0,0,1,.41-2.23c.3-.32.53-.73.84-1a5.85,5.85,0,0,1,1.45-1,10.12,10.12,0,0,1,1.86-.69l1-.27a3.09,3.09,0,0,1,1.15-.22C129.34,220.9,129.36,220.77,129.3,220.74Z",
    style: {
      opacity: 0.5
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.82,256.1l7.06-40.7,4.47-.23-9.28,40.93h0a.61.61,0,0,1-.3.4,1.78,1.78,0,0,1-1.59.08.53.53,0,0,1-.35-.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.21,208.71h4.47L346.19,251h0a.55.55,0,0,1-.33.49,1.72,1.72,0,0,1-1.59,0,.58.58,0,0,1-.32-.38h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.29,275.5l.2-45.59,4.47-.22-2.42,45.81h0a.61.61,0,0,1-.3.4,1.78,1.78,0,0,1-1.59.08.54.54,0,0,1-.35-.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.81,194.52h4.47l7.16,44.93h0a.55.55,0,0,1-.33.49,1.72,1.72,0,0,1-1.59,0,.6.6,0,0,1-.32-.38h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.08,159.33a25.35,25.35,0,0,1,1.79,7.85c.51,6-1.53,25.5-2.75,34.21h0c-1.77,14.56-3.94,14.59-7.09,17-5.43,4.2-21,12.41-26.18,14.44-9.34,3.68-17-2-22.67-4.8a132.8,132.8,0,0,1-15.08-8.93c-1.42-1-2.16-2.09-2.14-3.19,0-.43,0-2.22,0-2.68,0-1.41,1.24-2.92,3.86-4.61,4.82-3.13,22.25-13.3,29-17a.06.06,0,0,1,.06-.05c5.19-3.16,8.32-24.61,11.92-36,.08-.24.15-.48.23-.71s.13-.36.19-.53c.23-.62.46-1.19.71-1.71",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,213.24c0-1.41,1.24-2.92,3.86-4.61,4.82-3.13,22.25-13.3,29-17a.06.06,0,0,1,.06-.05c5.19-3.16,8.32-24.61,11.92-36,0-.11.29-1,.76-2.1l.06-.15c.07-.15.13-.31.21-.47a2.29,2.29,0,0,1,.1-.23h0a11.09,11.09,0,0,1,2.41-3.47,5.49,5.49,0,0,1,1.17-.83c.59-.33,1.82-1,2.12-1.19,3.53-2.11,8.16.42,13.94,3.58,3.59,2,6.65,4.31,8.51,8.67h0a25.35,25.35,0,0,1,1.79,7.85c.51,6-1.53,25.5-2.75,34.21h0c-1.77,14.56-3.94,14.59-7.09,17-5.43,4.2-21,12.41-26.18,14.44-9.34,3.68-17-2-22.67-4.8a132.8,132.8,0,0,1-15.08-8.93c-1.42-1-2.16-2.09-2.14-3.19C270,215.49,270,213.7,270,213.24Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,213.24c0-1.41,1.24-2.92,3.86-4.61,4.82-3.13,22.25-13.3,29-17a.06.06,0,0,1,.06-.05c5.19-3.16,8.32-24.61,11.92-36,0-.11.29-1,.76-2.1l.06-.15c.07-.15.13-.31.21-.47a2.29,2.29,0,0,1,.1-.23h0a11.09,11.09,0,0,1,2.41-3.47,5.49,5.49,0,0,1,1.17-.83c.59-.33,1.82-1,2.12-1.19,3.53-2.11,8.16.42,13.94,3.58,3.59,2,6.65,4.31,8.51,8.67h0a25.35,25.35,0,0,1,1.79,7.85c.51,6-1.53,25.5-2.75,34.21h0c-1.77,14.56-3.94,14.59-7.09,17-5.43,4.2-21,12.41-26.18,14.44-9.34,3.68-17-2-22.67-4.8a132.8,132.8,0,0,1-15.08-8.93c-1.42-1-2.16-2.09-2.14-3.19C270,215.49,270,213.7,270,213.24Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.18,225.33a132.8,132.8,0,0,1-15.08-8.93c-3.23-2.35-2.93-4.76,1.71-7.77,6.44-4.18,32.72-19.09,32.72-19.09s33.22,19.6,31.79,23.22-22,14.82-28.47,17.37C300.51,233.81,292.87,228.14,287.18,225.33Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.18,225.33a132.8,132.8,0,0,1-15.08-8.93c-3.23-2.35-2.93-4.76,1.71-7.77,6.44-4.18,32.72-19.09,32.72-19.09s33.22,19.6,31.79,23.22-22,14.82-28.47,17.37C300.51,233.81,292.87,228.14,287.18,225.33Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.51,148.27c3.5-1.83,8,.66,13.67,3.74,3.6,2,6.66,4.32,8.53,8.69l2.37-1.37c-1.86-4.36-4.92-6.7-8.51-8.66-5.78-3.17-10.41-5.7-13.94-3.59C321.33,147.26,320.1,147.94,319.51,148.27Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.51,148.27c3.5-1.83,8,.66,13.67,3.74,3.6,2,6.66,4.32,8.53,8.69l2.37-1.37c-1.86-4.36-4.92-6.7-8.51-8.66-5.78-3.17-10.41-5.7-13.94-3.59C321.33,147.26,320.1,147.94,319.51,148.27Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.88,191.54s3.38,1.11,15.47,7c5,2.44,8.22,4.89,12.87,7.82,6.83,4.3,6.31,7.49,6.31,7.49,3.4-2.81,6.78-35.48,6-45.36a24.88,24.88,0,0,0-2-8.23l-.27-.57-.21-.39a1.74,1.74,0,0,0-.1-.19,14.44,14.44,0,0,0-.86-1.37l-.22-.32-.24-.31-.24-.31-.21-.24a14.8,14.8,0,0,0-1.23-1.27c-.11-.11-.21-.21-.32-.3a21.75,21.75,0,0,0-2.17-1.65c-.11-.08-.23-.15-.35-.22l-.47-.3-.4-.24-1.06-.61c-4.3-2.35-8-4.36-11-4.36a5.72,5.72,0,0,0-3.82,1.45c-2.26,2-3.46,6.18-3.54,6.42C311.2,166.93,308.07,188.38,302.88,191.54Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.88,191.54s3.38,1.11,15.47,7c5,2.44,8.22,4.89,12.87,7.82,6.83,4.3,6.31,7.49,6.31,7.49,3.4-2.81,6.78-35.48,6-45.36a24.88,24.88,0,0,0-2-8.23l-.27-.57-.21-.39a1.74,1.74,0,0,0-.1-.19,14.44,14.44,0,0,0-.86-1.37l-.22-.32-.24-.31-.24-.31-.21-.24a14.8,14.8,0,0,0-1.23-1.27c-.11-.11-.21-.21-.32-.3a21.75,21.75,0,0,0-2.17-1.65c-.11-.08-.23-.15-.35-.22l-.47-.3-.4-.24-1.06-.61c-4.3-2.35-8-4.36-11-4.36a5.72,5.72,0,0,0-3.82,1.45c-2.26,2-3.46,6.18-3.54,6.42C311.2,166.93,308.07,188.38,302.88,191.54Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bean-bag--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.91,299.87c13.19,7.62,32.29,25.64,32.29,58.14s-15.36,56.67-44.78,67.47c-15.74,5.77-40.95,6.07-57.17.29-16.52-8.46-27.65-17.15-33.71-32.94-6.24-18.31,4.93-37.49,20.12-48.45S368,320.93,378.77,308c5.78-7,14.28-12.94,24.65-14.1C414.74,292.6,427.87,294.08,437.91,299.87Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.91,299.87c13.19,7.62,32.29,25.64,32.29,58.14s-15.36,56.67-44.78,67.47c-15.74,5.77-40.95,6.07-57.17.29-16.52-8.46-27.65-17.15-33.71-32.94-6.24-18.31,4.93-37.49,20.12-48.45S368,320.93,378.77,308c5.78-7,14.28-12.94,24.65-14.1C414.74,292.6,427.87,294.08,437.91,299.87Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.94,412.69a30.73,30.73,0,0,0,9.66.36c3.1-.38,6.58-1,9.33.93,1.44,1,2.4,2.55,3.77,3.65,2.9,2.31,7.75,1.9,9.84-1.16a12.3,12.3,0,0,0,1.52-4q1.21-4.83,2.41-9.66a16.21,16.21,0,0,1,1.88-5c2-3.12,6-4.42,9.7-4.88s7.54-.29,11.09-1.46a15.59,15.59,0,0,0,7.08-4.81c2.84-3.41,4.5-5.46,8.75-7a42.82,42.82,0,0,1,12.69-2.7c3.47-.16,7.56,0,10.78,1.52,0,0-8.91-7.54-20.09-5.34,0,0,2.9-3.37,5-10.51,3.54-11.9,3.61-34-.14-45.16-5.44-16.21-28.19-17-28.19-17s-15.49-1.67-24,20.39-10.4,28-20.18,33.4c-4,2.24-8.82,3.22-12.57,5.9a17.73,17.73,0,0,0-2.68,26.72c2.5,2.65,7.94,5.39,5.14,9.76-1.18,1.85-3.21,2.93-5,4.17s-3.6,2.93-3.77,5.12a5.65,5.65,0,0,0,2.58,4.85A13.53,13.53,0,0,0,352.94,412.69Z",
    style: {
      fill: "#0B1D51",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.31,427.79a80.64,80.64,0,0,0,54-13C453,398.73,463.22,373.2,458.16,343c-4.48-26.72-17.84-41.43-31.25-47.52a46.69,46.69,0,0,1,8.64,3.19c10.86,7.92,20.52,22,24.21,44.06,5.18,30.91-5.31,57-29.54,73.5a81.31,81.31,0,0,1-40.34,13.58A91,91,0,0,1,375.31,427.79Z",
    style: {
      fill: "#0B1D51",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.5,387.06l-5.33-10.5-10.73,6.28,13.23,15.61s6.55-.6,7.61-4S373.31,388.2,371.5,387.06Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.06,391.19a5.58,5.58,0,0,1,1.48,1.62c.44.64.3,3.75.72,5.19a38.89,38.89,0,0,0,1.42,3.64c.76,2,2.17,3.83.58,9s-4.16,7.61-6.31,8.87a5.71,5.71,0,0,1-2.61.63s-2.82-1.07-2.39-2.74S379.06,391.19,379.06,391.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.65,396.84a6.2,6.2,0,0,0,1.12,1.78,14,14,0,0,1,1.83,5.15c1.67,8.15-1.57,12.29,2.82,15.35,1.27.8,3.91.58,7.91-4.56,2.05-2.62,3.22-8,2.42-10.46s-1.89-4-2.41-5.92-.24-5.38-1.28-7a7.48,7.48,0,0,0-2.55-2.19c-.77-.47-2.48-1.1-3.27-1.55s-1.23-1-1.74-.39l.92,1.14c1.43,2,1,2.27,1,3.32a17,17,0,0,0,.53,3.36c-1-1.29-1.43-2.41-2.54-2.21s-1.24.14-2.83,1.63S366.58,396.37,366.65,396.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.33,414.56c2.05-2.62,3.22-8,2.42-10.46a23.9,23.9,0,0,0-.94-2.37c0,.17.08.33.1.48,0,.31.1.63.13,1a7.39,7.39,0,0,1-.41,3.7c-.46,1-1.52,3.56-2.9,3.62-.77,0-1.43-.73-1.73-1.6-.12-.37-.33-1.36-.33-1.36A12.11,12.11,0,0,0,373.1,409c-2,1.32-1.91,1.61-1.91,1.61a5.28,5.28,0,0,1,.06,1.74,4.29,4.29,0,0,1-.74,1.74,2.65,2.65,0,0,1-.5.41,5.29,5.29,0,0,0,2.41,4.64C373.69,419.92,376.33,419.7,380.33,414.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.6,403.77a27,27,0,0,1,.51,6.51c.75,2.09,1.41,2,1.5,1s-1.35-5.57-2.43-9.28C369.35,402.56,369.48,403.18,369.6,403.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.56,390.7a4.52,4.52,0,0,0-.79-3,5.18,5.18,0,0,1-.53-.27c-.86-.49-1.23-1-1.74-.39l.92,1.14c1.43,2,1,2.27,1,3.32a16.81,16.81,0,0,0,.53,3.35c.84,3.54,1.59,4.73,2,8.07s-.27,5.59.2,5.78,1.42-.19,1.6-2.87-1-7.18-1.85-9.32S374.39,392.13,374.56,390.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.91,407.76a.38.38,0,0,1-.18.09,8,8,0,0,0-5.34,3.13.33.33,0,0,1-.51-.43,8.64,8.64,0,0,1,5.72-3.35.34.34,0,0,1,.31.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.48,405a.26.26,0,0,1-.16.09,9,9,0,0,0-5.63,3.42.34.34,0,0,1-.49,0,.34.34,0,0,1,0-.48,9.55,9.55,0,0,1,6-3.64.33.33,0,0,1,.41.25A.34.34,0,0,1,376.48,405Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.54,401.9a.32.32,0,0,1-.18.1,10.15,10.15,0,0,0-6.29,3.84.38.38,0,0,1-.54,0,.39.39,0,0,1,0-.53,11,11,0,0,1,6.7-4.08.37.37,0,0,1,.35.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.1,399.28a.4.4,0,0,1-.18.1,9.91,9.91,0,0,0-6.16,3.75.37.37,0,1,1-.56-.48,10.65,10.65,0,0,1,6.55-4,.36.36,0,0,1,.44.28A.38.38,0,0,1,376.1,399.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.13,396.73a.39.39,0,0,1-.18.1,9.87,9.87,0,0,0-6.15,3.75.37.37,0,0,1-.56-.48,10.66,10.66,0,0,1,6.55-4,.37.37,0,0,1,.34.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.61 387.9 361.66 393.58 357.73 396.05 362.22 404.53 374.85 398.48 368.61 387.9",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.76,350s-25.28-4.19-36.1-4.12c-11,.07-12.06,8.36-9.3,13.44C342.65,369,361,389.63,361,389.63s6.18-2.83,8.07-8.17l-4.19-9.62,13.2,4.22,6.74-4.52.55-3.44Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.76,350s-25.28-4.19-36.1-4.12c-11,.07-12.06,8.36-9.3,13.44C342.65,369,361,389.63,361,389.63s6.18-2.83,8.07-8.17l-4.19-9.62,13.2,4.22,6.74-4.52.55-3.44Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.76,350l43.76,7.29s.43,10.48-3.69,19.86a21.39,21.39,0,0,1-16.37,12.5,122.2,122.2,0,0,1-13.24,1.08,33.32,33.32,0,0,1-6.91,4.07c-3.49,1.38-18.73,7.76-18.73,7.76s-4.28-3.62-3.85-11.17l14.39-15.31c3.25-4,4.4-5.25,6.21-6.15C381.55,364.55,382.45,355.89,382.76,350Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.76,350l43.76,7.29s.43,10.48-3.69,19.86a21.39,21.39,0,0,1-16.37,12.5,122.2,122.2,0,0,1-13.24,1.08,33.32,33.32,0,0,1-6.91,4.07c-3.49,1.38-18.73,7.76-18.73,7.76s-4.28-3.62-3.85-11.17l14.39-15.31c3.25-4,4.4-5.25,6.21-6.15C381.55,364.55,382.45,355.89,382.76,350Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M362.72,363.65a95.45,95.45,0,0,1,5.57,9.26l-3.37-1.07c-3.8-9.06-4.58-11.7-10.66-15.94C354.26,355.9,358.62,357.54,362.72,363.65Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M396.45,385.63s-2.31,3.34-9.77,6.5c-4.19,1.78-17.17,6.86-21.11,7.79a10.18,10.18,0,0,0,2,2.62s15.24-6.38,18.73-7.76a23.63,23.63,0,0,0,2.22-1l.92-.51c.78-.45,1.49-.91,2.08-1.31s1.06-.73,1.35-1l.3-.22,0,0C396.5,387.85,396.45,385.63,396.45,385.63Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M380.29,373.5c-1.47,1.72-2.17,2.56-2.17,2.56l-2.11-.69s3.74-4.08,6.16-6.22a8.08,8.08,0,0,1,1.38-1.08c-1.22-3.21-1.17-8.46-1.17-8.46a16.91,16.91,0,0,0,3.19,7.68,14,14,0,0,1,6.07-.07l16.51,2.8s-11.76-1.06-17.88-1.3S381.77,371.77,380.29,373.5Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M341.81,400.47c-3,1.17-4.81,2.35-6.19,4.14s-1.79,3.62-.48,5.79,3.7,4.73,6.55,4.56a15.31,15.31,0,0,0,7.24-2.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.57,403c0,.89-3.72,2.67-7.62,4.53-4.18,2-5.21,3.29-8.62,5-3.9,1.92-5.39,2-8.41,1.19s-6.77-5.17-4.16-9.16c2.12-3.24,4.86-4.14,9-5.23a78.8,78.8,0,0,0,9.76-3.16c3-1.16,5.49-3.27,6.11-2.54-.43.21-3.58,2.16-3,2.68.14.28.59.19,1.37-.13a1.31,1.31,0,0,1,1.08-.05,2,2,0,0,1,.77.94,21.45,21.45,0,0,1,1,2.38c.23.55.13.24.35.79a5.89,5.89,0,0,1,.65,2.14c0,.34-.29.45-.55.62a10.23,10.23,0,0,0-.89.56c-.1.08-.28.33-.22.46s.63.12.86,0,.61-.18.88-.29S364.88,403.3,365.57,403Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.67,411.84c-.56.28-4.11,1.93-5.22.94s1.64-2.77,1.64-2.77.43-2.67-2.79-6.6c-.56.43-2.89.41-2.86-1s3.94-3.05,4-3.08c-4,1.07-6.62,2-8.67,5.14-2.61,4,1.13,8.32,4.16,9.16s4.51.73,8.41-1.19C349.72,412.29,350.32,412,350.67,411.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.71,409.74c-1.48.49-.46,1.84,1.7,1.4,3.24-.65,5.93-2.49,9.54-3.63,3.9-1.86,7.88-3.6,7.62-4.58-.7.26-2.19.88-2.19.88-.29.13-1.05.41-1.05.41-2.95,1.27-6.22,3.33-9.42,4.2C350.09,409.18,348.19,409.25,346.71,409.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.51,403.91c1.36-.78,1.59-1.45,4.24-2.67s7.13-3.82,9.9-5.43a34.6,34.6,0,0,0,3-2.23c-.46-.52-2.15,0-3.84,1s-2.72,1.74-4.39,2.61c-3.26,2-7,3.28-8.82,4.47S343.16,404.69,344.51,403.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.31,403.55a.36.36,0,0,0,.08.12,11.85,11.85,0,0,1,2.53,6.55.4.4,0,0,0,.37.36.32.32,0,0,0,.3-.38,12.38,12.38,0,0,0-2.75-7,.32.32,0,0,0-.48,0A.41.41,0,0,0,344.31,403.55Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.94,401.64a.39.39,0,0,0,.06.11,16.13,16.13,0,0,1,3.14,7.72.38.38,0,0,0,.38.36.33.33,0,0,0,.28-.39,16.63,16.63,0,0,0-3.33-8.18.32.32,0,0,0-.48,0A.38.38,0,0,0,346.94,401.64Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.71,409.2a.39.39,0,0,0,.31.23.32.32,0,0,0,.33-.35,19.44,19.44,0,0,0-3.35-9.33.32.32,0,0,0-.48,0,.42.42,0,0,0,0,.53s3,4.37,3.13,8.78A.41.41,0,0,0,352.71,409.2Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.14,407.65a.36.36,0,0,0,.3.23.31.31,0,0,0,.33-.34,13.93,13.93,0,0,0-3.53-8.86.31.31,0,0,0-.47,0,.4.4,0,0,0,.06.52,13.46,13.46,0,0,1,3.27,8.27A.32.32,0,0,0,355.14,407.65Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.28,406.32a.36.36,0,0,0,.3.23.31.31,0,0,0,.34-.33c0-4.93-3.49-8.74-3.64-8.9a.32.32,0,0,0-.48,0,.39.39,0,0,0,.05.52s3.37,3.73,3.39,8.3A.47.47,0,0,0,358.28,406.32Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.21,311.61c-2.17,3.06-8.59,15.5-8.59,15.5-2.24-2.74-4.91-6.12-7.16-9.05-3-3.84-4.18-4.66-5.65-10.55a18.16,18.16,0,0,0-2-4.09,12.86,12.86,0,0,1-1.44-4.37c-.06-.76-2-.59-2.4,1.82-.28,1.24.1,2.49.07,3.73,0,.37.17,1.18-.3,1.1-2.85-.49-4.87-3.8-8.23-6.2-1.22-.86-4.36-1.8-5.08,0-.07.44.24.75.34,1.14a.38.38,0,0,1,0,.15,2.42,2.42,0,0,1-.07.54c-.09.36-.25.7-.33,1.06a2.64,2.64,0,0,0,.14,1.64,5.81,5.81,0,0,1,.54,1.16,4.19,4.19,0,0,0,.24,2.26,9.07,9.07,0,0,0,1.05,1.77,6.75,6.75,0,0,1,.54,1.23,7.37,7.37,0,0,0,1.34,1.89,28.91,28.91,0,0,0,6.1,5.38c1,.64,2.15,1.19,3.13,1.93a9.24,9.24,0,0,1,1.92,1.93,19.3,19.3,0,0,1,1.72,3l0,.06c4.37,8.08,4.7,11,9.37,17.47,3.94,5.16,8.67,2.85,13.82-4,6.55-8.68,9.61-13.79,9.61-13.79l.6-21.57C390.05,304.1,387.38,308.55,385.21,311.61Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.08,307.76a8.17,8.17,0,0,0,1.93,7.09C357.41,314.06,356.45,310.66,358.08,307.76Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,302.27c-4.22.6-6.77,3.08-10.74,9.84-4.44,7.57-7.67,14.63-7.67,14.63L372.5,322c.88,1.7.94,6.77-1.31,9.41a9.19,9.19,0,0,1-5.45,3,58.46,58.46,0,0,0,3.95,6.93c2.08,3,3.45,3.81,5.3,3.86s4.84-.11,8.88-5.43c4.44-5.85,10.61-15.44,10.61-15.44Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.63,326.74c2.19,2.54,3.66,6.92,3.44,9.15,1-2.58,0-7.27-2.77-10.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.5,337.61a9.37,9.37,0,0,0,1.57-.44,8.9,8.9,0,0,0,2.8-1.72,9.56,9.56,0,0,0,2.95-5.42c0-.1.13-.07.12,0A8.78,8.78,0,0,1,372,336a9.48,9.48,0,0,1-3,1.73,10.39,10.39,0,0,1-1.35.38l-.26-.47Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.24,317.58c.59-11.75,3.24-15,9.2-15.65l9.84-1c2.92.6,13,3.8,16.35,5,2.18.76,3.11,5.38,3.58,12.63.38,5.88.44,10.82.24,18.95A117.94,117.94,0,0,1,425,361.51c-8.14,3.09-31.67.14-41-10.61.75-2.43,3.76-6.82,4.24-11.7C387.93,329,388.05,321.27,388.24,317.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.85,305.71l-7.35-2.59s-1.32,3.09-4.17,9-2.95,8.61-3.21,18.95-2.16,28.51-3.39,32.7c4.55.63,8.5,7.24,20.2,5.19,0,0,2.46-12,2.84-32.37C429,326,429,308.69,423.85,305.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.83,302.25c-4.18,1.63-7.25,6.28-8.24,12.7s-1.79,22.83-2.49,27.68-3.79,13.3-3.79,13.3-5.14-2.11-6.56-6.14a24,24,0,0,0,5-11.41c.41-4,0-16.93.64-21.86s1.13-11.74,7-14c2.52-1,8.45-1.37,8.45-1.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.14,318.66c.57-4.73,3.26-13.19,8.39-14.91a4.14,4.14,0,0,0,.3-1.5l-.05-2.46a21,21,0,0,0-4.36,2.14c-2.21,1.42-6,6-7,9.67C393.62,309.72,394.5,312.78,394.14,318.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.45,273.42a4.87,4.87,0,0,1,3.91,2.41c.88,1.27,1.7,3.67.66,11a28.87,28.87,0,0,1-2.4,8.23,3.56,3.56,0,0,1-1.83,1.88l-.55-5.45-.28-3.82s-3.4-2.38-4-5.06a8.82,8.82,0,0,1,.33-5.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.22,273.51c-.92-3-5.26-6.14-12.78-5.59-6.16.45-9.48,3-11.15,6.85s.31,8.29.31,8.29l19.07-3.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.41,292.43c-2.64,1.73-4.21-.33-4.21-.33l1.12,12.25c-4.49,7.92-19.27,6.84-14.05.67l-.41-3.44a19.86,19.86,0,0,1-2.47.05,6.54,6.54,0,0,1-5.9-4.17c-1.61-3.86-2.37-10.27-1.73-17.26.13-1.35.51-2.86,1.64-3.6,2.8-1.86,5.84-.08,10.21,1,1.81.46,6,.22,7.07-.44-1.25,1.79.12,5.84.68,7.11.8,1.83,1.71,2.65,2.12,2.68,1.75.14,1.76-1.35,2.43-2.25a3.16,3.16,0,0,1,5,.51A5.13,5.13,0,0,1,419.41,292.43Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.09,297c-.24,2.83-3.74,5.12-10,6.07l-.18-1.5a29.44,29.44,0,0,0,4.59-1A16.32,16.32,0,0,0,412.09,297Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.89,281.47l2.72,1.32a1.58,1.58,0,0,0-.73-2.07A1.47,1.47,0,0,0,403.89,281.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.52,283.74l2.54-1.67a1.45,1.45,0,0,0-2.06-.48A1.59,1.59,0,0,0,392.52,283.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.3,285.37a1.22,1.22,0,0,1-1.05,1.39,1.23,1.23,0,1,1,1.05-1.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.45,293.82a.93.93,0,0,1-1.84.26.93.93,0,0,1,1.84-.26Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.79,285.87a1.23,1.23,0,1,1-1.39-1.05A1.11,1.11,0,0,1,395.79,285.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.83,283.14l0,8.05-4.5-.92A16.29,16.29,0,0,1,399.83,283.14Z",
    style: {
      fill: "#f0997a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M409.53,321.82c1.14-9.28,5-9.76,5.93-6.71A18.85,18.85,0,0,0,418.92,304c-.92-1.6-1.77-3.58-2.08-4.19a1.59,1.59,0,0,0-1-.9l.26,3.28a15.77,15.77,0,0,1-3.31,6.11C410.73,310.78,410,314,409.53,321.82Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.1,371.07a7.37,7.37,0,0,1,1.18-1.39c4.52-4.18,13-9.71,20.23-14.31l32.84,19a.3.3,0,0,1,0,.52L385.5,388.62Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.14,361.43V362a2.19,2.19,0,0,0,1.09,1.89l38.18,22a2.15,2.15,0,0,0,1.09.29,2.26,2.26,0,0,0,1.1-.29l20.81-12A2.18,2.18,0,0,0,408.5,372v-.73h0a.25.25,0,0,1-.14.24l-22.85,13.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.5,384.73v1.45a2.15,2.15,0,0,1-1.09-.29l-38.18-22a2.19,2.19,0,0,1-1.09-1.89v-.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.14,361.43l22.64-13.07a1.26,1.26,0,0,1,1.3,0L408.35,371a.29.29,0,0,1,0,.51L385.5,384.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.71 382.81 397.92 375.77 362.22 355.15 349.94 362.16 385.71 382.81",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.94 362.16 350.41 362.43 362.22 355.69 397.45 376.04 397.92 375.77 362.22 355.15 349.94 362.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.71 363.22 391.49 363.35 385.5 366.8 374.86 360.66 374.64 360.53 380.85 356.95 391.71 363.22",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.49 363.35 385.5 366.8 374.86 360.66 380.85 357.2 391.49 363.35",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.69,365.82c1.91-1.9,4.69-4.53,7-5.31a15.94,15.94,0,0,1,1.64-.51,18.2,18.2,0,0,1-2.4-.48,4.22,4.22,0,0,1-2-1.34c-.2-.26-.35-.68-.09-.89a.55.55,0,0,1,.33-.12c1.75-.05,3.13-.33,4.72-.44a6.67,6.67,0,0,1,2.14,0c.65.18,1.3.37,1.94.59,2.9,1,5.65.73,9.65-1.1s18.45-10.73,18.45-10.73L418,362.47l-11.42,4.41h0l-.12.05a28.45,28.45,0,0,1-3.92,1.72c-2.59.8-5.9-.14-8.15-.26a24,24,0,0,0-8.14,1.76c-2.08.85-4.59-2.36-5.63-2S377.77,367.72,379.69,365.82Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.32,358.76a7.85,7.85,0,0,1,3.18.52,17.52,17.52,0,0,0-4.15.72,18.2,18.2,0,0,1-2.4-.48,4.39,4.39,0,0,1-1.83-1.12C385.37,359.25,387.81,358.92,389.32,358.76Z",
    style: {
      fill: "#f0997a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M384.89,385.05a2.57,2.57,0,0,1-2.23-.17l-38-21.95a2.56,2.56,0,0,1-1.26-1.8l-4.16-24.82a3,3,0,0,1,0-.43,2.56,2.56,0,0,1,.77-1.83l39.5,22.81a1.92,1.92,0,0,1,.93,1.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.5,384.73l-.26.15-.35.17-4.5-26.86a1.92,1.92,0,0,0-.93-1.33L340,334.05a2.11,2.11,0,0,1,.53-.4l39.58,22.85a1.92,1.92,0,0,1,.93,1.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,357.36l.61-.35a1.91,1.91,0,0,1,.37.82l4.5,26.9-.26.15-.35.17-4.5-26.86A1.88,1.88,0,0,0,380,357.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.48,362.14a8.43,8.43,0,0,0-3.83-4.93c-1.84-1.06-3.1-.57-2.83,1.09a8.41,8.41,0,0,0,3.84,4.93C362.49,364.29,363.76,363.8,363.48,362.14Z",
    style: {
      fill: "#0B1D51"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M410,353.44c6.09-4.41,11.1-7.91,11.1-7.91l-1.74-18.71s-1.32-9.25.77-14.49c2.16-5.43,4.3-6.2,4.3-6.2a21.18,21.18,0,0,1,5.89,3.31c2.36,2.06,3.48,6.85,4,13.61.5,5.93,1.44,20.82,1.59,24.29.19,4.41,0,8-4.68,10.08-4.93,2.26-19.69,7.29-19.69,7.29Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.85,305.71c4.78,1.53,7.23,2.41,9.25,8s1.95,15.9,2.57,24.16,1.07,13.64-.25,16.24c-.73,1.43-2.05,2.75-6.79,4.53s-9.3,3.41-9.3,3.41-.45-7.29-5.65-12.19l7.14-4.35s-1.64-16.85-2-21.46S417.89,309.7,423.85,305.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.82,345.53c2.8-1.32,8.35-.13,9.53.87-1.41-2.44-5.19-3.32-9.71-2.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,350.61a6.64,6.64,0,0,1,2.06,2.4,11.79,11.79,0,0,1,1.14,2.86,15.2,15.2,0,0,1,.48,3.48c0,.48,0,1,0,1.51l-.53.2a14.85,14.85,0,0,0-.42-5,12.26,12.26,0,0,0-1.1-2.8,26.76,26.76,0,0,0-1.68-2.51S418.94,350.56,419,350.61Z",
    style: {
      fill: "#ebebeb"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Backpack--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416,437.2c-1.59-3.63-5.51-12.53-7.54-19.94-1.83-6.7,1.35-12.58,2.46-16.25-2.23,10.71,3.27,23,8.7,34.41,1.32,2.75,2.79,2.87,4.51,2.38l.56,1.42S418.29,441.8,416,437.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,379.06c1.58,1.42,4.46,3.89,4.46,3.89l-1.24.38s-1.24-1.68-2.08-1.43l-12.06,3.67a1.53,1.53,0,0,0-1.24,1.78s-1.3-2.33-.26-4.15,1.27-1.43,4.28-2.4S426,378.26,427,379.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.6,389.84c-1.19-1.32-2.18-2.92-1.8-4.5s.33-3.28,2.32-3.89,7.95-2.64,9.18-2.79a2,2,0,0,1,1.73.4s-.34-.26-1.91.23-8,2.36-8.7,2.67a2.66,2.66,0,0,0-1.4,2.69,6.93,6.93,0,0,0,1.25,2.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.47,380.92c10.81-3.28,23.32,3.06,27.95,14.18l12.73,30.59a2.23,2.23,0,0,1,.13,1.36c-.16.73-.93,4-1,4.41a2.14,2.14,0,0,1-1.52,1.6l-34.51,10.49A2.71,2.71,0,0,1,425,442l-12.74-30.59a20.92,20.92,0,0,1-1.17-13c.17-.68.79-3.37.94-4A17.92,17.92,0,0,1,424.47,380.92Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.47,380.92c10.81-3.28,23.32,3.06,27.95,14.18l12.73,30.59a2.23,2.23,0,0,1,.13,1.36c-.16.73-.93,4-1,4.41a2.14,2.14,0,0,1-1.52,1.6l-34.51,10.49A2.71,2.71,0,0,1,425,442l-12.74-30.59a20.92,20.92,0,0,1-1.17-13c.17-.68.79-3.37.94-4A17.92,17.92,0,0,1,424.47,380.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.15,425.69a2.23,2.23,0,0,1,.13,1.36c-.16.73-.93,4-1,4.41a2.14,2.14,0,0,1-1.52,1.6l-34.51,10.49a2.6,2.6,0,0,1-1.74-.09L435,406.71l24.6,5.72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.15,425.69,452.42,395.1c-4.63-11.12-17.14-17.46-27.95-14.18s-15.82,15-11.19,26.08L426,437.59a2.73,2.73,0,0,0,3.25,1.54l34.51-10.5A2.14,2.14,0,0,0,465.15,425.69Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,438.69a2.05,2.05,0,0,0,1.1,0l34.51-10.49a1.75,1.75,0,0,0,1.07-.9,1.72,1.72,0,0,0,0-1.39L452,395.29a24.38,24.38,0,0,0-16.72-14.18,20.59,20.59,0,0,0-10.64.28,17.32,17.32,0,0,0-10.82,9.26,19.71,19.71,0,0,0-.06,16.17l12.73,30.59A2.23,2.23,0,0,0,428,438.69Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,438.69a2.23,2.23,0,0,1-1.56-1.28l-12.73-30.59a21.06,21.06,0,0,1-1.65-9.5c.11-.27.22-.54.35-.81a17.34,17.34,0,0,1,10.82-9.25,20.58,20.58,0,0,1,10.64-.28,24.38,24.38,0,0,1,16.72,14.18l11.44,27.49-32.93,10A2.05,2.05,0,0,1,428,438.69Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.16,421.16,426,437.6a2.73,2.73,0,0,0,3.24,1.53l34.51-10.49a2.16,2.16,0,0,0,1.39-2.95l-.83-1.92-33.89,10.31a2.74,2.74,0,0,1-3.25-1.53L420.72,417c-2.6-6.67,1.24-31.14,16.91-35.66a18.35,18.35,0,0,1,7.08-.76,22,22,0,0,0-12.46,1.71C417.8,388.69,415.21,412.1,419.16,421.16Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.69,434a2.66,2.66,0,0,0,1.74.1l34.51-10.5a2.16,2.16,0,0,0,1.51-1.57l-1.17,5a2.14,2.14,0,0,1-1.51,1.58l-34.51,10.5a2.66,2.66,0,0,1-1.74-.1Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.69,434a2.66,2.66,0,0,0,1.74.1l34.51-10.5a2.16,2.16,0,0,0,1.51-1.57l-1.17,5a2.14,2.14,0,0,1-1.51,1.58l-34.51,10.5a2.66,2.66,0,0,1-1.74-.1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.63,381.29c10.7-3.08,16,2.62,17.79,10.79a62.07,62.07,0,0,0,5.46,16l5.45,12.59a2.16,2.16,0,0,1-1.39,2.95l-34.5,10.49a2.74,2.74,0,0,1-3.25-1.53L420.72,417C418.13,410.28,422,385.8,437.63,381.29Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.63,381.29c10.7-3.08,16,2.62,17.79,10.79a62.07,62.07,0,0,0,5.46,16l5.45,12.59a2.16,2.16,0,0,1-1.39,2.95l-34.5,10.49a2.74,2.74,0,0,1-3.25-1.53L420.72,417C418.13,410.28,422,385.8,437.63,381.29Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.31,413,454,405.49a2.79,2.79,0,0,1,3.29,1.52l3.76,8.58a2.15,2.15,0,0,1,.15,1.33c-.09.45-.48,2-.57,2.44a2.1,2.1,0,0,1-1.49,1.59l-24.94,7.56a2.74,2.74,0,0,1-3.25-1.54l-3.57-8.63a2.23,2.23,0,0,1-.13-1.36c.1-.43.47-2.05.58-2.47A2.15,2.15,0,0,1,429.31,413Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.31,413,454,405.49a2.79,2.79,0,0,1,3.29,1.52l3.76,8.58a2.15,2.15,0,0,1,.15,1.33c-.09.45-.48,2-.57,2.44a2.1,2.1,0,0,1-1.49,1.59l-24.94,7.56a2.74,2.74,0,0,1-3.25-1.54l-3.57-8.63a2.23,2.23,0,0,1-.13-1.36c.1-.43.47-2.05.58-2.47A2.15,2.15,0,0,1,429.31,413Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.68,418.51l-24.94,7.56a2.72,2.72,0,0,1-3.24-1.53l-3.58-8.63a2.16,2.16,0,0,1,1.39-3L454,405.49a2.79,2.79,0,0,1,3.29,1.52l3.76,8.58A2.09,2.09,0,0,1,459.68,418.51Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.68,418.51l-24.94,7.56a2.72,2.72,0,0,1-3.24-1.53l-3.58-8.63a2.16,2.16,0,0,1,1.39-3L454,405.49a2.79,2.79,0,0,1,3.29,1.52l3.76,8.58A2.09,2.09,0,0,1,459.68,418.51Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.17 409.05 428.77 417.95 428.43 417.12 457.81 408.22 458.17 409.05",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.29,417.84l1,.23-.38,3.8c-.21.87-2.14.41-1.94-.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.05,417.32a.86.86,0,0,0,1.68.39.86.86,0,1,0-1.68-.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.56,389.5l3.53,3.3a1.05,1.05,0,0,1,.15,1.36l-2.42,3.53a1.06,1.06,0,0,1-1.48.26L435.17,395a1.06,1.06,0,0,1-.22-1.51l3.06-3.89A1.05,1.05,0,0,1,439.56,389.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.93,397.17a.1.1,0,0,0,.09,0l2.42-3.53a.08.08,0,0,0,0-.11l-3.52-3.29,0,0s-.06,0-.08,0l-3.07,3.89s0,0,0,.06a.07.07,0,0,0,0,.06l4.17,2.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.37,395.15h0a.43.43,0,0,0,.35-.49l-.36-2.08a.43.43,0,0,0-.49-.35h0a.43.43,0,0,0-.35.49l.36,2.09A.42.42,0,0,0,440.37,395.15Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.63,395.34h0a.42.42,0,0,0,.34-.49l-.36-2.09a.43.43,0,0,0-.49-.35h0a.42.42,0,0,0-.34.49l.36,2.09A.43.43,0,0,0,438.63,395.34Z",
    style: {
      fill: "#0B1D51"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chartacter--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.73,274.67,231.67,234l-4.46-.23,9.27,40.93h0a.58.58,0,0,0,.3.4,1.75,1.75,0,0,0,1.59.08.54.54,0,0,0,.35-.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.34,227.27h-4.47l-10.51,42.29h0a.56.56,0,0,0,.32.49,1.8,1.8,0,0,0,1.6,0,.65.65,0,0,0,.32-.39h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.26,294.07l-.2-45.6-4.46-.22L201,294.06h0a.61.61,0,0,0,.3.4,1.75,1.75,0,0,0,1.59.08.55.55,0,0,0,.35-.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.74,213.09h-4.47L185.11,258h0a.54.54,0,0,0,.32.49,1.74,1.74,0,0,0,1.6,0,.61.61,0,0,0,.32-.38h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.47,177.89a25.37,25.37,0,0,0-1.78,7.85c-.51,6,1.52,25.5,2.75,34.21h0c1.77,14.55,3.94,14.58,7.1,17,5.42,4.19,21,12.4,26.18,14.43,9.34,3.68,17-2,22.66-4.8a131.9,131.9,0,0,0,15.08-8.93c1.42-1,2.16-2.08,2.15-3.19,0-.43,0-2.22,0-2.68,0-1.41-1.24-2.91-3.85-4.61-4.83-3.13-22.26-13.29-29-17a.06.06,0,0,0-.06-.05c-5.2-3.16-8.33-24.61-11.93-36-.07-.24-.15-.48-.23-.71s-.13-.36-.19-.53c-.22-.62-.46-1.19-.7-1.71",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.6,231.8c0-1.41-1.24-2.91-3.85-4.61-4.83-3.13-22.26-13.29-29-17a.06.06,0,0,0-.06-.05c-5.2-3.16-8.33-24.61-11.93-36A19.18,19.18,0,0,0,188,172a1,1,0,0,0-.07-.15c-.06-.15-.13-.31-.2-.46a2.44,2.44,0,0,1-.1-.24h0a10.86,10.86,0,0,0-2.4-3.46,5,5,0,0,0-1.18-.83l-2.12-1.2c-3.53-2.11-8.16.43-13.93,3.59-3.59,2-6.65,4.3-8.52,8.66h0a25.37,25.37,0,0,0-1.78,7.85c-.51,6,1.52,25.5,2.75,34.21h0c1.77,14.55,3.94,14.58,7.1,17,5.42,4.19,21,12.4,26.18,14.43,9.34,3.68,17-2,22.66-4.8a131.9,131.9,0,0,0,15.08-8.93c1.42-1,2.16-2.08,2.15-3.19C233.59,234.05,233.6,232.26,233.6,231.8Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.6,231.8c0-1.41-1.24-2.91-3.85-4.61-4.83-3.13-22.26-13.29-29-17a.06.06,0,0,0-.06-.05c-5.2-3.16-8.33-24.61-11.93-36A19.18,19.18,0,0,0,188,172a1,1,0,0,0-.07-.15c-.06-.15-.13-.31-.2-.46a2.44,2.44,0,0,1-.1-.24h0a10.86,10.86,0,0,0-2.4-3.46,5,5,0,0,0-1.18-.83l-2.12-1.2c-3.53-2.11-8.16.43-13.93,3.59-3.59,2-6.65,4.3-8.52,8.66h0a25.37,25.37,0,0,0-1.78,7.85c-.51,6,1.52,25.5,2.75,34.21h0c1.77,14.55,3.94,14.58,7.1,17,5.42,4.19,21,12.4,26.18,14.43,9.34,3.68,17-2,22.66-4.8a131.9,131.9,0,0,0,15.08-8.93c1.42-1,2.16-2.08,2.15-3.19C233.59,234.05,233.6,232.26,233.6,231.8Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.37,243.89A131.9,131.9,0,0,0,231.45,235c3.24-2.35,2.94-4.76-1.7-7.77C223.3,223,197,208.1,197,208.1s-33.22,19.61-31.79,23.23,22,14.82,28.47,17.36C203.05,252.37,210.68,246.7,216.37,243.89Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.37,243.89A131.9,131.9,0,0,0,231.45,235c3.24-2.35,2.94-4.76-1.7-7.77C223.3,223,197,208.1,197,208.1s-33.22,19.61-31.79,23.23,22,14.82,28.47,17.36C203.05,252.37,210.68,246.7,216.37,243.89Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,166.84c-3.49-1.84-8,.66-13.66,3.74-3.6,2-6.67,4.31-8.53,8.69l-2.38-1.38c1.87-4.36,4.93-6.69,8.52-8.66,5.77-3.16,10.4-5.7,13.93-3.59Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,166.84c-3.49-1.84-8,.66-13.66,3.74-3.6,2-6.67,4.31-8.53,8.69l-2.38-1.38c1.87-4.36,4.93-6.69,8.52-8.66,5.77-3.16,10.4-5.7,13.93-3.59Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.75,174.08c-.07-.24-1.27-4.43-3.53-6.41a5.68,5.68,0,0,0-3.82-1.46c-3.06,0-6.72,2-11,4.37-.36.19-.71.4-1.06.6l-.4.24-.48.3-.35.23a20.12,20.12,0,0,0-2.16,1.64c-.11.1-.22.19-.32.3a14.8,14.8,0,0,0-1.23,1.27l-.21.25c-.08.1-.17.2-.24.3l-.24.31c-.08.1-.15.21-.23.32-.3.44-.59.89-.86,1.38l-.1.18-.2.39c-.1.19-.19.38-.28.57a24.65,24.65,0,0,0-1.94,8.23c-.84,9.89,2.55,42.55,5.94,45.37,0,0-.52-3.2,6.32-7.5,4.65-2.92,7.91-5.38,12.87-7.81,12.08-5.94,15.47-7.05,15.47-7.05C195.48,206.94,192.35,185.49,188.75,174.08Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.75,174.08c-.07-.24-1.27-4.43-3.53-6.41a5.68,5.68,0,0,0-3.82-1.46c-3.06,0-6.72,2-11,4.37-.36.19-.71.4-1.06.6l-.4.24-.48.3-.35.23a20.12,20.12,0,0,0-2.16,1.64c-.11.1-.22.19-.32.3a14.8,14.8,0,0,0-1.23,1.27l-.21.25c-.08.1-.17.2-.24.3l-.24.31c-.08.1-.15.21-.23.32-.3.44-.59.89-.86,1.38l-.1.18-.2.39c-.1.19-.19.38-.28.57a24.65,24.65,0,0,0-1.94,8.23c-.84,9.89,2.55,42.55,5.94,45.37,0,0-.52-3.2,6.32-7.5,4.65-2.92,7.91-5.38,12.87-7.81,12.08-5.94,15.47-7.05,15.47-7.05C195.48,206.94,192.35,185.49,188.75,174.08Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.15,255.19c-3.16-.31-5.76,2.29-6,3.11-.3,1.09-.11,3.29,1.27,6a18.75,18.75,0,0,1,1.68,8.49c-.14,2.49-1.1,8.72,1.51,11.74s8.27,5.54,10.1,1.21c.6-1.42-.87-6.2-1.58-9.71-1.4-7-2.54-13.92-2.54-13.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.36,260.83a67.1,67.1,0,0,1,1.16,10.27c.07,3.77,1,6.22,2.32,7.86,1.5,1.8,5.12,2.71,4.56-1.16-.39-2.69-2.8-15.73-2.8-15.73Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.16,257c-.06,2.32,1.41,8.44,4.73,13.49s8,10.74,9,14.32c0-1.66-.78-4.67-1.39-7.36l0-.17c0-.16-.07-.31-.1-.47s0-.14,0-.21l-.12-.59v0c-.44-2.18-.85-4.36-1.21-6.32-.29-1.57-.54-3-.75-4.19-.1-.6-.2-1.13-.27-1.59,0-.23-.08-.44-.11-.63-.13-.76-.2-1.19-.2-1.19l-4.45-6.88-.61,0A7,7,0,0,0,206.16,257Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.41,213.65c-9.85-6.41-20.92-13.19-20.92-13.19l-33.6,5.11,34.9,20.37,14,8.68s2.59-.3,1.15,3.81c-.45,1.31-1.12,3.92-1.81,6.86l7,17.15s3.17-6.18,7.69-17.36c4.2-10.39,4.15-16.71,3.6-19C231.63,223.2,229,219.2,220.41,213.65Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,218.5c.42.26,3.63,2.3,4.1,2.61,6.46,4.2,18.4,12.37,19.73,16.09.83,2.31,2.75,10.94,4.63,19.71l.08.41s-.94-10-1.42-15.72c-.56-6.75-2.16-7.55-4.87-10.41s-18.48-12.26-19.43-12.77c.72-4.22.76-5,.38-7.75C198.17,210.67,197.38,215.51,195,218.5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.05,284.82c-.76,0-.76,1.29-1.16,3a8.43,8.43,0,0,0-.06,5c.71,2.07,4,2.37,5.76,5.1s4.26,7.62,10.17,9.07,10.52-.38,11.69-2.12.22-3.45-3.52-5.74c-4-2.44-5.1-3.15-5.1-3.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.62,274.66A90.27,90.27,0,0,0,230,284.89a42.51,42.51,0,0,0,7.26,10.58c.65.72,2.11,2.06,2.64,2.65a1.15,1.15,0,0,1-.09,1.77c-1.28,1.26-6.77,1.63-9.88-.63s-6-7.13-7.86-9a28.78,28.78,0,0,1-2-2.14,3.8,3.8,0,0,1-1-2.44,11.24,11.24,0,0,0-.29-3.54,39.16,39.16,0,0,0-1.52-4.55Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.92,207c-.71,10.37-.15,14,1.77,17.88,2.49,5.07,5.35,7.92,13.78,12.67,7,3.93,16.55,6.1,18.63,7s2.85,3.14,4,7.16a69.58,69.58,0,0,0,6.93,18c4.76,8.47,6.06,11,6.06,11s5.64,2,9.81-2.21c0,0-7.22-36.11-9.06-41.24S195,218.5,195,218.5s2.54-8.58.17-14.51Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.35,205.36c.42,5.37,1.24,10.87,3.24,15.57a4.83,4.83,0,0,0,3.48-1.68c1.48-2,1.54-6.14.19-14.26l.81,0c1.39,8.4,1.28,12.59-.35,14.78a5.46,5.46,0,0,1-3.78,2,19.46,19.46,0,0,0,7.54,8.8c4.88,3,13.41,6.32,19.06,8.55,2.54,1,4.37,1.72,5.15,2.12,2.2,1.12,3.05,3.85,5.31,11.16.5,1.61,1.07,3.46,1.74,5.57,2.73,8.56,8,18.66,10.45,23.19-.31,0-.6,0-.89,0-2.55-4.71-7.64-14.57-10.32-23-.68-2.11-1.25-4-1.75-5.58-2.18-7.06-3-9.71-4.9-10.67-.75-.38-2.66-1.14-5.09-2.09-5.67-2.24-14.23-5.62-19.18-8.62-8.55-5.18-10.74-15.71-11.52-25.77Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "256.66 287.01 254.22 285.61 254.22 347.82 256.66 349.23 256.66 287.01",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.66 287.01 259.1 285.61 259.1 347.82 256.66 349.23 256.66 287.01",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.62 241.44 333.18 240.03 333.18 302.25 335.62 303.66 335.62 241.44",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.62 241.44 338.06 240.03 338.06 302.25 335.62 303.66 335.62 241.44",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.01 239.29 171.56 237.88 171.56 300.1 174.01 301.5 174.01 239.29",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.01 239.29 176.45 237.88 176.45 300.1 174.01 301.5 174.01 239.29",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.81,238.17v-3.35a1.32,1.32,0,0,1,.6-1l91.28-52.72a1.31,1.31,0,0,1,1.19,0l90.66,52.41a1.33,1.33,0,0,1,.6,1v3.34a1.32,1.32,0,0,1-.6,1l-91.28,52.72a1.33,1.33,0,0,1-1.2,0L165.41,239.2A1.32,1.32,0,0,1,164.81,238.17Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.81,238.17v-3.35a1.32,1.32,0,0,1,.6-1l91.28-52.72a1.31,1.31,0,0,1,1.19,0l90.66,52.41a1.33,1.33,0,0,1,.6,1v3.34a1.32,1.32,0,0,1-.6,1l-91.28,52.72a1.33,1.33,0,0,1-1.2,0L165.41,239.2A1.32,1.32,0,0,1,164.81,238.17Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256.66,287v4.72a1.3,1.3,0,0,1-.6-.14L165.41,239.2a1.32,1.32,0,0,1-.6-1v-3.35a1.31,1.31,0,0,1,.49-.95c-.22.18-.18.44.11.61l90.65,52.41A1.18,1.18,0,0,0,256.66,287Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.66,287v4.72a1.3,1.3,0,0,1-.6-.14L165.41,239.2a1.32,1.32,0,0,1-.6-1v-3.35a1.31,1.31,0,0,1,.49-.95c-.22.18-.18.44.11.61l90.65,52.41A1.18,1.18,0,0,0,256.66,287Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M165.41,234.48l90.65,52.41a1.33,1.33,0,0,0,1.2,0l91.28-52.72a.36.36,0,0,0,0-.69l-90.66-52.41a1.31,1.31,0,0,0-1.19,0l-91.28,52.72A.36.36,0,0,0,165.41,234.48Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.41,234.48l90.65,52.41a1.33,1.33,0,0,0,1.2,0l91.28-52.72a.36.36,0,0,0,0-.69l-90.66-52.41a1.31,1.31,0,0,0-1.19,0l-91.28,52.72A.36.36,0,0,0,165.41,234.48Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269,240.54c-4.8,2.76-4.8,7.25,0,10s12.56,2.76,17.35,0,4.79-7.26,0-10S273.78,237.77,269,240.54Z",
    style: {
      fill: "#0B1D51"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M283.92,246.63c3.34-3.42,5.31-11.95,2.05-14.65H269.36c-3.27,2.7-1.3,11.23,2,14.64l.09.1.12.11.3.27.08.06.25.19c.15.1.29.2.44.28a11,11,0,0,0,10,0h0c.14-.08.29-.18.43-.28l.24-.18.1-.08.29-.26a1.59,1.59,0,0,0,.13-.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.8,230.88c-3.79,2.19-3.79,5.74,0,7.93a15.15,15.15,0,0,0,13.72,0c3.79-2.19,3.79-5.74,0-7.93A15.21,15.21,0,0,0,270.8,230.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.55,231.9c-2.82,1.63-2.82,4.27,0,5.9a11.35,11.35,0,0,0,10.22,0c2.82-1.63,2.82-4.27,0-5.9A11.29,11.29,0,0,0,272.55,231.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.77,234.7a11.29,11.29,0,0,0-10.22,0,4.67,4.67,0,0,0-1.69,1.55,4.85,4.85,0,0,0,1.69,1.55,11.35,11.35,0,0,0,10.22,0,4.85,4.85,0,0,0,1.69-1.55A4.67,4.67,0,0,0,282.77,234.7Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.59,229.14l-.21-.28a7.64,7.64,0,0,0,3-6.09,5.77,5.77,0,0,0-2.33-4.77l.19-.29a6.13,6.13,0,0,1,2.49,5.07A8,8,0,0,1,281.59,229.14Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.66,235.34a36.79,36.79,0,0,1,5-6.56c2.36-2.17,5.67-3.73,6.05-3.48s-1.15,4.62-3.26,6.64S277.66,235.34,277.66,235.34Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.42,231.94c-1.87,1.79-6.5,3.08-7.54,3.35l10.8-10C289.06,225.55,287.53,229.92,285.42,231.94Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.42,231.94c-1.87,1.79-6.5,3.08-7.54,3.35l10.8-10C289.06,225.55,287.53,229.92,285.42,231.94Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.67,235.48s-.64-5.44.51-8.55,3.28-5.28,3.86-5,.48,5.06-.19,6.89S277.67,235.48,277.67,235.48Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.67,235.48s-.64-5.44.51-8.55,3.28-5.28,3.86-5,.48,5.06-.19,6.89S277.67,235.48,277.67,235.48Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.85,228.78c-.67,1.84-4.18,6.7-4.18,6.7L282,221.89C282.62,222.13,282.52,227,281.85,228.78Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.72,236.73a10.82,10.82,0,0,1,6.09-5c4.25-1.31,6-.6,6.11.29s-1.47,3.08-5.16,4.22A16,16,0,0,1,277.72,236.73Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.72,236.73a10.82,10.82,0,0,1,6.09-5c4.25-1.31,6-.6,6.11.29s-1.47,3.08-5.16,4.22A16,16,0,0,1,277.72,236.73Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.76,236.23a16,16,0,0,1-7,.5l12.2-4.72C290.08,232.9,288.45,235.09,284.76,236.23Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.76,236.23a16,16,0,0,1-7,.5l12.2-4.72C290.08,232.9,288.45,235.09,284.76,236.23Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.68,236.72a15.09,15.09,0,0,1,4.5-5.69c3.18-2.43,5.78-2.61,6.21-2.13s-1.62,3.74-4.06,5.4A13.71,13.71,0,0,1,277.68,236.72Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.68,236.72a15.09,15.09,0,0,1,4.5-5.69c3.18-2.43,5.78-2.61,6.21-2.13s-1.62,3.74-4.06,5.4A13.71,13.71,0,0,1,277.68,236.72Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.33,234.3a13.71,13.71,0,0,1-6.65,2.42,38.38,38.38,0,0,0,10.71-7.82C288.82,229.38,286.77,232.64,284.33,234.3Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.66,235.34c1.66,0,4.11-1.48,5.6-3s3.38-5.62,2.45-6.57-4.23,1.71-5.8,3.59A11.71,11.71,0,0,0,277.66,235.34Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.66,235.34c1.66,0,4.11-1.48,5.6-3s3.38-5.62,2.45-6.57-4.23,1.71-5.8,3.59A11.71,11.71,0,0,0,277.66,235.34Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.26,232.31c-1.49,1.55-3.94,3-5.6,3l8-9.6C286.64,226.69,284.74,230.76,283.26,232.31Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.26,232.31c-1.49,1.55-3.94,3-5.6,3l8-9.6C286.64,226.69,284.74,230.76,283.26,232.31Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.66,235.34a36.54,36.54,0,0,0-5-6.56c-2.36-2.17-5.68-3.73-6.06-3.48s1.15,4.62,3.26,6.64S277.66,235.34,277.66,235.34Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.9,231.94c1.87,1.79,6.51,3.08,7.55,3.35l-10.81-10C266.27,225.55,267.79,229.92,269.9,231.94Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.9,231.94c1.87,1.79,6.51,3.08,7.55,3.35l-10.81-10C266.27,225.55,267.79,229.92,269.9,231.94Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.66,235.48s.64-5.44-.51-8.55-3.28-5.28-3.86-5-.49,5.06.18,6.89S277.66,235.48,277.66,235.48Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.47,228.78c.67,1.84,4.19,6.7,4.19,6.7l-4.37-13.59C272.71,222.13,272.8,227,273.47,228.78Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.47,228.78c.67,1.84,4.19,6.7,4.19,6.7l-4.37-13.59C272.71,222.13,272.8,227,273.47,228.78Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.6,236.73a10.82,10.82,0,0,0-6.09-5c-4.25-1.31-5.95-.6-6.11.29s1.47,3.08,5.16,4.22A16,16,0,0,0,277.6,236.73Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.6,236.73a10.82,10.82,0,0,0-6.09-5c-4.25-1.31-5.95-.6-6.11.29s1.47,3.08,5.16,4.22A16,16,0,0,0,277.6,236.73Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.56,236.23a16,16,0,0,0,7,.5L265.4,232C265.25,232.9,266.87,235.09,270.56,236.23Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.56,236.23a16,16,0,0,0,7,.5L265.4,232C265.25,232.9,266.87,235.09,270.56,236.23Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.65,236.72a15.18,15.18,0,0,0-4.51-5.69c-3.18-2.43-5.78-2.61-6.21-2.13s1.62,3.74,4.06,5.4A13.71,13.71,0,0,0,277.65,236.72Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.65,236.72a15.18,15.18,0,0,0-4.51-5.69c-3.18-2.43-5.78-2.61-6.21-2.13s1.62,3.74,4.06,5.4A13.71,13.71,0,0,0,277.65,236.72Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,234.3a13.71,13.71,0,0,0,6.66,2.42,38.28,38.28,0,0,1-10.72-7.82C266.5,229.38,268.55,232.64,271,234.3Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.66,235.34c-1.65,0-4.11-1.48-5.59-3s-3.39-5.62-2.46-6.57,4.23,1.71,5.8,3.59A11.61,11.61,0,0,1,277.66,235.34Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.07,232.31c1.48,1.55,3.94,3,5.59,3l-8.05-9.6C268.68,226.69,270.59,230.76,272.07,232.31Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.07,232.31c1.48,1.55,3.94,3,5.59,3l-8.05-9.6C268.68,226.69,270.59,230.76,272.07,232.31Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.66,225.85c-.7,0-2,2.08-2,5.49,0,2.74,1.34,5.39,2,5.39s2-2.65,2-5.39C279.71,227.93,278.36,225.85,277.66,225.85Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.66,225.85c-.7,0-2,2.08-2,5.49,0,2.74,1.34,5.39,2,5.39s2-2.65,2-5.39C279.71,227.93,278.36,225.85,277.66,225.85Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.69,231.34c0-3.41-1.33-5.49-2-5.49v10.88C278.34,236.73,279.67,234.08,279.69,231.34Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.59,222.78a1.72,1.72,0,0,0,.48-1,1.52,1.52,0,0,0-.44-1,1.55,1.55,0,0,0-.48,1A1.68,1.68,0,0,0,284.59,222.78Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.59,222.78a1.72,1.72,0,0,0,.48-1,1.52,1.52,0,0,0-.44-1,1.55,1.55,0,0,0-.48,1A1.68,1.68,0,0,0,284.59,222.78Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.69,222.82a1.64,1.64,0,0,1,.45-1,1.47,1.47,0,0,1,1-.35,1.52,1.52,0,0,1-.41,1A1.68,1.68,0,0,1,284.69,222.82Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.69,222.82a1.64,1.64,0,0,1,.45-1,1.47,1.47,0,0,1,1-.35,1.52,1.52,0,0,1-.41,1A1.68,1.68,0,0,1,284.69,222.82Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.61,222.87a1.67,1.67,0,0,0,.84-.76.61.61,0,1,0-.84-.37A1.68,1.68,0,0,0,284.61,222.87Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.61,222.87a1.66,1.66,0,0,0,.05-1.13,1.53,1.53,0,0,0-.78-.77,1.5,1.5,0,0,0-.07,1.1A1.66,1.66,0,0,0,284.61,222.87Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.61,222.87a1.66,1.66,0,0,0,.05-1.13,1.53,1.53,0,0,0-.78-.77,1.5,1.5,0,0,0-.07,1.1A1.66,1.66,0,0,0,284.61,222.87Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.61,222.87a1.66,1.66,0,0,1,.8-.8,1.57,1.57,0,0,1,1.1.07,1.53,1.53,0,0,1-.77.79A1.69,1.69,0,0,1,284.61,222.87Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.61,222.87a1.66,1.66,0,0,1,.8-.8,1.57,1.57,0,0,1,1.1.07,1.53,1.53,0,0,1-.77.79A1.69,1.69,0,0,1,284.61,222.87Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.52,218.19a1.65,1.65,0,0,0-.84-.76,1.48,1.48,0,0,0-1.09.11,1.52,1.52,0,0,0,.8.75A1.64,1.64,0,0,0,282.52,218.19Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.52,218.19a1.65,1.65,0,0,0-.84-.76,1.48,1.48,0,0,0-1.09.11,1.52,1.52,0,0,0,.8.75A1.64,1.64,0,0,0,282.52,218.19Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.59,218.11a1.68,1.68,0,0,1-.86-.74.61.61,0,1,1,.83-.39A1.64,1.64,0,0,1,282.59,218.11Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.59,218.11a1.68,1.68,0,0,1-.86-.74.61.61,0,1,1,.83-.39A1.64,1.64,0,0,1,282.59,218.11Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.61,218.2a1.62,1.62,0,0,0-.47-1,1.51,1.51,0,0,0-1-.32,1.48,1.48,0,0,0,.44,1A1.64,1.64,0,0,0,282.61,218.2Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.61,218.2a1.62,1.62,0,0,0-1.06-.39,1.49,1.49,0,0,0-1,.51,1.51,1.51,0,0,0,1,.4A1.64,1.64,0,0,0,282.61,218.2Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.61,218.2a1.62,1.62,0,0,0-1.06-.39,1.49,1.49,0,0,0-1,.51,1.51,1.51,0,0,0,1,.4A1.64,1.64,0,0,0,282.61,218.2Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.61,218.2a1.65,1.65,0,0,1-.51-1,1.46,1.46,0,0,1,.4-1,1.49,1.49,0,0,1,.51,1A1.67,1.67,0,0,1,282.61,218.2Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.61,218.2a1.65,1.65,0,0,1-.51-1,1.46,1.46,0,0,1,.4-1,1.49,1.49,0,0,1,.51,1A1.67,1.67,0,0,1,282.61,218.2Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--laptop--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--laptop--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.35,215.86l-22.92-13.23a1.3,1.3,0,0,0-1.32,0l-39.77,23a.29.29,0,0,0,0,.5l23.14,13.36Z",
    style: {
      fill: "#0B1D51",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.64,213.07v.52a2.13,2.13,0,0,1-1.06,1.83l-37,21.38a2.15,2.15,0,0,1-2.12,0l-20.19-11.62a2.12,2.12,0,0,1-1.06-1.83v-.71h0a.27.27,0,0,0,.13.24l22.17,12.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.64,213.07l-22-12.68a1.3,1.3,0,0,0-1.27,0l-38.1,22a.28.28,0,0,0,0,.49l22.17,12.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.28 233.81 216.43 226.98 251.07 206.98 262.98 213.78 228.28 233.81",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.98 213.78 262.52 214.04 251.07 207.5 216.89 227.24 216.43 226.98 251.07 206.98 262.98 213.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.46 214.81 222.67 214.93 228.48 218.29 238.81 212.32 239.02 212.2 233 208.72 222.46 214.81",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.67 214.93 228.48 218.29 238.81 212.32 233 208.97 222.67 214.93",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.48,235.68v1.41a2.14,2.14,0,0,0,1.06-.29l37-21.38a2.14,2.14,0,0,0,1.06-1.84v-.51Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.49,200.79c-1.44-1.39-4.24-3.83-5-4.37a55.1,55.1,0,0,0-6.5-3.54c-3.74-1.84-15.42-8.13-15.42-8.13s-8.54-14.33-10.41-17.33c-2.24-3.6-5.18-6.24-9.32-6.52l.78,12.1s8.54,16.76,9.93,18.94c1.11,1.75,2.07,2.09,4.42,2.92,3.58,1.28,16.27,5.13,16.27,5.13l.64.26a2.28,2.28,0,0,1,1.07.89,6.16,6.16,0,0,1,.61,1.28c.55,1.53.45,2,1,3.68s.91,1.54,1.9,2.86,1.3,2,1.81,2,.89-1.33.63-2.45a15.07,15.07,0,0,0-1.37-2.67c-.11-.4,0-1.11,1.19-.73s3.68,3,4.78,4.17,1.93,2.78,3,3.55,1.07-.36,1.24-1.33,1.3-2.34,1.44-3.88A11.94,11.94,0,0,0,240.49,200.79Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.78,184.46s-7.11-12.67-8.65-15.05c-2.92-4.54-4-6-5.85-7.14a10.75,10.75,0,0,0-5.8-1.72l-.21,13.55s8.07,13.51,9.42,15.85,2.36,3.68,5.47,4.84S221.51,199,221.51,199a7.94,7.94,0,0,1,.49-5.23,5.09,5.09,0,0,1,3.19-2.82Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.59,129.94c-4.55-2.25-7.21-1.43-9.61.11-3.77,2.42-3.94,5.34-3.89,10,.08,7.05-.21,9.22-.9,10.88a6,6,0,0,1-3.22,3.25,4.1,4.1,0,0,0,4-.18c-.41,3.44-1.15,6.36,0,9.85a14.3,14.3,0,0,0,4.28,6.52c1.7,1.33,4,1.59,6,2.25-1.52-2.63-2.43-5.16-1.81-8.32.68-3.49,2.72-6.58,3.43-10.09,1-4.87,2.18-9.92,2.15-14.9C180,135.15,179.87,132.8,179.59,129.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.48,129.77c-.59-.61-3.35-.37-5.09,1.53s-2.88,4.72-.94,6.35S181,131.85,177.48,129.77Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.75,159.51l-8.84,4.86c-.85,2.22-4.71,6.89-3.72,12.85s5.2,19.26,4.55,21.75a85.76,85.76,0,0,0-1.6,17.09s12.93,4.76,24.37,1.48a26.74,26.74,0,0,0,16.35-13.06s-3.83-5.2-4.64-9c-.51-2.46-.27-9.27-.27-9.27s5.12-5,3.4-10.62c-1.63-5.31-10-13.18-11.87-15-4.25-1-5.88-1.46-5.88-1.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,160.84c.58,2.91,1.75,3.62,5,7.24s13.61,13.47,14.56,17.75c.62-3.67,1.46-8.58.49-12.88s-3.31-10-7-12.89l-12.75-.55Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.86,140.77c2.81-10.39-6.76-15.7-16.29-14-3.14.55-7.19,2.34-7.62,6.82-4.15,1.3-6.14,6.85-3.58,12.77,1.85,4.3,5.24,6.77,6.92,9.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.05,141.86c2.74-1.19,4.12,1.68,4.12,1.68,1.78,1.11,2.81-2.47,3.2-3.54.69-1.89,1.33-4.57,3.42-5.35a5.6,5.6,0,0,1,4.71.85,3.63,3.63,0,0,0,2.84.38c.85-.23,1.12-1.56,1.89-2,2.23-1.19,4,2.47,4.26,4.23a49.88,49.88,0,0,1,.87,7.11c.18,7.61-1.92,10.9-3.77,11.93-1.34.75-3.79.93-6.45.71l0,2.35a22.14,22.14,0,0,1,1.91,8.2A32,32,0,0,1,176,160.34V149.66c-.5,1-2.86,1.53-4.32-.34C169.8,146.9,169.42,143,172.05,141.86Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.12,150l4.36,1.35a2.24,2.24,0,0,1-2.81,1.59A2.4,2.4,0,0,1,186.12,150Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.41,151a2.5,2.5,0,0,1,2.52,1.93,2.16,2.16,0,0,1-1.26,0,2.34,2.34,0,0,1-1.6-1.89A1.86,1.86,0,0,1,186.41,151Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.14,157.88c-2.58-.4-7.3-1.66-8.08-3.78a4.08,4.08,0,0,0,1.88,3.25c1.67,1.27,6.22,2.06,6.22,2.06Z",
    style: {
      fill: "#9a4a4d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.81,140.58l-2.61-.91a1.33,1.33,0,0,1,1.71-.88A1.45,1.45,0,0,1,195.81,140.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.3,141.73l2.43-1.33a1.33,1.33,0,0,0-1.84-.58A1.45,1.45,0,0,0,183.3,141.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.17,143.05A1.12,1.12,0,1,1,194,142,1.15,1.15,0,0,1,195.17,143.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.69,143.65a1.15,1.15,0,0,1-1,1.25,1.16,1.16,0,0,1-1.22-1.08,1.14,1.14,0,0,1,1-1.25A1.15,1.15,0,0,1,186.69,143.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.35,142.81l1.58,6.14,3.12-1.52C193.49,146.16,190.74,142.38,189.35,142.81Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.41,148.11a1,1,0,1,1-1-1A1,1,0,0,1,175.41,148.11Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M176,157.8v1.73a81.52,81.52,0,0,0,7.28,9.38c5,5.52,9.28,9.72,10.81,13.54a40.07,40.07,0,0,1,2.13,8.58,21.42,21.42,0,0,0-7.42-11c-3.62-2.9-9.47-5.13-10.58-7s1.05-4.16,1.05-4.16a24.9,24.9,0,0,1-5.74-2.71,6.66,6.66,0,0,1-2.55-4.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.18,160.23c2,1.94,5.65,6.19,6.58,11.11s1.33,16.08,1.33,16.08,1.3-7.54,2-10.74,1.08-5.68-2.42-9c.86-1.49,1-2.06-.81-4.23a16.27,16.27,0,0,0-3.4-3.17l-3.33-2.43Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.5,206.34a17.51,17.51,0,0,1,6.92,0c2.58.44,4.7,0,5.05.14,1.33.64.19,2.86-3.17,2.86C215.71,209.34,209.5,206.34,209.5,206.34Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.35,215.73c.85.25,1.68.52,2.54.75a7.5,7.5,0,0,0,1.5.28,20.53,20.53,0,0,0,3.59-.28,6.54,6.54,0,0,1,2.85.15c1.14.34,2.25.74,3.38,1.13a4.61,4.61,0,0,0,2.82.17,6.19,6.19,0,0,0,.95-.41,5.44,5.44,0,0,1,1.45-.12,2,2,0,0,0,1-.42c.16-.15.23-.42.42-.54a1.72,1.72,0,0,1,1-.13,6.62,6.62,0,0,0,1.47-.11c.65-.14,1.59-.49,1.51-1.3,0-.37-.32-.54-.59-.78-.48-.42-1-.83-1.43-1.28-1-1.05-2.22-1.93-3.25-3a6.88,6.88,0,0,0-3.32-1.74c-1.3-.36-2.58-.83-3.9-1.13a9.46,9.46,0,0,0-3.23-.63c-2.79.34-5.67,1.28-8.43.43-4-1.25-21.8-8.38-21.8-8.38l-4.1-15.2s-2.79-13.51-7-17.49c-3.07,1.16-5.85,3.5-6.76,6.63-1.07,3.7.05,6.94,2.16,15.92a104.49,104.49,0,0,0,3.78,13.82c2.56,7.53,2.44,7.43,9.15,8.45,1.42.22,2.84.47,4.25.73,3.45.64,6.88,1.34,10.31,2.07,1.66.35,6.62,1.46,7.42,1.73C198.4,215.19,200,215.62,200.35,215.73Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.91,164.37c-4.63,2.21-7.48,6.06-7.44,10.87s3.66,16.35,5.72,22.93c3.54,11.27,3.45,10.88,7.17,12s19.72,3.49,19.72,3.49a15,15,0,0,1,.85-4.28c1.15-3.81,2.85-4.34,2.85-4.34l-16.49-6.62s-4-16.48-5.18-20.32C174.17,178.31,171.76,167.21,166.91,164.37Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M229.08,236a2.49,2.49,0,0,0,2.16-.17l36.88-21.29a2.53,2.53,0,0,0,1.22-1.75l4-24.08a1.9,1.9,0,0,0,0-.41,2.52,2.52,0,0,0-.74-1.78l-38.33,22.13a1.83,1.83,0,0,0-.9,1.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.48,235.68l.25.14a2.26,2.26,0,0,0,.35.17l4.36-26.06a1.83,1.83,0,0,1,.9-1.29l38.33-22.13a2.53,2.53,0,0,0-.52-.39l-38.4,22.17a1.85,1.85,0,0,0-.9,1.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.8,209.13l-.6-.35a2,2,0,0,0-.35.81l-4.37,26.09.25.14a2.26,2.26,0,0,0,.35.17l4.36-26.06A1.82,1.82,0,0,1,233.8,209.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.85,213.76a8.15,8.15,0,0,1,3.71-4.78c1.79-1,3-.55,2.74,1.06a8.13,8.13,0,0,1-3.72,4.78C250.8,215.85,249.58,215.38,249.85,213.76Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coffee--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-49",
    d: "M206.32,240c3,1.64,3,4.29,0,5.92a12.42,12.42,0,0,1-10.78,0c-3-1.63-3-4.28,0-5.92A12.42,12.42,0,0,1,206.32,240Z",
    style: {
      fill: "#0B1D51",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coffee--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.21,228.23a15.76,15.76,0,0,1,9.49.05c2.57,1,2.56,2.57,0,3.53a15.76,15.76,0,0,1-9.49-.05C193.53,230.77,193.54,229.19,196.21,228.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.08,224.88l13.67.36-1.17,18.12h0c-.08.58-.65,1.14-1.7,1.56a12.17,12.17,0,0,1-8.2-.21c-1.07-.47-1.62-1.06-1.67-1.64h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.75,225.24l-.3,3.24a5.7,5.7,0,0,1-1.16.58,16.72,16.72,0,0,1-10.88-.28l-.36-.17a7.42,7.42,0,0,1-.85-.5l-.12-3.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.2,225.33l.06-2.45,1.6,0c.21-.1.45-.2.71-.3a16.68,16.68,0,0,1,10.88.28,5.78,5.78,0,0,1,.66.34l1.55,0-.06,2.44h0c0,.8-.78,1.57-2.28,2.14a16.65,16.65,0,0,1-10.88-.28C193.92,226.94,193.18,226.12,193.2,225.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.61,220.74a16.71,16.71,0,0,1,10.89.28c2.93,1.29,2.88,3.26-.11,4.4a16.75,16.75,0,0,1-10.89-.28C192.47,223.85,192.53,221.88,195.61,220.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.69,222.33h0l.54-2,3.91.1a15.8,15.8,0,0,1,3.89.1l3.8.1.44,2h0c.23.74-.37,1.49-1.82,2a14.35,14.35,0,0,1-9-.23C195,223.84,194.42,223.06,194.69,222.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,219.08a13.85,13.85,0,0,1,8.24.22c2.22.89,2.19,2.24-.07,3a13.92,13.92,0,0,1-8.25-.21C194.6,221.21,194.63,219.86,197,219.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,220.58s.06.14.25.29a3.52,3.52,0,0,0,.93.5,12.3,12.3,0,0,0,3.87.68,11.52,11.52,0,0,0,3.83-.48,3.57,3.57,0,0,0,.93-.46c.19-.14.24-.25.24-.28s-.19-.42-1.13-.8a11.44,11.44,0,0,0-3.8-.67,12.07,12.07,0,0,0-3.9.48C196.25,220.16,196,220.5,196,220.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.25,220.87a3.52,3.52,0,0,0,.93.5,12.3,12.3,0,0,0,3.87.68,11.52,11.52,0,0,0,3.83-.48,3.57,3.57,0,0,0,.93-.46,3.32,3.32,0,0,0-.91-.5,11.64,11.64,0,0,0-3.8-.68,12,12,0,0,0-3.89.49A3.19,3.19,0,0,0,196.25,220.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M198.57,221a1.2,1.2,0,0,0-.92-.2c-.17.09,0,.33.3.53a1.18,1.18,0,0,0,.91.2C199,221.41,198.9,221.18,198.57,221Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M207.21,235.92c0,.6-.62,1.2-1.83,1.65a14.86,14.86,0,0,1-8.95,0c-1.25-.47-1.87-1.07-1.87-1.67L194.2,230c0,.63.66,1.28,2,1.77a15.76,15.76,0,0,0,9.49.05c1.29-.48,1.94-1.12,1.94-1.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,236.24a8.58,8.58,0,0,0,.54-1,2.94,2.94,0,0,1,1.55-1.34.19.19,0,0,1,.24.08,2.08,2.08,0,0,1-.58,2.32,2.14,2.14,0,0,1-2.32.57s-.05-.09,0-.11A2,2,0,0,0,203,236.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.75,233.72a3.37,3.37,0,0,0-1,.59,3.15,3.15,0,0,0-.71.95,2.82,2.82,0,0,1-.89,1.17.2.2,0,0,1-.27,0,2,2,0,0,1,.49-2.48,2.12,2.12,0,0,1,2.39-.53A.19.19,0,0,1,204.75,233.72Z",
    style: {
      fill: "#263238"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sofa--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.33,425.81a1.14,1.14,0,0,1-1.14-1.06l-1.91-32.14a3.83,3.83,0,0,0-1.32-2.73L76.19,368h0a1.62,1.62,0,0,0-.13.6l-3.37,30.87a1.14,1.14,0,1,1-2.28-.15l3.36-30.88a2.92,2.92,0,0,1,1.36-2.52,2.27,2.27,0,0,1,2.21.1l37.76,21.87a5.91,5.91,0,0,1,2.47,4.54l1.91,32.15a1.14,1.14,0,0,1-1,1.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.27,388.86a1.13,1.13,0,0,1-1.15-1.05l-3.35-31.91a3.83,3.83,0,0,0-1.32-2.73L138.69,331.3h0a1.62,1.62,0,0,0-.13.6l-1.47,30.23a1.14,1.14,0,1,1-2.28-.16l1.46-30.23a2.93,2.93,0,0,1,1.37-2.52,2.25,2.25,0,0,1,2.2.1l37.76,21.87a5.88,5.88,0,0,1,2.47,4.54l3.35,31.91a1.14,1.14,0,0,1-1.05,1.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.54,391.46,74.62,367.23a3.21,3.21,0,0,1,0-5.93l55.83-32.8a8.65,8.65,0,0,1,7.92-.06l41.93,24.23a3.21,3.21,0,0,1,0,5.93l-55.84,32.8a8.65,8.65,0,0,1-7.92.06Zm15.06-60.94-55.84,32.8c-.5.29-.81.65-.81.94s.32.65.82.93l41.93,24.24a6.26,6.26,0,0,0,5.58-.05l55.84-32.8c.5-.29.8-.65.8-.94s-.31-.65-.82-.93l-41.92-24.23h0a6.23,6.23,0,0,0-5.58,0Zm6.15-1.06h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.43,339.52a.94.94,0,0,0,.9-.75L164,321.35a.93.93,0,1,0-1.83-.38l-3.68,17.42a1,1,0,0,0,.72,1.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.61,333.94a.94.94,0,0,0,.91-.74l3.67-17.42a.94.94,0,0,0-1.83-.39l-3.68,17.42a.94.94,0,0,0,.73,1.11A.65.65,0,0,0,149.61,333.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.89,311a1,1,0,0,1,.56-.78l4.88-2.87a3,3,0,0,1,2.7,0l27.45,15.59a1,1,0,0,1,.57.78c0,.26,0,1.2,0,1.46a1,1,0,0,1-.55.79l-4.88,2.86a3,3,0,0,1-2.71,0L138.47,313.2a1,1,0,0,1-.57-.78C137.9,312.16,137.9,311.22,137.89,311Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.45,310.18l4.88-2.87a3,3,0,0,1,2.7,0l21.18,12,.07,9.78a2.76,2.76,0,0,1-1.36-.31L138.47,313.2a1,1,0,0,1-.57-.78c0-.26,0-1.2,0-1.46A1,1,0,0,1,138.45,310.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,307.29l27.45,15.59a1,1,0,0,1,.57.78.93.93,0,0,1-.56.78l-4.88,2.87a3,3,0,0,1-2.7,0l-27.45-15.59a1,1,0,0,1-.57-.78,1,1,0,0,1,.56-.78l4.88-2.87A3,3,0,0,1,146,307.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.53,354.73l57.69-33.9a1.18,1.18,0,0,1,1.2.11l40.64,23.51a3.71,3.71,0,0,1,1.71,2.91l0,7.07a1.17,1.17,0,0,1-.48,1.09l-57.69,33.9a1.18,1.18,0,0,1-1.2-.11L78.81,365.8a3.73,3.73,0,0,1-1.71-2.91l0-7.07A1.18,1.18,0,0,1,77.53,354.73Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.53,354.73l57.69-33.9a1.18,1.18,0,0,1,1.2.11l40.64,23.51a3.71,3.71,0,0,1,1.71,2.91l0,7.07a1.17,1.17,0,0,1-.48,1.09l-57.69,33.9a1.18,1.18,0,0,1-1.2-.11L78.81,365.8a3.73,3.73,0,0,1-1.71-2.91l0-7.07A1.18,1.18,0,0,1,77.53,354.73Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120.65,389.42l57.68-33.9a1.18,1.18,0,0,0,.5-1.09l-.05-7.07a3.59,3.59,0,0,0-.59-1.77l-57.68,33.9a3.43,3.43,0,0,1,.57,1.77l0,7.07A1.17,1.17,0,0,1,120.65,389.42Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.65,389.42l57.68-33.9a1.18,1.18,0,0,0,.5-1.09l-.05-7.07a3.59,3.59,0,0,0-.59-1.77l-57.68,33.9a3.43,3.43,0,0,1,.57,1.77l0,7.07A1.17,1.17,0,0,1,120.65,389.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.13,388.33l0-7.07a3.72,3.72,0,0,0-1.7-2.91L78.73,354.84a1,1,0,0,0-1.68,1l0,7.07a3.73,3.73,0,0,0,1.71,2.91l40.64,23.51a1.18,1.18,0,0,0,1.2.11A1.17,1.17,0,0,0,121.13,388.33Z",
    style: {
      fill: "#0B1D51"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73,309.63l51.38-30.19a1.07,1.07,0,0,1,1.06.14l6.15,3.49a4.73,4.73,0,0,1,2,2.88l7.11,39.38c.1.56,0,.94-.29,1.1L89.09,356.62a1.07,1.07,0,0,1-1.06-.14L81.88,353a4.73,4.73,0,0,1-2-2.88l-7.11-39.37C72.63,310.17,72.75,309.79,73,309.63Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73,309.63l51.38-30.19a1.07,1.07,0,0,1,1.06.14l6.15,3.49a4.73,4.73,0,0,1,2,2.88l7.11,39.38c.1.56,0,.94-.29,1.1L89.09,356.62a1.07,1.07,0,0,1-1.06-.14L81.88,353a4.73,4.73,0,0,1-2-2.88l-7.11-39.37C72.63,310.17,72.75,309.79,73,309.63Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.38,355.52c.1.56,0,.94-.29,1.1l51.39-30.19c.27-.16.38-.54.28-1.1L133.65,286a4.4,4.4,0,0,0-.77-1.67L81.5,314.47a4.25,4.25,0,0,1,.77,1.67Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.38,355.52c.1.56,0,.94-.29,1.1l51.39-30.19c.27-.16.38-.54.28-1.1L133.65,286a4.4,4.4,0,0,0-.77-1.67L81.5,314.47a4.25,4.25,0,0,1,.77,1.67Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88,356.48,81.88,353a4.73,4.73,0,0,1-2-2.88l-7.11-39.37c-.1-.56,0-.94.29-1.1a1.07,1.07,0,0,1,1.06.14l6.15,3.49a4.73,4.73,0,0,1,2,2.88l7.11,39.38c.1.56,0,.94-.29,1.1A1.07,1.07,0,0,1,88,356.48Z",
    style: {
      fill: "#0B1D51"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cushion--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.44,310.43c-2.35-.22-4.29,2.51-8.2,4.46A38.58,38.58,0,0,0,76.29,325.8c-3.38,4-4.68,3.34-5.7,5.82s1.86,3.53,3.26,7c2.36,5.9,5.26,9.86,8.27,12.31,5.32,4.32,4.54,7.36,6.94,7.31,2.57,0,2.37-2.25,6.38-3.84,9.5-3.77,13.39-7.09,17.75-13.64,1.7-2.56,3.89-2.36,4.29-4.82.2-1.23-1.59-1.88-3.23-5.72-2.73-6.39-7-12.37-11.25-15.47C101.17,313.43,100.84,310.65,98.44,310.43Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.44,310.43c-2.35-.22-4.29,2.51-8.2,4.46A38.58,38.58,0,0,0,76.29,325.8c-3.38,4-4.68,3.34-5.7,5.82s1.86,3.53,3.26,7c2.36,5.9,5.26,9.86,8.27,12.31,5.32,4.32,4.54,7.36,6.94,7.31,2.57,0,2.37-2.25,6.38-3.84,9.5-3.77,13.39-7.09,17.75-13.64,1.7-2.56,3.89-2.36,4.29-4.82.2-1.23-1.59-1.88-3.23-5.72-2.73-6.39-7-12.37-11.25-15.47C101.17,313.43,100.84,310.65,98.44,310.43Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.21,335.73c2,2.84,1.79,5.69,6,10.9,4,5,6.9,6.4,8.11,8.66,1,1.87,2.36,2.74,2.67.54s-1.46-8.47-5.51-13.82c-4.66-6.16-7.62-8.51-9.61-9.4C71.69,331.2,71.61,333.5,73.21,335.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.58,352c-2.62.92-2.72,3.26-4,5.07a10.33,10.33,0,0,1,3.88-2.65,44.69,44.69,0,0,0,10.06-5.22C102.15,351,97.49,351.34,95.58,352ZM112,339.81c-1.62,1.51-1.44,4.18-3.38,6.77a36.41,36.41,0,0,0,4.61-5.79c1.55-2.34,3.51-2.38,4.14-4.24C115.9,338.39,113.91,338,112,339.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.21,316.12a27.2,27.2,0,0,0-15,8.37,4.45,4.45,0,0,0-1,3.26,4.4,4.4,0,0,0,2.29,3.54,8.05,8.05,0,0,0,4.63.53c2.9-.39,4.61-1.16,8.37-1.25a8.71,8.71,0,0,1,4,1c1.86,1,3.25,2.17,4.88,3,2.24,1.19,6.21.61,7.58-.78s1.77-3.7.43-6.46C108.35,321.19,102.85,315.23,95.21,316.12Z",
    style: {
      fill: "#0B1D51",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--cushion--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.1,302.43c2-1.2,5,.45,9.32.55A49,49,0,0,1,156.76,307c4.77,2.17,5.66,1,7.64,2.84s-.18,4,0,7.74c.39,6.35-.56,11.17-2.24,14.66-3,6.18-1,8.59-3.16,9.58-2.34,1-3.1-1-7.41-.76-10.2.64-17.21-.85-23.94-4.91-2.63-1.59-4.53-.48-5.93-2.54-.71-1,.64-2.37.48-6.55-.25-6.94,1.11-14.2,3.59-18.78C126.91,306.32,126,303.66,128.1,302.43Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.1,302.43c2-1.2,5,.45,9.32.55A49,49,0,0,1,156.76,307c4.77,2.17,5.66,1,7.64,2.84s-.18,4,0,7.74c.39,6.35-.56,11.17-2.24,14.66-3,6.18-1,8.59-3.16,9.58-2.34,1-3.1-1-7.41-.76-10.2.64-17.21-.85-23.94-4.91-2.63-1.59-4.53-.48-5.93-2.54-.71-1,.64-2.37.48-6.55-.25-6.94,1.11-14.2,3.59-18.78C126.91,306.32,126,303.66,128.1,302.43Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.78,314.71c-.63,3.43.8,5.91-.75,12.4-1.5,6.24-3.52,8.74-3.65,11.29-.11,2.12-1,3.48-2.19,1.62s-2.28-8.28-.9-14.84c1.59-7.56,3.27-10.95,4.7-12.61C163.22,310,164.27,312,163.78,314.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.3,340.66a44.47,44.47,0,0,0,11.33.44,10.43,10.43,0,0,1,4.64.74c-2-1.08-3-3.15-5.8-2.87C148.46,339.17,144.1,340.86,140.3,340.66Zm-18.16-6.55c1.36,1.42,3.15.63,5.55,2.08a37,37,0,0,0,6.64,3.27c-2.86-1.51-3.83-4-5.94-4.68C125.85,334,124.21,335.17,122.14,334.11Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.45,306.21c5.54-1.4,13-1.41,18.27.89,1,.49,2.87,1.8,3.26,2.93a4.38,4.38,0,0,1-.57,4.18,8,8,0,0,1-4,2.46c-2.79.88-5.64.59-9.29,1.9a11.2,11.2,0,0,0-4,3c-1.25,1.71-2,3.35-3.13,4.82-1.53,2-5.36,3.19-7.19,2.51s-3.18-2.58-3.15-5.66C123.72,316.39,126.15,308.66,133.45,306.21Z",
    style: {
      fill: "#0B1D51",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.53,377.57a1.27,1.27,0,0,0,.26,0,.94.94,0,0,0,.63-1.17l-3.9-13a.93.93,0,0,0-1.79.54l3.9,13A.93.93,0,0,0,94.53,377.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.71,372a.75.75,0,0,0,.26,0,.93.93,0,0,0,.63-1.16l-3.89-13a.94.94,0,0,0-1.17-.63,1,1,0,0,0-.63,1.17l3.9,13A.93.93,0,0,0,84.71,372Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.33,351.17a.93.93,0,0,1,.55-.79l4.88-2.86a3,3,0,0,1,2.7,0l27.46,15.59a.94.94,0,0,1,.56.78c0,.26,0,1.2,0,1.46a1,1,0,0,1-.55.78L100.06,369a3,3,0,0,1-2.7,0L69.9,353.4a.94.94,0,0,1-.56-.77C69.34,352.37,69.33,351.43,69.33,351.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.88,350.38l4.88-2.86a3,3,0,0,1,2.7,0l21.18,12,.07,9.78a2.8,2.8,0,0,1-1.35-.31L69.9,353.4a.94.94,0,0,1-.56-.77c0-.26,0-1.2,0-1.46A.93.93,0,0,1,69.88,350.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.46,347.5l27.46,15.59a.94.94,0,0,1,.56.78,1,1,0,0,1-.55.78l-4.88,2.86a3,3,0,0,1-2.7,0L69.89,351.94a.83.83,0,0,1,0-1.56l4.88-2.86A3,3,0,0,1,77.46,347.5Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.17,371.51l7.09-9.24,11,8.11c-7.35,5-15.43,11.2-17.42,13.6,0,0-6.26-2.66-6.67-6.17S137.21,372.29,139.17,371.51Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.07,374.15a5.74,5.74,0,0,0-1.74,1.31c-.53.55-1,3.59-1.63,4.92a37.93,37.93,0,0,1-2,3.28c-1.1,1.81-2.81,3.33-2.19,8.63s2.66,8.15,4.53,9.76a5.62,5.62,0,0,0,2.42,1.09s2.94-.53,2.82-2.24S131.07,374.15,131.07,374.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.11,381.9c-.17.5-1,1.16-1.41,1.52A14,14,0,0,0,138,388.1c-3.1,7.62-.7,12.24-5.52,14.41-1.38.55-3.91-.14-6.87-5.86-1.52-2.92-1.67-8.38-.45-10.61s2.56-3.58,3.41-5.32,1.21-5.19,2.51-6.57a7.61,7.61,0,0,1,2.87-1.67c.85-.31,2.61-.61,3.47-.91s1.37-.71,1.76-.06l-1.1.94c-1.74,1.66-1.41,2-1.57,3.05a16.09,16.09,0,0,1-1.12,3.16c1.22-1.06,1.83-2.07,2.87-1.68s1.18.36,2.46,2.1S142.27,381.45,142.11,381.9Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.11,381.9c-.17.5-1,1.16-1.41,1.52A14,14,0,0,0,138,388.1c-3.1,7.62-.7,12.24-5.52,14.41-1.38.55-3.91-.14-6.87-5.86-1.52-2.92-1.67-8.38-.45-10.61s2.56-3.58,3.41-5.32,1.21-5.19,2.51-6.57a7.61,7.61,0,0,1,2.87-1.67c.85-.31,2.61-.61,3.47-.91s1.37-.71,1.76-.06l-1.1.94c-1.74,1.66-1.41,2-1.57,3.05a16.09,16.09,0,0,1-1.12,3.16c1.22-1.06,1.83-2.07,2.87-1.68s1.18.36,2.46,2.1S142.27,381.45,142.11,381.9Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.6,396.65c-1.52-2.92-1.67-8.38-.45-10.61a21.51,21.51,0,0,1,1.34-2.14c-.06.16-.14.31-.19.45-.11.3-.2.6-.29.9a7.28,7.28,0,0,0-.28,3.67c.27,1.07.84,3.74,2.16,4.05a2,2,0,0,0,2-1.24c.19-.34.57-1.26.57-1.26a11.87,11.87,0,0,1,3.2,2.06c1.7,1.64,1.57,1.91,1.57,1.91a5.23,5.23,0,0,0-.38,1.69,4.24,4.24,0,0,0,.41,1.82,2.52,2.52,0,0,0,.42.49,5.25,5.25,0,0,1-3.19,4.07C131.09,403.06,128.56,402.37,125.6,396.65Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,388.1a27.15,27.15,0,0,0-1.68,6.24c-1.1,1.89-1.73,1.71-1.62.65s2.32-5.17,4-8.58C138.45,387,138.21,387.55,138,388.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.53,374.49a4.48,4.48,0,0,1,1.32-2.75c.21-.06.4-.11.56-.17.92-.31,1.37-.71,1.76-.06l-1.1.94c-1.74,1.66-1.41,2-1.57,3.05a16.09,16.09,0,0,1-1.12,3.16C133.93,382,133,383,132,386.14s-.74,5.49-1.23,5.59-1.36-.44-1-3.08,2.28-6.8,3.48-8.72S135.44,375.91,135.53,374.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.16,390.65a.37.37,0,0,0,.15.13,7.85,7.85,0,0,1,4.63,4,.34.34,0,0,0,.45.12.33.33,0,0,0,.12-.45,8.5,8.5,0,0,0-4.95-4.29.33.33,0,0,0-.43.18A.35.35,0,0,0,130.16,390.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.08,388a.36.36,0,0,0,.15.12,8.9,8.9,0,0,1,4.85,4.34.33.33,0,0,0,.46.13.34.34,0,0,0,.13-.46,9.54,9.54,0,0,0-5.17-4.63.34.34,0,0,0-.45.18A.33.33,0,0,0,131.08,388Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.58,385a.36.36,0,0,0,.16.14,10.06,10.06,0,0,1,5.42,4.87.37.37,0,0,0,.65-.37,10.85,10.85,0,0,0-5.77-5.19.37.37,0,0,0-.49.2A.34.34,0,0,0,131.58,385Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.49,382.56a.38.38,0,0,0,.15.13,9.75,9.75,0,0,1,5.31,4.76.37.37,0,1,0,.63-.37,10.55,10.55,0,0,0-5.64-5.06.36.36,0,0,0-.48.19A.34.34,0,0,0,132.49,382.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.89,380.25a.38.38,0,0,0,.15.13,9.77,9.77,0,0,1,5.3,4.76.37.37,0,0,0,.5.13.36.36,0,0,0,.14-.5,10.58,10.58,0,0,0-5.64-5.06.37.37,0,0,0-.49.19A.36.36,0,0,0,133.89,380.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.79,331.57s28.94,4.49,39.27,7.29c10.54,2.86,9.42,11,5.5,15.2-7.51,8-28.87,22.63-28.87,22.63s-6.05-3.72-6.51-9.31l5.86-8.29-21.21-2.59-3-3.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.18,368.14c-1.51-3.49-2.84-4.56-6.55-7.06l-4.45,6.3c.46,5.59,6.51,9.31,6.51,9.31s2.46-1.69,6-4.23A42.47,42.47,0,0,0,153.18,368.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.75,350.77c-1.85,1.63-3.47,3.1-4.89,4.53s-4.69,1.45-7.61,0a61.91,61.91,0,0,1-9.73-6.63c3.31-3.69,2-9.09,2-9.09a11.85,11.85,0,0,1-3.61,7.82l-1.79,1.25-.64,5.57,1,2.19L148,359.09c5.92-7.7,8-11.24,12.92-11.82C161,347.27,157.21,346,151.75,350.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.12,411.93l-.3-1L140.91,393l13-4.88c1.69,9.21,3.78,21.34,5.75,24.53,0,0-3.53,5.48-7,4.84S148.29,414,148.12,411.93Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.57,418.46a5.49,5.49,0,0,0,.74,2.05c.37.67,3.15,2,4.23,3s1.27,1.48,2.54,2.91,2.36,3.66,7.61,4.62,8.57-.17,10.66-1.49a5.54,5.54,0,0,0,1.74-2s.36-3-1.3-3.35S148.57,418.46,148.57,418.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.2,410.17a6.25,6.25,0,0,1,1.05,1.79,13.88,13.88,0,0,0,3.67,4c6.39,5.19,11.5,4.24,12.18,9.48.12,1.49-1.28,3.7-7.62,4.86-3.23.6-8.5-.85-10.28-2.66s-2.67-3.51-4.08-4.82-4.61-2.68-5.55-4.33a7.34,7.34,0,0,1-.76-3.23c-.06-.9-.08-3.94-.08-3.94,1.08,2.16,2.77,1.92,3.71,2.38a16.11,16.11,0,0,1,2.7,2c-.66-1.48-1.45-2.36-.77-3.24s.69-1,2.73-1.74S158.82,409.89,159.2,410.17Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.2,410.17a6.25,6.25,0,0,1,1.05,1.79,13.88,13.88,0,0,0,3.67,4c6.39,5.19,11.5,4.24,12.18,9.48.12,1.49-1.28,3.7-7.62,4.86-3.23.6-8.5-.85-10.28-2.66s-2.67-3.51-4.08-4.82-4.61-2.68-5.55-4.33a7.34,7.34,0,0,1-.76-3.23c-.06-.9-.08-3.94-.08-3.94,1.08,2.16,2.77,1.92,3.71,2.38a16.11,16.11,0,0,1,2.7,2c-.66-1.48-1.45-2.36-.77-3.24s.69-1,2.73-1.74S158.82,409.89,159.2,410.17Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.48,430.27c-3.23.6-8.5-.85-10.28-2.66a21.89,21.89,0,0,1-1.64-1.91l.36.31.78.54a7.3,7.3,0,0,0,3.43,1.34c1.1.06,3.82.29,4.5-.89a2,2,0,0,0-.61-2.25c-.26-.28-1-.91-1-.91a11.91,11.91,0,0,1,2.9-2.46c2.07-1.14,2.29-.95,2.29-.95a5.21,5.21,0,0,0,1.5.86,4.18,4.18,0,0,0,1.87.14,2.74,2.74,0,0,0,.58-.25,5.23,5.23,0,0,1,3,4.23C176.22,426.9,174.82,429.11,168.48,430.27Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.92,415.93a26.88,26.88,0,0,0,5.48,3.42c1.49,1.61,1.14,2.16.15,1.74s-4.27-3.73-7-6.36C163,415.15,163.46,415.55,163.92,415.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.19,414.3a6.09,6.09,0,0,1-2.41-1.21c-.45-.42-.15-1.64,0-2.18l.34,1.09a11.39,11.39,0,0,0,3.28,1.67,16.11,16.11,0,0,1,2.7,2c2.72,2.34,3.41,3.55,6.16,5.42s5,2.31,5,2.81-.81,1.17-3.24.09-5.84-4.17-7.33-5.87S151.53,414.8,150.19,414.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.08,424.15a.27.27,0,0,0,.16-.1,7.92,7.92,0,0,1,5.19-3.26.32.32,0,0,0,.25-.39.33.33,0,0,0-.39-.25,8.55,8.55,0,0,0-5.56,3.48.33.33,0,0,0,.05.46A.28.28,0,0,0,164.08,424.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.83,422.51a.34.34,0,0,0,.16-.1,8.84,8.84,0,0,1,5.57-3.38.32.32,0,0,0,.25-.4.33.33,0,0,0-.4-.26,9.48,9.48,0,0,0-5.93,3.6.33.33,0,0,0,0,.47A.35.35,0,0,0,161.83,422.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.11,421.16a.36.36,0,0,0,.18-.12,10.07,10.07,0,0,1,6.24-3.76.37.37,0,0,0,.28-.45.38.38,0,0,0-.45-.28,10.83,10.83,0,0,0-6.64,4,.38.38,0,0,0,0,.52A.38.38,0,0,0,159.11,421.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,419.57a.38.38,0,0,0,.17-.12,9.8,9.8,0,0,1,6.1-3.68.36.36,0,0,0,.27-.43.37.37,0,0,0-.44-.28,10.5,10.5,0,0,0-6.49,3.92.38.38,0,0,0,0,.52A.4.4,0,0,0,157,419.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.22,417.56a.38.38,0,0,0,.17-.12,9.8,9.8,0,0,1,6.1-3.68.36.36,0,0,0-.16-.71,10.5,10.5,0,0,0-6.5,3.92.36.36,0,0,0,0,.51A.38.38,0,0,0,155.22,417.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.84,404.5c-3.41,3.54-11.65,3.29-11.65,3.29s-2.36-4.52-6.64-14.41c-2.38-5.53-3.71-8-4.72-15.74-7.24-3.55-20.12-8.65-32.33-17.78-8.75-6.53-10.13-15.41-9-25.93,1.36-12.92,39.31-2.36,39.31-2.36-2.5,7-1.94,13.91-6.68,17.08,0,0,15.28,11,20.44,14.88,2.37,1.8,3.49,2.39,4.63,7.84C154.51,387.33,157.84,404.5,157.84,404.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,407.75l.68,0c-2.63-4.94-6.59-15.53-8.07-20.1-.48-1.49-1.47-5.68-1.76-6.82-1.4-5.48-1.6-7.48-3.11-8-.38-.13-1.21-.62-2.51-1.26-6.61-3.28-22.62-11.41-28.14-16.61-.17-.15-.32-.31-.47-.47,2.78-1.61,3.65-5.86,2.64-8.88-1.08-3.24-1-9.08.69-11.49l-.49-.35c-2,2.8-1.79,9-.78,12,.95,2.83.06,6.88-2.51,8.24-5.16-5.5-6.49-13.08-3.82-22l-.59-.17c-2.88,9.68-1.18,17.83,4.91,23.56,5.59,5.25,21.66,13.41,28.29,16.7l2.49,1.25c1.44.78,2,4.55,2.79,7.71.3,1.16,1.29,5.3,1.81,6.8C141.65,392.47,145.51,402.94,148,407.75Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.48,359l26.46-16.73-21.22-11.14-4.44-.29-37.34,23.6a.3.3,0,0,0,0,.51l23.44,12.31,12.54-7.92c-1.8-1.05-4.16-2.41-6.65-3.83l9.06.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--arm--inject-49",
    d: "M119.24,283.48c6.1-.42,11.31,3.18,12,8,.74,5-1.68,20.05-1.68,20.05l11.08,7.67-5.79,8.15s-10.64-4.61-14.33-6.34c-5.63-2.64-4.83-4.36-4.81-11.28S118.56,287.4,119.24,283.48Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.26,283.47a14.89,14.89,0,0,1,4.73.42,12.16,12.16,0,0,1,5.5,3.39c1.42,1.82,2.1,3.31,2.06,7.48s-1.2,12.79-1.2,12.79l-9.07.07Z",
    style: {
      fill: "#0B1D51"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130,299c-1-11.34-4.91-15.15-10.7-15.55a114.82,114.82,0,0,0-12.63,1.23,49.92,49.92,0,0,0-13.88,5.38c-2.87,1.79-3.79,5.63-3.84,13.66a180.25,180.25,0,0,0,1.5,23.16,120.55,120.55,0,0,0,4,20c8,2.67,39.65-7,39.41-17.15-.83-2.32-2.25-5-2.9-9.71C130.05,311.75,130.28,302.58,130,299Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.83,280.57c-.33-3.2-3.27-6.72-4.5-9.57s-1.87-4.87-1.55-7.37c.19-1.47,1.25-3.42,2.38-3.77-.91-5.6,3.32-7.53,5.22-8.06.84-.24,2.67-.56,3.5-.85,1.23-.42,1.56-1.36,2.58-2.11,1.75-1.3,4.54-1.15,5.46,1,1.2-1.35,2.69-1.22,4.39-.66a3,3,0,0,1,2,3.48,3.11,3.11,0,0,1,4.53,2c.09,1-.18,1.84.42,2.78a1.54,1.54,0,0,0,2.54.35c.15,1.44-.48,2.49-2,2.3a3.23,3.23,0,0,1,.22,2.75,3,3,0,0,1-2.8,1.86,5,5,0,0,1-.83,2.13,5.15,5.15,0,0,1-1.92,1.51,32,32,0,0,1-7.58,1.51l-3,.42c-.18,0-1.08,0-1.2.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.26,276.22a3.07,3.07,0,0,0,3.74.14l-.85,10.43c1.45,4.59,9,5.84,11.89,4.76s2.63-2.75,1-5.37l.3-1.7a30.69,30.69,0,0,0,3.78.08c2.51-.17,4.51-2.07,5.39-4.71a27.9,27.9,0,0,0,1-10.64,9.13,9.13,0,0,1,0-2.61,12.29,12.29,0,0,0-.41-5.65c-2.58-2.38-8.85-3.55-15-.35.45,3.55-1.1,6.24-3.74,7.41.06.95,0,3.35-1.54,3.2-1.12-.1-1.1-1.51-2.17-2.83s-3.73-1.82-4.89-.07A6.07,6.07,0,0,0,99.26,276.22Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.85,266.38l-7.59,1.56a3,3,0,0,1,1,1.27l6.61-1.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.32,265.47l-.49,0a14.46,14.46,0,0,0-5,.42c-1.62.58-2.23,1.17-3.11,1.22s-1.47-.48-3.11-.89a16.27,16.27,0,0,0-5.27.11l-.54.09a1.12,1.12,0,0,0-.7.95,1.72,1.72,0,0,0,.37,1,1,1,0,0,1,.12.42,18,18,0,0,0,.29,3,3.08,3.08,0,0,0,.55,1.06,2.27,2.27,0,0,0,.32.3l.19.14a2.52,2.52,0,0,0,.57.27l.1,0,.15,0,.17,0a3.92,3.92,0,0,0,.52.06H113a4.4,4.4,0,0,0,3.93-2.46c.67-1.16.68-2.75,1.69-2.8h.18c.73.14.51,1.61.88,2.65a3.9,3.9,0,0,0,.62,1.13,1.29,1.29,0,0,0,.16.17.3.3,0,0,0,.08.08l.09.08.08.06.09.07.07,0,0,0a2.81,2.81,0,0,0,.86.33h.08a4.48,4.48,0,0,0,1.07.06,3.64,3.64,0,0,0,3.28-2.27,21.11,21.11,0,0,0,.83-3,1.16,1.16,0,0,1,.21-.4,2.26,2.26,0,0,0,.53-1.1C127.86,265.9,127.59,265.49,127.32,265.47Zm-10.83,4.72a4.13,4.13,0,0,1-.93,1.63h0a3.56,3.56,0,0,1-2.52,1.05,2.19,2.19,0,0,1-2.18-1.05.3.3,0,0,1-.06-.11l-.06-.11,0-.1,0-.1a.19.19,0,0,1,0-.07l0-.07,0-.11h0a2.17,2.17,0,0,1-.07-.33h0l0-.2c0-.11,0-.22,0-.31v-.12c-.07-.78-.08-2.32.34-2.68a4.64,4.64,0,0,1,3-.7H114a6.09,6.09,0,0,1,.73.1l.28,0a6.22,6.22,0,0,1,.69.21l.21.08.23.11,0,0,.09.05a1.22,1.22,0,0,1,.44.38A3.66,3.66,0,0,1,116.49,270.19Zm9.57-.84a4,4,0,0,1-1.73,2.63,2.91,2.91,0,0,1-1.25.35,2.27,2.27,0,0,1-2.36-1.07h0a.43.43,0,0,0,0-.07l0-.09,0,0a.61.61,0,0,1,0-.12.88.88,0,0,1,0-.15l0-.07v0l0-.06a.43.43,0,0,0,0-.05,3.53,3.53,0,0,1-.1-.58,4,4,0,0,1,.26-2.38,5.07,5.07,0,0,1,2.75-1.29c.27-.05.52-.08.75-.1h.65l.2,0a2.2,2.2,0,0,1,.37,0h.16l.09,0,.11,0,.17.07h0a1.31,1.31,0,0,1,.38.24C126.58,267,126.28,268.55,126.06,269.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.61,273.87l-3.87,1.7-1-6.38c.2-.43.44-.73.88-.76h.19a.34.34,0,0,1,.12,0l0,0,.18.18a10.22,10.22,0,0,1,1.21,1.55c.38.56.77,1.18,1.16,1.83.22.36.43.72.64,1.09S122.47,273.63,122.61,273.87Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.33,284.48c-3.91-.72-6.87-1.35-8.74-4.34a25,25,0,0,1-2.06-4.83,19.25,19.25,0,0,0,1.3,6c.87,1.88,3.11,3.65,9.25,4.59Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,269.75a1.11,1.11,0,1,1-1.09-1.18A1.15,1.15,0,0,1,115,269.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.64,264.62l-2.62.73a1.42,1.42,0,0,1,1-1.71A1.32,1.32,0,0,1,114.64,264.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,276.19l3.62,1.33a2,2,0,0,1-2.55,1.16A1.88,1.88,0,0,1,114,276.19Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.17,278.76a2.29,2.29,0,0,0-2.26-2,1.85,1.85,0,0,0,1.19,2A2,2,0,0,0,116.17,278.76Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.66,265.2l-2.69-.48a1.31,1.31,0,0,1,1.54-1.13A1.44,1.44,0,0,1,124.66,265.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.58,269.48a1.11,1.11,0,0,1-1.22,1,1.15,1.15,0,1,1,1.22-1Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M103,267.36l-4.28-.13s-.72-4.23-1-6.76c0-.49-.08-.91-.08-1.23,0-.15,0-.28,0-.43,0-1.79.19-3.4,2.12-4.91a11.88,11.88,0,0,1,4.58-2.1,6.05,6.05,0,0,0-2,1.48,5,5,0,0,0-1.24,2.59,4.44,4.44,0,0,0-.06,1c0,.46.07,1,.15,1.61C101.63,262,103,267.36,103,267.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.79,274.8a10,10,0,0,0-1.49-9,4.29,4.29,0,0,0-1.75-1.34,2.52,2.52,0,0,0-1.34-.14l-1.51.24A3.43,3.43,0,0,0,96.26,267a10,10,0,0,0,1.49,9,4.32,4.32,0,0,0,1.75,1.35,2.66,2.66,0,0,0,1.35.14l1.49-.25A3.41,3.41,0,0,0,104.79,274.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5,277.32A4.32,4.32,0,0,1,97.75,276a10,10,0,0,1-1.49-9c.74-2,2.22-2.85,3.79-2.26a4.21,4.21,0,0,1,1.75,1.34,10,10,0,0,1,1.49,9C102.55,277,101.07,277.9,99.5,277.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,274.94a9.66,9.66,0,0,0-1.44-8.64,3.08,3.08,0,0,0-2.79-1.38l-.75.13a3.07,3.07,0,0,0-2.2,2.2,9.67,9.67,0,0,0,1.44,8.64,3.06,3.06,0,0,0,2.79,1.37l.75-.12A3.09,3.09,0,0,0,103,274.94Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.8,266.42a9.67,9.67,0,0,1,1.44,8.64c-1,2.62-3.22,3-5,.83a9.67,9.67,0,0,1-1.44-8.64C96.8,264.64,99,264.26,100.8,266.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.24,275.06a9.67,9.67,0,0,0-1.44-8.64A3.05,3.05,0,0,0,98,265.05c-.25,0-.71.15-1,.19a3.08,3.08,0,0,0-2.19,2.2,9.69,9.69,0,0,0,1.43,8.64,3.11,3.11,0,0,0,2.79,1.38l1-.2A3.09,3.09,0,0,0,102.24,275.06Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.84,266.61a9.7,9.7,0,0,1,1.43,8.64c-1,2.62-3.21,3-5,.83a9.69,9.69,0,0,1-1.43-8.64C95.83,264.83,98.06,264.46,99.84,266.61Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.45,269a5.08,5.08,0,0,1,.75,4.54c-.52,1.37-1.69,1.57-2.62.43a5.06,5.06,0,0,1-.75-4.53C96.34,268.1,97.52,267.91,98.45,269Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.15,270.75l-1.75.79-.53-3.2a1.59,1.59,0,0,1,1.46.72A4.52,4.52,0,0,1,99.15,270.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.08,273.6a1.59,1.59,0,0,1-1.15,1.15l-.53-3.21,1.75-.79A4.91,4.91,0,0,1,99.08,273.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.93,274.75a1.61,1.61,0,0,1-1.47-.72,4.36,4.36,0,0,1-.81-1.69l1.75-.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4,271.54l-1.75.8a4.88,4.88,0,0,1,.06-2.84,1.62,1.62,0,0,1,1.16-1.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--laptop--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.87,350.17v.75a2.15,2.15,0,0,0,1,1.84L133,364.44a2.11,2.11,0,0,0,1.06.29,2.07,2.07,0,0,0,1-.28l37.07-21.18a2.14,2.14,0,0,0,1.07-1.83v-.51l-39.19,22.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.27,340.93,151.4,328.17a1.29,1.29,0,0,0-1.26,0L112,350a.29.29,0,0,0,0,.49l22.07,12.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.89 361.46 122.1 354.59 156.76 334.78 168.61 341.61 133.89 361.46",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.16 342.46 128.38 342.59 134.16 345.96 144.49 340.06 144.71 339.94 138.71 336.44 128.16 342.46",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.38 342.59 134.16 345.96 144.49 340.06 138.71 336.69 128.38 342.59",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.08,363.32v1.41a2.07,2.07,0,0,0,1-.28l37.07-21.18a2.14,2.14,0,0,0,1.07-1.83v-.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.08,363.32v1.41a2.07,2.07,0,0,0,1-.28l37.07-21.18a2.14,2.14,0,0,0,1.07-1.83v-.51Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164.13,334.78c-1.23-1.7-2.75-3.19-3.88-5a30.49,30.49,0,0,0-3.59-3.1c-3.67-2.56-4.61-2.48-9.22-3.89a19.83,19.83,0,0,1-6.78-3.58l-5.79,8.15c.68.37,1.34.75,2,1.13,1,.63,2.4,2.91,4.75,3.77,3.11,1.14,6.75.29,7.1,1.18a7,7,0,0,0,.25,1.68,6.21,6.21,0,0,0-1.81-.45c-.57,0-1.38.69-1.21,1.08s.53.54.94.86,1.26,1,1.39,1.08a5.51,5.51,0,0,0,2.91.42,1.28,1.28,0,0,0,.94-.84,5,5,0,0,0,.66.23,1.74,1.74,0,0,0,1.27-.1,1,1,0,0,0,.39-.6,5.37,5.37,0,0,0,1.53-.33c.68-.39.68-1.24.79-1.91a8.53,8.53,0,0,0,.07-2.57c2.08,1.24,3.72,3.58,6.24,4C164,336.13,165.13,335.77,164.13,334.78Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.63,326c.51-9.87,1.05-18.81,2.19-26.07.63-4,4.3-7.87,8.15-9.44,5.68,3.09,5.42,14.53,5,17.35l-2.09,17.45s5,3.16,10.15,6.08c4.38,2.46,7.27,4.5,12.09,4.48s6.73-.41,9.33.37c1.39.41,4.56,1.38,5.65,1.77s3.16,2,5,3.07-.16,2-1.44,1.82a15.92,15.92,0,0,1-4-1.35,20.79,20.79,0,0,0-3.35-.84,19.61,19.61,0,0,1,1.13,3.66c.09.68.34,1.49-.19,2.06a5.37,5.37,0,0,1-1.36.77,1.06,1.06,0,0,1-.2.69,1.72,1.72,0,0,1-1.18.46,5.33,5.33,0,0,1-.71,0,1.26,1.26,0,0,1-.65,1.08,5.51,5.51,0,0,1-2.9.45c-.15,0-1.3-.49-1.64-.62a2.92,2.92,0,0,1-1.16-.54c-.28-.33.29-1.23.84-1.38a5.61,5.61,0,0,1,1.87-.11,6.57,6.57,0,0,1-.74-1.53c-.6-.75-4.15.52-7.46.35-2.5-.13-4.55-2.23-5.71-2.6-7.42-2.31-13.07-3.88-20.7-7.3C81.64,333,82.36,331.14,82.63,326Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,340.85c-.49-.88-1.2-1.91-1.94-2.08a8.59,8.59,0,0,1,1.28,1.94Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,347.2a8.17,8.17,0,0,0-.18-2,19.47,19.47,0,0,0-.51-2,8.86,8.86,0,0,0-.78-1.89,3.74,3.74,0,0,0-1.4-1.47,3.31,3.31,0,0,1,.65.75,7.32,7.32,0,0,1,.49.86,14.29,14.29,0,0,1,.67,1.87c.21.63.39,1.27.59,1.91A18.63,18.63,0,0,1,129,347.2Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.86,348.33a8.79,8.79,0,0,0-.24-2,16.06,16.06,0,0,0-.53-1.92,13.49,13.49,0,0,0-.77-1.84A3.79,3.79,0,0,0,124.1,341a2.48,2.48,0,0,1,.55.8c.14.29.27.59.39.89.24.61.47,1.23.68,1.85C126.14,345.8,126.55,347,126.86,348.33Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.35,347.32a3.27,3.27,0,0,1,.83,0c.27,0,.47.14.82.21l-.16-.2a.74.74,0,0,0,.1.38.93.93,0,0,0,.22.29,1.16,1.16,0,0,0,.6.29,3.18,3.18,0,0,1-.39-.46,1.87,1.87,0,0,1-.12-.25,1.11,1.11,0,0,1,0-.23v-.15l-.16,0a2.48,2.48,0,0,0-.8-.06A1.62,1.62,0,0,0,121.35,347.32Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,289.93a13.92,13.92,0,0,0-8.45,10c-1.37,6.19-1.92,18.47-1.92,18.47s2.06,1.94,7.52,2.43S97,320,97,320s.92-8.61,1.33-12.59S99.21,292.32,93,289.93Z",
    style: {
      fill: "#0B1D51"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.68,363.64a2.53,2.53,0,0,0,2.16-.16l36.9-21.09a2.47,2.47,0,0,0,1.22-1.75l4.14-24a2.93,2.93,0,0,0,0-.41,2.51,2.51,0,0,0-.73-1.79l-38.35,21.93a1.81,1.81,0,0,0-.9,1.29Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.68,363.64a2.53,2.53,0,0,0,2.16-.16l36.9-21.09a2.47,2.47,0,0,0,1.22-1.75l4.14-24a2.93,2.93,0,0,0,0-.41,2.51,2.51,0,0,0-.73-1.79l-38.35,21.93a1.81,1.81,0,0,0-.9,1.29Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.08,363.32l.26.15.34.17,4.47-26a1.81,1.81,0,0,1,.9-1.29l38.35-21.93a3.42,3.42,0,0,0-.51-.39l-38.42,22a1.85,1.85,0,0,0-.91,1.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.51,341.54a8.08,8.08,0,0,1,3.73-4.76c1.78-1,3-.54,2.73,1.07a8.16,8.16,0,0,1-3.73,4.76C156.45,343.63,155.23,343.15,155.51,341.54Z",
    style: {
      fill: "#0B1D51"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table2--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--table--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.74,412.68a1.29,1.29,0,0,0-.88-1,4.11,4.11,0,0,0-3.71.39,1.3,1.3,0,0,0-.65,1.15l6.69,32.48h0a.93.93,0,0,0,.62.68,2.93,2.93,0,0,0,2.62-.27,1,1,0,0,0,.46-.8h0Zm-73.76-.6a4.1,4.1,0,0,0-3.71-.39,1.29,1.29,0,0,0-.88,1l-5.16,32.64h0a1,1,0,0,0,.46.8,3,3,0,0,0,2.63.27.93.93,0,0,0,.61-.68h0l6.69-32.48A1.3,1.3,0,0,0,225,412.08Zm36.6,14.08a4.09,4.09,0,0,0-3.73,0,1.3,1.3,0,0,0-.77,1.07l.77,35.14h0a.91.91,0,0,0,.54.74,2.92,2.92,0,0,0,2.64,0,1,1,0,0,0,.54-.74h0l.77-35.14A1.26,1.26,0,0,0,261.58,426.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,412.08a4.1,4.1,0,0,0-3.71-.39,1.29,1.29,0,0,0-.88,1l-1.3,8.32a35.25,35.25,0,0,0,4.2,3.6l2.34-11.37A1.3,1.3,0,0,0,225,412.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.74,412.68a1.29,1.29,0,0,0-.88-1,4.11,4.11,0,0,0-3.71.39,1.3,1.3,0,0,0-.65,1.15l2.36,11.45a35.66,35.66,0,0,0,4.24-3.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.2,434.3l.15-7.07a1.26,1.26,0,0,0-.77-1.07,4.09,4.09,0,0,0-3.73,0,1.3,1.3,0,0,0-.77,1.07l.16,7.07C258.89,434.35,260.55,434.35,262.2,434.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,398.88h-.05c0-7-4.57-14-13.8-19.29-18.46-10.66-48.39-10.66-66.85,0-9.23,5.32-13.8,12.31-13.8,19.29h0v3.75h0c.11,6.9,4.73,13.77,13.84,19,18.46,10.65,48.39,10.65,66.85,0,9.11-5.26,13.74-12.13,13.85-19h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.29,379.59c-18.46,10.65-18.46,27.93,0,38.59s48.39,10.66,66.85,0,18.46-27.94,0-38.59S244.75,368.93,226.29,379.59Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-49",
    d: "M290.1,395.39c2.81,1.62,2.81,4.25,0,5.87a11.23,11.23,0,0,1-10.16,0c-2.81-1.62-2.81-4.25,0-5.87A11.23,11.23,0,0,1,290.1,395.39Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coffee--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293,396.53a4.78,4.78,0,0,0,1.91-.27c.85-.31,1.59-1.22,2.26-2.79.57-1.32,1.48-4.21.84-5.71-.82-1.89-3.11-2-4.64-2l-.52,0-.09,1.81c.18,0,.47.06.67.07.86,0,2.74.32,2.95.81.71,1.17-1.1,5.69-1.89,6.18a7,7,0,0,1-2.95,0l-.59,1.52A7.12,7.12,0,0,0,293,396.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,383.57c.18-.77.94-1.53,2.29-2.14a16.35,16.35,0,0,1,11.37-.12c1.37.58,2.14,1.32,2.33,2.09h.05c.59,5.07-.26,11-2,14.24l0,.07,0,.05h0a3.93,3.93,0,0,1-1.47,1.41,9.54,9.54,0,0,1-8.63.09,3.73,3.73,0,0,1-1.49-1.38h0l0,0a.3.3,0,0,1,0-.08c-1.84-3.24-2.81-9.11-2.33-14.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.31,381.43c-3.12,1.4-3.1,3.61.05,4.94a16.3,16.3,0,0,0,11.37-.12c3.13-1.39,3.11-3.61-.05-4.94A16.35,16.35,0,0,0,279.31,381.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.42,382.28c-2.52.92-2.51,2.36,0,3.23a16.12,16.12,0,0,0,9.18-.1c2.52-.92,2.5-2.36,0-3.23A16.08,16.08,0,0,0,280.42,382.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.44,384.23a5.13,5.13,0,0,0-1.27.65,5.08,5.08,0,0,0,1.28.63,16.12,16.12,0,0,0,9.18-.1,5,5,0,0,0,1.26-.65,4.76,4.76,0,0,0-1.28-.63A16.08,16.08,0,0,0,280.44,384.23Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.44,384.23a5.13,5.13,0,0,0-1.27.65,5.08,5.08,0,0,0,1.28.63,16.12,16.12,0,0,0,9.18-.1,5,5,0,0,0,1.26-.65,4.76,4.76,0,0,0-1.28-.63A16.08,16.08,0,0,0,280.44,384.23Z",
    style: {
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book-shelf--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-49",
    d: "M238.56,409.89l-20.19-11.66a.58.58,0,0,1,0-1.09l28.14-16.24a2.08,2.08,0,0,1,1.88,0l20.19,11.66a.57.57,0,0,1,0,1.08l-28.13,16.25A2.1,2.1,0,0,1,238.56,409.89Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.69 397.75 239.39 406.7 265.31 391.82 249.62 382.87 223.69 397.75",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.69 397.75 239.39 406.7 265.31 391.82 249.62 382.87 223.69 397.75",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.57,406l-15.14-8.69a6.31,6.31,0,0,0-.08-3.93l15,8.6A14.81,14.81,0,0,1,239.57,406Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.62,400.77a3.21,3.21,0,0,1,1.45,2.51v2.92c0,.92-.65,1.3-1.45.84l-14.92-8.56v-.73l14.71,8.4c.49.27.88.05.88-.51l0-2.71a1.92,1.92,0,0,0-.87-1.5L223.7,393v-.82Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.62,400.77a3.21,3.21,0,0,1,1.45,2.51v2.92c0,.92-.65,1.3-1.45.84l-14.92-8.56v-.73l14.71,8.4c.49.27.88.05.88-.51l0-2.71a1.92,1.92,0,0,0-.87-1.5L223.7,393v-.82Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.7,392.21l25.92-14.87,14.92,8.56a3.19,3.19,0,0,1,1.45,2.5v2.93a1,1,0,0,1-.42.93l-25.93,14.88a1,1,0,0,0,.43-.94v-2.92a3.21,3.21,0,0,0-1.45-2.51Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.7,392.21l25.92-14.87,14.92,8.56a3.19,3.19,0,0,1,1.45,2.5v2.93a1,1,0,0,1-.42.93l-25.93,14.88a1,1,0,0,0,.43-.94v-2.92a3.21,3.21,0,0,0-1.45-2.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.64,401.85a2.92,2.92,0,0,1,.43,1.43v2.92a1,1,0,0,1-.43.94l25.93-14.88a1,1,0,0,0,.42-.93V388.4a2.94,2.94,0,0,0-.42-1.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.7 390.41 239.39 399.36 265.31 384.48 249.62 375.53 223.7 390.41",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.57,398.68,224.43,390a6.24,6.24,0,0,0-.08-3.93l15,8.6A14.81,14.81,0,0,1,239.57,398.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.62,393.43a3.19,3.19,0,0,1,1.45,2.51v2.92c0,.92-.65,1.3-1.45.84l-14.92-8.57v-.72l14.72,8.39c.48.28.87.06.87-.5l0-2.71a1.92,1.92,0,0,0-.87-1.5l-14.7-8.4v-.82Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.62,393.43a3.19,3.19,0,0,1,1.45,2.51v2.92c0,.92-.65,1.3-1.45.84l-14.92-8.57v-.72l14.72,8.39c.48.28.87.06.87-.5l0-2.71a1.92,1.92,0,0,0-.87-1.5l-14.7-8.4v-.82Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.7,384.87,249.62,370l14.92,8.57a3.19,3.19,0,0,1,1.45,2.5V384a1,1,0,0,1-.42.94L239.64,399.8a1,1,0,0,0,.43-.94v-2.93a3.19,3.19,0,0,0-1.45-2.5Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.7,384.87,249.62,370l14.92,8.57a3.19,3.19,0,0,1,1.45,2.5V384a1,1,0,0,1-.42.94L239.64,399.8a1,1,0,0,0,.43-.94v-2.93a3.19,3.19,0,0,0-1.45-2.5Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.65,394.51a2.94,2.94,0,0,1,.42,1.42v2.93a1,1,0,0,1-.43.94l25.93-14.88A1,1,0,0,0,266,384v-2.92a3,3,0,0,0-.42-1.43Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.65,394.51a2.94,2.94,0,0,1,.42,1.42v2.93a1,1,0,0,1-.43.94l25.93-14.88A1,1,0,0,0,266,384v-2.92a3,3,0,0,0-.42-1.43Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274,418.67a3.14,3.14,0,0,1-.49,1.16,5.61,5.61,0,0,1-1.87,1.66,13,13,0,0,1-11.71,0,5.61,5.61,0,0,1-1.87-1.66,3.14,3.14,0,0,1-.49-1.16h0c-.28-1.4.51-2.87,2.37-3.94a12.92,12.92,0,0,1,11.71,0C273.49,415.8,274.28,417.27,274,418.67Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.22,411.62H258.33l1.54,6.41h0a3.13,3.13,0,0,0,1.71,2.12,9.26,9.26,0,0,0,8.39,0,3,3,0,0,0,1.72-2.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.4,416a7.12,7.12,0,0,0,.9-.63l.83-3.43a5.81,5.81,0,0,1-1.5,1.2,13,13,0,0,1-11.43.15l.38-1.53-.12-.16h-2.13l1.54,6.41h0a3.13,3.13,0,0,0,1.71,2.12,9.31,9.31,0,0,0,6.1.82c-3.71.28-6.26-1.35-6.64-2.84-.15-.6-.42-1.92-.42-1.92A12.46,12.46,0,0,0,271.4,416Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,409.72a3.14,3.14,0,0,1-.49,1.16,5.61,5.61,0,0,1-1.87,1.66,13,13,0,0,1-11.71,0,5.61,5.61,0,0,1-1.87-1.66,3.14,3.14,0,0,1-.49-1.16h0c-.28-1.4.51-2.86,2.37-3.94a12.92,12.92,0,0,1,11.71,0C273.49,406.86,274.28,408.32,274,409.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.5,410.88a5.61,5.61,0,0,1-1.87,1.66,13,13,0,0,1-11.71,0,5.61,5.61,0,0,1-1.87-1.66,3.14,3.14,0,0,1-.49-1.16h0l.37,2.52A4.21,4.21,0,0,0,260.2,415a12.31,12.31,0,0,0,11.15,0,4.24,4.24,0,0,0,2.27-2.75l0-.13.35-2.43A3.14,3.14,0,0,1,273.5,410.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.65,406.34a10.8,10.8,0,0,0-9.75,0c-1.53.88-2.19,2.07-2,3.22a3.67,3.67,0,0,0,2,2.41,10.74,10.74,0,0,0,9.75,0,3.7,3.7,0,0,0,2-2.41C272.84,408.41,272.18,407.22,270.65,406.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.37,410.63A4.45,4.45,0,0,0,260.9,412a10.74,10.74,0,0,0,9.75,0,4.45,4.45,0,0,0,1.53-1.34,3.19,3.19,0,0,0-1.87-2.57,10,10,0,0,0-9.07,0A3.21,3.21,0,0,0,259.37,410.63Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cactus--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.25,406.08c.14-4.41,4.92-6.17,7.52-6.17s7.39,1.76,7.53,6.17c.13,4.11-3.46,5.66-7.52,5.66S258.12,410.19,258.25,406.08Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.25,406.08c.14-4.41,4.92-6.17,7.52-6.17s7.39,1.76,7.53,6.17c.13,4.11-3.46,5.66-7.52,5.66S258.12,410.19,258.25,406.08Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.25,406.08c.14-4.41,4.92-6.17,7.52-6.17v11.83C261.71,411.74,258.12,410.19,258.25,406.08Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.25,406.08c.14-4.41,4.92-6.17,7.52-6.17v11.83C261.71,411.74,258.12,410.19,258.25,406.08Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.77,399.91c.68,0,1.86,3.69,1.86,5.83s-.69,6-1.85,6c0,0,3.22-.46,3.22-6S265.77,399.91,265.77,399.91Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.77,399.91c2,0,4.9,2.24,4.9,5.5s-2.49,6.33-4.64,6.33a6,6,0,0,0,6.09-6.29C272.12,401.77,268.12,399.91,265.77,399.91Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.77,399.91c-.67,0-1.86,3.69-1.86,5.83s.7,6,1.87,6c0,0-3.24-.46-3.24-6S265.77,399.91,265.77,399.91Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.77,399.91c-.67,0-1.86,3.69-1.86,5.83s.7,6,1.87,6c0,0-3.24-.46-3.24-6S265.77,399.91,265.77,399.91Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.77,399.91c-1.95,0-4.9,2.24-4.9,5.5s2.5,6.33,4.65,6.33a6,6,0,0,1-6.09-6.29C259.43,401.77,263.43,399.91,265.77,399.91Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.77,399.91c-1.95,0-4.9,2.24-4.9,5.5s2.5,6.33,4.65,6.33a6,6,0,0,1-6.09-6.29C259.43,401.77,263.43,399.91,265.77,399.91Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.67,410.21v.1a.11.11,0,0,0,.11.1.11.11,0,0,0,.1-.1v-.1a.11.11,0,0,0-.1-.11A.11.11,0,0,0,265.67,410.21Zm0-1.38a.1.1,0,0,0,.1.1.1.1,0,0,0,.11-.1v-.1a.1.1,0,0,0-.11-.1.1.1,0,0,0-.1.1Zm0-7.39a.11.11,0,0,0,.1.11.11.11,0,0,0,.11-.11v-.1a.1.1,0,0,0-.11-.1.1.1,0,0,0-.1.1Zm0,1.48a.1.1,0,0,0,.1.1.1.1,0,0,0,.11-.1v-.1a.1.1,0,0,0-.11-.1.1.1,0,0,0-.1.1Zm0,4.43a.11.11,0,0,0,.1.11.11.11,0,0,0,.11-.11v-.1a.1.1,0,0,0-.11-.1.1.1,0,0,0-.1.1Zm0-3a.11.11,0,0,0,.1.1.11.11,0,0,0,.11-.1v-.1a.11.11,0,0,0-.11-.11.11.11,0,0,0-.1.11Zm0,1.47a.11.11,0,0,0,.1.11.11.11,0,0,0,.11-.11v-.1a.11.11,0,0,0-.11-.1.11.11,0,0,0-.1.1Zm3.42-.83v-.11a.1.1,0,0,0-.11-.1c-.05,0-.1.06-.09.11v.11a.1.1,0,0,0,.11.1h0A.1.1,0,0,0,269.09,405Zm-1,4.68a.11.11,0,0,0,0,.15h.05a.11.11,0,0,0,.09-.06l.05-.09a.1.1,0,0,0-.18-.1A.41.41,0,0,0,268.07,409.72Zm.66-6.48a.1.1,0,0,0-.08.12l0,.1a.11.11,0,0,0,.1.09h0a.1.1,0,0,0,.08-.12l0-.11A.09.09,0,0,0,268.73,403.24Zm.15,3.31v.11s0,.1.09.11h0a.11.11,0,0,0,.11-.1v-.11c0-.05,0-.1-.09-.11A.1.1,0,0,0,268.88,406.55Zm-1.61-5.81a.11.11,0,0,0,.08,0,.12.12,0,0,0,0-.15l-.09-.07a.11.11,0,0,0-.15,0,.12.12,0,0,0,0,.15l.08.07Zm1,1.27a.11.11,0,0,0,0-.14l0-.1a.1.1,0,0,0-.14,0,.11.11,0,0,0,0,.14.41.41,0,0,1,0,.09.11.11,0,0,0,.1.06Zm.44,6.36a.1.1,0,0,0,.1-.08l0-.11a.09.09,0,0,0-.07-.12.11.11,0,0,0-.13.07l0,.11a.09.09,0,0,0,.07.12Zm-2.19-7.19,0,.1a.11.11,0,0,0,.1.06h0a.1.1,0,0,0,.06-.14l0-.1a.1.1,0,0,0-.13-.06A.11.11,0,0,0,266.54,401.18Zm.5,1.51,0,.1a.11.11,0,0,0,.1.08h0a.1.1,0,0,0,.07-.13l0-.1a.11.11,0,0,0-.21.05Zm-.36,7.93a.1.1,0,0,0,.05.13h0a.1.1,0,0,0,.1-.06l0-.1a.1.1,0,1,0-.19-.08Zm.93-6.3,0-.11a.1.1,0,1,0-.2,0l0,.1a.1.1,0,0,0,.1.09h0A.1.1,0,0,0,267.61,404.32Zm.13,1.62v-.11a.12.12,0,0,0-.11-.11.11.11,0,0,0-.1.11v.1a.1.1,0,0,0,.1.11h0A.11.11,0,0,0,267.74,405.94Zm-.32,1.48v.1a.1.1,0,0,0,.09.12h0a.12.12,0,0,0,.11-.09v-.11c0-.05,0-.11-.09-.11A.1.1,0,0,0,267.42,407.42Zm-.13,1.49a.11.11,0,0,0-.13.08l0,.11a.1.1,0,0,0,.08.12h0a.11.11,0,0,0,.1-.09l0-.1A.12.12,0,0,0,267.29,408.91Zm1.69-8.13a.11.11,0,0,0-.05-.14l-.1-.05a.1.1,0,0,0-.14,0,.11.11,0,0,0,.05.14l.1.05h0A.12.12,0,0,0,269,400.78Zm2.21,8a.11.11,0,0,0,0,.15h.06a.12.12,0,0,0,.09-.05.47.47,0,0,1,.05-.1.1.1,0,0,0,0-.14.1.1,0,0,0-.14,0A.41.41,0,0,0,271.19,408.75Zm-3.69-8.57a.1.1,0,0,0-.07-.13l-.1,0a.11.11,0,0,0-.13.08v0a.1.1,0,0,0-.11.06.11.11,0,0,0,.06.14l.09,0h0a.1.1,0,0,0,.09-.07.13.13,0,0,0,0-.06h0A.1.1,0,0,0,267.5,400.18Zm4.56,4,0-.1a.12.12,0,0,0-.13-.08.1.1,0,0,0-.07.13l0,.1a.1.1,0,0,0,.1.08h0A.12.12,0,0,0,272.06,404.17ZM270.24,410a.11.11,0,0,0,0,.15.1.1,0,0,0,.14,0l.08-.08a.11.11,0,0,0-.15-.15Zm1.77-4.33v.11a.1.1,0,0,0,.1.1h0a.1.1,0,0,0,.11-.1v-.1a.1.1,0,0,0-.1-.11A.11.11,0,0,0,272,405.66Zm-.23,1.65a.11.11,0,0,0,.07.13h0a.11.11,0,0,0,.1-.07l0-.11a.1.1,0,0,0-.08-.12.1.1,0,0,0-.13.07Zm-.61-4.72a.11.11,0,0,0,0,.15l.06.08a.11.11,0,0,0,.09.05l.06,0a.11.11,0,0,0,0-.15l-.06-.09A.11.11,0,0,0,271.17,402.59Zm-2.23,8.46a.11.11,0,0,0,.1.06h0l.09-.06a.1.1,0,0,0,0-.14.1.1,0,0,0-.14,0l-.09.05A.11.11,0,0,0,268.94,411.05Zm1.11-9.59a.11.11,0,0,0,0,.15l.09.07.06,0a.09.09,0,0,0,.08,0,.1.1,0,0,0,0-.14l-.08-.07A.11.11,0,0,0,270.05,401.46Zm-4.12-1.54h0a.1.1,0,0,0-.1-.08h-.11a.1.1,0,0,0-.1.08h0a.1.1,0,0,0,0,.05h0a.08.08,0,0,0,.08.06h0a.1.1,0,0,0,.09-.06h0a.05.05,0,0,0,0-.05h0Zm4.18,7.94a.1.1,0,0,0,.06.13h0a.09.09,0,0,0,.09-.07l0-.09a.11.11,0,0,0-.06-.14.12.12,0,0,0-.14.07Zm.3-4.42,0-.09a.1.1,0,0,0-.14-.06.09.09,0,0,0-.05.13l0,.1a.11.11,0,0,0,.1.06h0A.12.12,0,0,0,270.41,403.44Zm-1,5.75a.11.11,0,0,0,0,.14.07.07,0,0,0,.06,0,.12.12,0,0,0,.09-.05l.05-.09a.1.1,0,0,0,0-.14.11.11,0,0,0-.15,0Zm1.21-4.15a.1.1,0,0,0,.1-.11v-.1a.1.1,0,0,0-.12-.09.09.09,0,0,0-.09.11v.1a.1.1,0,0,0,.1.09Zm-.17,1.39a.11.11,0,0,0,.09.12h0a.1.1,0,0,0,.1-.09l0-.1a.1.1,0,0,0-.09-.12.11.11,0,0,0-.12.09Zm-1.95,3.93a.11.11,0,0,0,.07.18.12.12,0,0,0,.08,0l.07-.07a.1.1,0,1,0-.15-.14Zm-1.21,1a.12.12,0,0,0,.09.05h.05l.09-.05a.1.1,0,1,0-.1-.18l-.09.05A.11.11,0,0,0,267.33,411.4Zm1.06-10.46a.11.11,0,0,0,0,.15l.07.06a.11.11,0,0,0,.07,0,.12.12,0,0,0,.08,0,.11.11,0,0,0,0-.15l-.08-.06A.11.11,0,0,0,268.39,400.94Zm1.07,1.06a.11.11,0,0,0,0,.15l.06.07a.1.1,0,0,0,.08,0l.07,0a.12.12,0,0,0,0-.15l-.06-.08A.1.1,0,0,0,269.46,402Zm-6.79,1.42a.1.1,0,0,0,.08.12h0a.11.11,0,0,0,.1-.09l0-.1a.11.11,0,0,0-.08-.12.11.11,0,0,0-.13.07S262.68,403.38,262.67,403.42Zm-.1,1.42a.1.1,0,0,0-.11.09V405a.1.1,0,0,0,.1.11h0a.11.11,0,0,0,.11-.1V405A.1.1,0,0,0,262.57,404.84Zm.12,3.34,0,.11a.1.1,0,0,0,.1.08h0a.1.1,0,0,0,.08-.13l0-.1a.11.11,0,0,0-.13-.08A.1.1,0,0,0,262.69,408.18Zm1.74-7.53a.11.11,0,0,0,0-.15.1.1,0,0,0-.14,0l-.09.07a.11.11,0,0,0,0,.15.11.11,0,0,0,.08,0l.07,0A.27.27,0,0,1,264.43,400.65Zm-1.85,6.12a.1.1,0,0,0,.1-.11v-.11a.1.1,0,0,0-.11-.1.12.12,0,0,0-.1.11v.11a.11.11,0,0,0,.11.1Zm.67,3,.05.1a.11.11,0,0,0,.09.05h.05a.1.1,0,0,0,0-.14.47.47,0,0,0-.05-.1.1.1,0,1,0-.18.1Zm0-7.86a.1.1,0,0,0,0,.14h.05a.09.09,0,0,0,.09-.06.41.41,0,0,0,.05-.09.1.1,0,0,0-.18-.1S263.23,401.84,263.21,401.87Zm1.43,8.73,0,.1a.1.1,0,0,0,.09.06h.05a.1.1,0,0,0,.05-.13l0-.1a.1.1,0,1,0-.19.08Zm.23-9.26a.11.11,0,0,0,.1-.06l0-.1a.11.11,0,0,0-.2-.08l0,.1a.11.11,0,0,0,.06.14Zm-.95,4.7a.1.1,0,0,0,.1-.11v-.1h-.21v.11a.1.1,0,0,0,.11.1Zm.56-3.25,0-.1a.1.1,0,0,0-.07-.13.11.11,0,0,0-.13.08l0,.1a.11.11,0,0,0,.08.13h0A.12.12,0,0,0,264.48,402.79Zm-.41,1.34a.11.11,0,0,0-.12.08v.11a.1.1,0,0,0,.08.12h0a.11.11,0,0,0,.1-.09l0-.1A.1.1,0,0,0,264.07,404.13Zm.11,4.91,0,.1a.11.11,0,0,0,.1.09h0a.1.1,0,0,0,.08-.12l0-.1a.11.11,0,0,0-.21,0Zm-.17-1.71a.1.1,0,0,0-.09.11v.11a.11.11,0,0,0,.11.09h0a.1.1,0,0,0,.09-.11v-.11A.1.1,0,0,0,264,407.33Zm-4.29-3.21a.11.11,0,0,0-.07-.13.11.11,0,0,0-.13.08l0,.1a.12.12,0,0,0,.07.13h0a.1.1,0,0,0,.1-.08Zm3.13-3.48a.1.1,0,0,0-.14-.05l-.09.05a.11.11,0,0,0-.05.14.12.12,0,0,0,.09.05h0l.09-.05A.09.09,0,0,0,262.85,400.64Zm-2.5,2.18.06-.08a.11.11,0,0,0,0-.15.11.11,0,0,0-.14,0l-.07.09a.11.11,0,0,0,0,.15l.06,0A.12.12,0,0,0,260.35,402.82Zm-.22,5.94.05.1a.12.12,0,0,0,.09.05h.05a.11.11,0,0,0,0-.15.41.41,0,0,0-.05-.09.11.11,0,0,0-.14,0A.1.1,0,0,0,260.13,408.76Zm1,1.15a.11.11,0,0,0,0,.15l.08.08a.1.1,0,0,0,.14,0,.11.11,0,0,0,0-.15.46.46,0,0,0-.07-.07A.1.1,0,0,0,261.09,409.91Zm-1.55-2.65,0,.11a.1.1,0,0,0,.1.07h0a.1.1,0,0,0,.07-.13l0-.1a.09.09,0,0,0-.12-.07A.1.1,0,0,0,259.54,407.26Zm-.21-1.59v.1a.11.11,0,0,0,.1.11h0a.11.11,0,0,0,.1-.1v-.11a.1.1,0,0,0-.1-.1A.1.1,0,0,0,259.33,405.67Zm2.07-4,.08-.07a.11.11,0,0,0,0-.15.11.11,0,0,0-.15,0l-.08.07a.1.1,0,0,0,0,.14.09.09,0,0,0,.08,0Zm.93,9.22a.1.1,0,0,0,0,.14l.09.06h.05a.11.11,0,0,0,.1-.06.11.11,0,0,0-.05-.14l-.09-.05A.1.1,0,0,0,262.33,410.9Zm.46-.62a.11.11,0,0,0,0,.15l.07.07a.09.09,0,0,0,.08,0,.11.11,0,0,0,.07-.18l-.07-.07A.11.11,0,0,0,262.79,410.28Zm-.92-1.06.05.08a.11.11,0,0,0,.09.05h.05a.12.12,0,0,0,0-.15l-.05-.08a.11.11,0,0,0-.15,0A.11.11,0,0,0,261.87,409.22Zm1.13-8a.09.09,0,0,0,.06,0l.08-.06a.12.12,0,0,0,0-.15.11.11,0,0,0-.15,0l-.08.06a.11.11,0,0,0,0,.15A.12.12,0,0,0,263,401.18ZM261.34,408h0a.12.12,0,0,0,.06-.14l0-.09a.09.09,0,0,0-.13-.06.1.1,0,0,0-.06.13l0,.09A.1.1,0,0,0,261.34,408Zm2.74,3.44h.05a.12.12,0,0,0,.09-.05.1.1,0,0,0,0-.14l-.09-.05a.1.1,0,0,0-.1.18Zm-2.9-8.09,0,.09a.12.12,0,0,0,.06.14h0a.09.09,0,0,0,.09-.06l0-.09a.1.1,0,0,0-.06-.14A.1.1,0,0,0,261.18,403.35Zm-.38,1.48v.1a.1.1,0,0,0,.1.11h0a.12.12,0,0,0,.1-.1v-.1a.1.1,0,0,0-.09-.11A.1.1,0,0,0,260.8,404.83Zm3.66-4.64a.11.11,0,0,0-.11-.06v0a.11.11,0,0,0-.13-.08l-.1,0a.11.11,0,0,0-.08.13.11.11,0,0,0,.1.08h0s0,0,0,.06a.12.12,0,0,0,.1.07h0l.09,0A.12.12,0,0,0,264.46,400.19Zm-2.35,2a.12.12,0,0,0,0-.15.11.11,0,0,0-.15,0l-.06.08a.1.1,0,0,0,0,.15l.06,0a.12.12,0,0,0,.09,0Zm-1.27,4.21v.1a.12.12,0,0,0,.11.09h0a.11.11,0,0,0,.09-.12l0-.1a.09.09,0,0,0-.11-.09A.1.1,0,0,0,260.84,406.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.61,401c.34.58,2.57,1.05,3.52.54s-1.26-1.1-1.26-1.1,1.91-.24,1.62-.89-2.17-.22-2.42.05c0,0,1.42-1.58,1-2S267.79,399.67,267.61,401Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.61,401c-.63.2-2.61-.93-3-1.94s1.67,0,1.67,0-1.25-1.46-.6-1.75,1.76,1.29,1.76,1.65c0,0,0-2.12.59-2.2S268.34,399.88,267.61,401Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.61,401c.69.33,2.94-1.69,2.73-2.16s-1.37-.14-1.72.41c0,0,1-1.67.41-2s-1,1.78-1,1.78-.17-1.39-.75-1.32S266.7,400.52,267.61,401Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.82,401.38l-.05,0-.14-.1-.07-.05-.06-.05-.07,0a2.91,2.91,0,0,1-.65.06l-.33,0h-.06a.9.9,0,0,1-.28-.08,2,2,0,0,1-.62-.35c-.15-.13-.3-.33-.23-.52a.45.45,0,0,1,.23-.22,1.08,1.08,0,0,1,.88-.08.64.64,0,0,1,.88-.68.78.78,0,0,1,.39.41,2.07,2.07,0,0,1,.17.55,1.23,1.23,0,0,1,1,0,.38.38,0,0,1,.14.11.23.23,0,0,1,0,.24.52.52,0,0,1-.18.18.83.83,0,0,1,.45.35.41.41,0,0,1,0,.5.38.38,0,0,1-.2.1,1.14,1.14,0,0,1-.58,0,.92.92,0,0,1-.27-.08.8.8,0,0,1-.24-.13l-.05-.08Z",
    style: {
      fill: "#37474f"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--table-1--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--table--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--table--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.75,399.54a2.37,2.37,0,0,0-2.11,0,.75.75,0,0,0-.44.61l.44,37.59h0a.56.56,0,0,0,.31.42,1.63,1.63,0,0,0,1.49,0,.52.52,0,0,0,.3-.42h0l.43-37.59A.74.74,0,0,0,73.75,399.54Zm-21.63-2.65a2.31,2.31,0,0,0-2.11,0,.64.64,0,0,0-.35.61l-3.91,31.65h0a.66.66,0,0,0,.37.42,1.63,1.63,0,0,0,1.49,0,.44.44,0,0,0,.24-.42h0l4.78-31.65A.9.9,0,0,0,52.12,396.89Zm43.15.61a.63.63,0,0,0-.35-.61,2.31,2.31,0,0,0-2.11,0,.9.9,0,0,0-.52.61l5.79,31.65h0a.44.44,0,0,0,.25.42,1.63,1.63,0,0,0,1.49,0,.64.64,0,0,0,.36-.42h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,385.75h0c0-4.93-3.22-9.86-9.74-13.62-13-7.51-34.13-7.51-47.16,0-6.51,3.76-9.74,8.69-9.73,13.62h0v2.64h0c.07,4.87,3.34,9.71,9.76,13.43,13,7.51,34.14,7.51,47.16,0,6.43-3.71,9.69-8.56,9.77-13.43h0Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,385.75h0c0-4.93-3.22-9.86-9.74-13.62-13-7.51-34.13-7.51-47.16,0-6.51,3.76-9.74,8.69-9.73,13.62h0v2.64h0c.07,4.87,3.34,9.71,9.76,13.43,13,7.51,34.14,7.51,47.16,0,6.43-3.71,9.69-8.56,9.77-13.43h0Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.11,372.13c-13,7.52-13,19.71,0,27.23s34.14,7.52,47.16,0,13-19.71,0-27.23S62.14,364.62,49.11,372.13Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.11,372.13c-13,7.52-13,19.71,0,27.23s34.14,7.52,47.16,0,13-19.71,0-27.23S62.14,364.62,49.11,372.13Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.78,379.41c3.66,2.11,3.66,5.53,0,7.64a14.66,14.66,0,0,1-13.22,0c-3.65-2.11-3.65-5.53,0-7.64A14.6,14.6,0,0,1,63.78,379.41Z",
    style: {
      fill: "#0B1D51"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.36,383.7c-3.18-3.25-5-11.35-2-13.92H65.19c3.1,2.57,1.24,10.67-1.94,13.92l-.09.09-.11.1a3.45,3.45,0,0,1-.28.26l-.08.06-.24.18a3.1,3.1,0,0,1-.41.26,10.46,10.46,0,0,1-9.47,0h0l-.42-.26-.22-.17-.1-.08-.27-.24-.13-.13A.46.46,0,0,1,51.36,383.7Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.82,368.74c3.6,2.08,3.6,5.45,0,7.53a14.41,14.41,0,0,1-13,0c-3.6-2.08-3.6-5.45,0-7.53A14.41,14.41,0,0,1,63.82,368.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.27,370.22c2.19,1.26,2.19,3.31,0,4.58a8.79,8.79,0,0,1-7.93,0c-2.19-1.27-2.19-3.32,0-4.58A8.73,8.73,0,0,1,61.27,370.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.34,372.39a8.79,8.79,0,0,1,7.93,0,3.59,3.59,0,0,1,1.31,1.2,3.61,3.61,0,0,1-1.31,1.21,8.79,8.79,0,0,1-7.93,0A3.64,3.64,0,0,1,52,373.59,3.63,3.63,0,0,1,53.34,372.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.79,373.59a18.17,18.17,0,0,0,2.87-3.81c1.32-2.34,2.45-5.32,1.77-5.71s-4.36,2.58-4.36,2.58a16.88,16.88,0,0,0,.29-4c-.12-2.08-.63-4-1.22-4.36s-1.94,2.25-2.51,4.16-.8,3.09-.8,3.09-.51-2.2-1.15-4c-.69-2-1.32-2.43-1.81-2.23s-.81,1.12-1,3.76a26,26,0,0,0,.12,3.77s-1-1.08-2.07-2.13-2.05-1.15-2.39-.93-.1,1.85,1.75,5.21a18.75,18.75,0,0,0,3.51,4.61S56.4,375.25,60.79,373.59Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.79,373.59a18.17,18.17,0,0,0,2.87-3.81c1.32-2.34,2.45-5.32,1.77-5.71s-4.36,2.58-4.36,2.58a16.88,16.88,0,0,0,.29-4c-.12-2.08-.63-4-1.22-4.36s-1.94,2.25-2.51,4.16-.8,3.09-.8,3.09-.51-2.2-1.15-4c-.69-2-1.32-2.43-1.81-2.23s-.81,1.12-1,3.76a26,26,0,0,0,.12,3.77s-1-1.08-2.07-2.13-2.05-1.15-2.39-.93-.1,1.85,1.75,5.21a18.75,18.75,0,0,0,3.51,4.61S56.4,375.25,60.79,373.59Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M57.63,362.45c-.57,1.9-.8,3.09-.8,3.09h0l.34,1.64s.36-3.59.87-5.9C57.88,361.68,57.74,362.07,57.63,362.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.66,365.32a23.89,23.89,0,0,1-.51-4.57,20.69,20.69,0,0,0-.24,2.31,26,26,0,0,0,.12,3.77l2.54,2.66A22.66,22.66,0,0,1,53.66,365.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.47,368.21l1.6-1.56h0a16.88,16.88,0,0,0,.29-4,14.64,14.64,0,0,0-.32-2.36,11.46,11.46,0,0,1-.19,3.84A36.32,36.32,0,0,1,59.47,368.21Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-49",
    d: "M96.6,384.05c-5.42-3.14-14.22-3.14-19.64,0s-5.43,8.21,0,11.34,14.22,3.13,19.64,0S102,387.18,96.6,384.05Z",
    style: {
      fill: "#0B1D51",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mug--inject-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plate--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.22,383c-5.21-3-13.67-3-18.88,0-2.6,1.5-3.91,3.47-3.91,5.45V389c0,2,1.31,3.94,3.91,5.45,5.22,3,13.67,3,18.88,0,2.61-1.51,3.91-3.48,3.91-5.45v-.56C100.13,386.46,98.83,384.48,96.22,383Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.35,395.7V381.16a16.5,16.5,0,0,0-5,1.82c-2.6,1.5-3.91,3.47-3.91,5.45V389c0,2,1.31,3.94,3.91,5.45a17.52,17.52,0,0,0,6.12,2C82.41,396.27,82.35,395.7,82.35,395.7Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.22,383c-5.21-3-13.67-3-18.88,0s-5.21,7.89,0,10.9,13.67,3,18.88,0S101.43,386,96.22,383Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.69,384.72a15.23,15.23,0,0,0-13.82,0c-3.82,2.2-3.82,5.77,0,8a15.29,15.29,0,0,0,13.82,0C97.51,390.49,97.51,386.92,93.69,384.72Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.84,385.59a13.41,13.41,0,0,0-12.12,0c-3.34,1.93-3.34,5.06,0,7a13.41,13.41,0,0,0,12.12,0C96.18,390.65,96.18,387.52,92.84,385.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.26,393.43a16,16,0,0,0,3.51,1.33,21,21,0,0,0,3.69.59,24.58,24.58,0,0,0,3.74,0,21.89,21.89,0,0,0,3.68-.6,16.8,16.8,0,0,0,3.49-1.28,9.54,9.54,0,0,0,2.92-2.23,5.46,5.46,0,0,0,.94-1.57,4.14,4.14,0,0,0,.27-1.81,4.42,4.42,0,0,0-.49-1.77,8.15,8.15,0,0,0-.49-.8q-.28-.37-.6-.72c.22.22.44.45.64.69a6.7,6.7,0,0,1,.53.78,4.82,4.82,0,0,1,.59,1.81,4.5,4.5,0,0,1-.23,1.89,5.62,5.62,0,0,1-.94,1.67,7.9,7.9,0,0,1-1.38,1.33,11.8,11.8,0,0,1-1.61,1A16.25,16.25,0,0,1,92,395.08a22.4,22.4,0,0,1-7.52.54,20.34,20.34,0,0,1-3.72-.7,16.43,16.43,0,0,1-1.78-.64A12,12,0,0,1,77.26,393.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.59,385.74a10.65,10.65,0,0,0-9.62,0c-2.65,1.53-2.65,4,0,5.55a10.59,10.59,0,0,0,9.62,0C94.24,389.76,94.24,387.27,91.59,385.74Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--mug--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73,382.76c0,2.05,2,3.1,3.49,3.74a11.46,11.46,0,0,1,2.59,1.13c0-.29-1.36-7.23-1.36-7.23a3.19,3.19,0,0,0-1.82-.48,2.53,2.53,0,0,0-1.12.31l-.7.41A2.25,2.25,0,0,0,73,382.76Zm2-.41a1.22,1.22,0,0,1,.3-.79.85.85,0,0,1,.23,0,2.08,2.08,0,0,1,1.49.58,20.63,20.63,0,0,1,.82,2.95l-.2-.08C75.74,384.18,75,383.37,75,382.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,382.76c0,2.05,2,3.1,3.49,3.74a11.46,11.46,0,0,1,2.59,1.13A40.29,40.29,0,0,0,77,380.8a3.29,3.29,0,0,0-1.83-.47A2.21,2.21,0,0,0,73,382.76Zm1.32,0a1.23,1.23,0,0,1,1.23-1.23,2.08,2.08,0,0,1,1.49.58,17,17,0,0,1,.91,3.65c-.32-.11-.63-.22-1-.37C75,384.59,74.3,383.78,74.3,382.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.82,385.34A10.54,10.54,0,0,0,77.7,387a4.21,4.21,0,0,1,1.36.67A40.29,40.29,0,0,0,77,380.8a3.38,3.38,0,0,0-1-.39v1a.53.53,0,0,0,0,.13,2.23,2.23,0,0,1,1,.53,17,17,0,0,1,.91,3.65c-.32-.11-.63-.22-1-.37Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.84,379.42c0-1.47-1-2.93-2.9-4.05a15.49,15.49,0,0,0-14,0C78,376.49,77,378,77,379.42h0v2.15a9.92,9.92,0,0,0,9.92,9.92h0a9.92,9.92,0,0,0,9.92-9.92v-2.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.92,373.78a14.09,14.09,0,0,1,7,1.67c1.85,1.06,2.86,2.47,2.86,4v2.15a9.83,9.83,0,0,1-19.66,0v-2.15c0-1.5,1-2.91,2.86-4a14.12,14.12,0,0,1,7-1.67m0-.09a14.28,14.28,0,0,0-7,1.68C78,376.49,77,378,77,379.42v2.15a9.92,9.92,0,0,0,9.92,9.92h0a9.92,9.92,0,0,0,9.92-9.92v-2.15c0-1.47-1-2.93-2.9-4.05a14.35,14.35,0,0,0-7-1.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.94,375.37a15.49,15.49,0,0,0-14,0c-3.88,2.24-3.88,5.86,0,8.1a15.49,15.49,0,0,0,14,0C97.81,381.23,97.81,377.61,93.94,375.37ZM93.63,383a15,15,0,0,1-13.42,0c-1.68-1-2.6-2.22-2.6-3.53s.92-2.56,2.6-3.53a15,15,0,0,1,13.42,0c1.68,1,2.61,2.23,2.61,3.53S95.31,382,93.63,383Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.63,375.89a15,15,0,0,0-13.42,0c-1.68,1-2.6,2.22-2.6,3.53a2.76,2.76,0,0,0,.22,1.09,5.26,5.26,0,0,1,2.38-2.43,14.87,14.87,0,0,1,13.42,0A5.28,5.28,0,0,1,96,380.51a3,3,0,0,0,.22-1.09C96.24,378.12,95.31,376.86,93.63,375.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.92,374.3a13.64,13.64,0,0,0-6.71,1.59c-1.68,1-2.6,2.22-2.6,3.53a2.76,2.76,0,0,0,.22,1.09,5.26,5.26,0,0,1,2.38-2.43,13.64,13.64,0,0,1,6.71-1.6h.48c-.62,0-1.91-.32-1.47-1.16a2.5,2.5,0,0,1,2.45-1C87.9,374.32,87.41,374.3,86.92,374.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.24,379.42a4.06,4.06,0,0,0-2-3.18c.62.73.27,2-1.07,1.56h0a5.21,5.21,0,0,1,.52.28A5.28,5.28,0,0,1,96,380.51,3,3,0,0,0,96.24,379.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.63,378.08a14.87,14.87,0,0,0-13.42,0,5.26,5.26,0,0,0-2.38,2.43A5.32,5.32,0,0,0,80.21,383a15,15,0,0,0,13.42,0A5.35,5.35,0,0,0,96,380.51,5.28,5.28,0,0,0,93.63,378.08Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.63,378.08a14.87,14.87,0,0,0-13.42,0,5.26,5.26,0,0,0-2.38,2.43A5.32,5.32,0,0,0,80.21,383a15,15,0,0,0,13.42,0A5.35,5.35,0,0,0,96,380.51,5.28,5.28,0,0,0,93.63,378.08Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.21,378.08a5.26,5.26,0,0,0-2.38,2.43A5.32,5.32,0,0,0,80.21,383,12.58,12.58,0,0,0,85,384.42a9.25,9.25,0,0,0-1.83-1c-.21,0-.4-.1-.61-.16a1.6,1.6,0,0,1-.86-.48.86.86,0,0,1-.17-.84,1.12,1.12,0,0,1,.38-.43c.54-.4,1.24-.55,1.81-.92a.67.67,0,0,0,.34-.38.62.62,0,0,0-.13-.54c-.11-.16-.26-.28-.38-.44a.69.69,0,0,1-.16-.53.63.63,0,0,1,.19-.31,2.68,2.68,0,0,1,1.23-.46.9.9,0,0,0,.59-.43c.13-.22,0-.49.11-.7a.79.79,0,0,1,.3-.3A13,13,0,0,0,80.21,378.08Zm-.1,2.91a.2.2,0,0,1-.15,0,0,0,0,0,1,0-.08.14.14,0,0,1,.15,0A0,0,0,0,1,80.11,381Zm.93,1.35a.53.53,0,0,1-.46,0c-.13-.08-.13-.19,0-.27a.53.53,0,0,1,.46,0C81.17,382.15,81.17,382.26,81,382.34Zm.2-.6a.2.2,0,0,1-.15,0s0-.06,0-.09a.2.2,0,0,1,.15,0S81.28,381.71,81.24,381.74Zm.09-1a.85.85,0,0,1-.73,0c-.2-.12-.2-.31,0-.42a.79.79,0,0,1,.73,0C81.53,380.45,81.53,380.64,81.33,380.76Zm1.54-2.39a.33.33,0,0,1,.24,0,.08.08,0,0,1,0,.14.26.26,0,0,1-.24,0A.08.08,0,0,1,82.87,378.37Zm-1.06.85c-.2-.12-.2-.31,0-.42a.76.76,0,0,1,.72,0c.21.11.21.3,0,.42A.83.83,0,0,1,81.81,379.22Zm.48,1.59a.33.33,0,0,1-.24,0,.08.08,0,0,1,0-.14.25.25,0,0,1,.24,0A.08.08,0,0,1,82.29,380.81Zm1-1c.23.13.23.34,0,.48a.93.93,0,0,1-.83,0c-.23-.14-.23-.35,0-.48A.87.87,0,0,1,83.34,379.77Zm.76-2a.14.14,0,0,1-.15,0,0,0,0,0,1,0-.08.14.14,0,0,1,.15,0A0,0,0,0,1,84.1,377.79Z",
    style: {
      fill: "#0B1D51",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.63,378.08a8.36,8.36,0,0,0-1.31-.63,1.65,1.65,0,0,0-.36.11.62.62,0,0,0-.33.24c-.18.28,0,.64.28.87a6.41,6.41,0,0,0,1.18.89,2.5,2.5,0,0,1,.63.48.72.72,0,0,1,.14.74,1.42,1.42,0,0,1-.4.41.61.61,0,0,0-.24.5.9.9,0,0,0,.25.37.41.41,0,0,1,.11.4c0,.14-.22.18-.37.2a12.71,12.71,0,0,0-1.63.19,1.06,1.06,0,0,0-.53.31c-.11.15-.16.34-.28.48-.27.31-.76.24-1.17.26a4,4,0,0,0-1.51.5l-.23.12A13.12,13.12,0,0,0,93.63,383,5.35,5.35,0,0,0,96,380.51,5.28,5.28,0,0,0,93.63,378.08Zm-.75.3a.79.79,0,0,1-.73,0c-.2-.11-.2-.3,0-.42a.85.85,0,0,1,.73,0C93.08,378.08,93.08,378.27,92.88,378.38Zm.61.6a.47.47,0,0,1-.4,0,.12.12,0,0,1,0-.23.47.47,0,0,1,.4,0A.12.12,0,0,1,93.49,379ZM92,383.43a.51.51,0,0,1-.45,0,.14.14,0,0,1,0-.26.51.51,0,0,1,.45,0C92.12,383.24,92.12,383.36,92,383.43Zm.55-.24a.3.3,0,0,1-.26,0,.08.08,0,0,1,0-.15.3.3,0,0,1,.26,0A.08.08,0,0,1,92.54,383.19Zm1.88-2.48a.26.26,0,0,1,.21,0,.06.06,0,0,1,0,.12.2.2,0,0,1-.21,0A.06.06,0,0,1,94.42,380.71Zm.31,1.2a1.06,1.06,0,0,1-1,0c-.27-.15-.27-.4,0-.55a1.06,1.06,0,0,1,1,0A.29.29,0,0,1,94.73,381.91Zm.33-1.76a.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3.59.59,0,0,1,.52,0C95.21,379.93,95.21,380.07,95.06,380.15Zm.55.16a.26.26,0,0,1-.21,0c-.06,0-.06-.09,0-.13a.26.26,0,0,1,.21,0C95.67,380.22,95.67,380.27,95.61,380.31Z",
    style: {
      fill: "#0B1D51",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.61,376.53a13,13,0,0,0-5.4,1.55,5.26,5.26,0,0,0-2.38,2.43A5.32,5.32,0,0,0,80.21,383a11.27,11.27,0,0,0,1.44.68,3.29,3.29,0,0,1-2-2.55C79.66,378.83,82.39,376.88,85.61,376.53Z",
    style: {
      opacity: 0.4
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tea-spoon--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-49",
    d: "M88.11,396.93v0h0v0h0s0,0,0,0h0l0,0h0L75.74,390a1.63,1.63,0,0,0,.32-.88.25.25,0,0,0,0-.08h0c0-.4-.31-.83-.95-1.27-1.35-.93-4.45-1.74-5.77-1a.93.93,0,0,0-.49,1.09h0a3.65,3.65,0,0,0,1,1.72h0l.13.13,0,0,.15.15a5.09,5.09,0,0,0,1.19.83,3.52,3.52,0,0,0,.39.16,4,4,0,0,0,.64.17,5.16,5.16,0,0,0,1,.09A3.06,3.06,0,0,0,75,390.7l11.69,7.06c.37.21,1.41-.34,1.41-.65,0,0,0-.15,0-.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tea-spoon--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.4,390.69a2.5,2.5,0,0,0,2.67-2.11l-7.21-1.16a4,4,0,0,0,1.32,2A4.38,4.38,0,0,0,73.4,390.69Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4,390.69a2.5,2.5,0,0,0,2.67-2.11l-7.21-1.16a4,4,0,0,0,1.32,2A4.38,4.38,0,0,0,73.4,390.69Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7,388.75a2.16,2.16,0,0,1-2.39,1.75,5.1,5.1,0,0,1-3.68-1.64,7.24,7.24,0,0,0,.55.58,4.38,4.38,0,0,0,3.22,1.25,2.5,2.5,0,0,0,2.67-2.11l-.37-.06Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.12,387.31c-1.35-.93-4.45-1.74-5.77-1s.09,2.55,1.7,3.33a4.35,4.35,0,0,0,4.15,0C76.29,389.09,76.45,388.23,75.12,387.31Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.78,386.11a8.7,8.7,0,0,1,4.29,1.26c.63.43.94.86.92,1.26s-.3.71-.82,1a3.9,3.9,0,0,1-1.89.48,5,5,0,0,1-2.2-.54c-1.19-.58-2.15-1.63-2.18-2.4a.84.84,0,0,1,.49-.79,2.71,2.71,0,0,1,1.39-.29m0-.08a2.94,2.94,0,0,0-1.43.3c-1.32.76.09,2.55,1.7,3.33a5.11,5.11,0,0,0,2.23.55,3.78,3.78,0,0,0,1.92-.5c1.09-.62,1.25-1.48-.08-2.4A8.86,8.86,0,0,0,70.78,386Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.35,387.5c-1.31-.87-4.06-1.7-5-1.06s.6,2.3,2.1,3.05,2.7.7,3.48.17S75.65,388.37,74.35,387.5Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.88,387.18c-.93-.62-2.88-1.2-3.55-.75s.43,1.63,1.49,2.16a2.45,2.45,0,0,0,2.47.13C73.84,388.34,73.8,387.8,72.88,387.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,396.35l-12.46-6.89a3.35,3.35,0,0,1-.79.46v.18l11.92,7.2c.37.21,1.41-.33,1.41-.64,0,0,0-.16,0-.19A.14.14,0,0,0,88,396.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,396.35l-12.46-6.89a3.35,3.35,0,0,1-.79.46v.18l11.92,7.2c.37.21,1.41-.33,1.41-.64,0,0,0-.16,0-.19A.14.14,0,0,0,88,396.35Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7,397.11c.43.25,1.76-.52,1.33-.76l-12.46-6.89a3.91,3.91,0,0,1-.79.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.65,389.66l11.17,6.14c.85.47,1.37.68.83,1s-.79.2-.79.2a1.45,1.45,0,0,0,.6-.2c.32-.2,0-.48-.58-.77S75.65,389.66,75.65,389.66Z",
    style: {
      fill: "#fafafa"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrmsLogin2);
export default __webpack_public_path__ + "static/media/HRMS-Login-2.040090036cebce1a2801d1e37ee8cfb3.svg";
export { ForwardRef as ReactComponent };